export const mockVtubers = [
  {
    id: "1",
    channelId: "UC_mock_001",
    name: "星宮リン",
    description: "料理配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V001",
    bannerUrl: "https://placehold.co/640x180?text=V001",
    youtubeUrl: "https://www.youtube.com/@example-v001",
    subscriberCount: 1658315,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_pink", approved: false },
      { value: "eye_red", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_glasses", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_soft", approved: true },
      { value: "genre_cooking", approved: false },
      { value: "personality_natural", approved: true },
      { value: "personality_gentle", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_early_morning",
      { value: "stream_frequency_low", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_monday", approved: false },
      { value: "day_tuesday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_001_021",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-08-04T22:00:00+09:00",
        durationSeconds: 1621,
        score: 3958,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_009",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-08-03T19:00:00+09:00",
        durationSeconds: 1227,
        score: 5580,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_001",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T19:00:00+09:00",
        durationSeconds: 2007,
        score: 7644,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_022",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-28T22:00:00+09:00",
        durationSeconds: 1400,
        score: 3476,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-27T23:00:00+09:00",
        durationSeconds: 1967,
        score: 9350,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_023",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-21T21:00:00+09:00",
        durationSeconds: 2265,
        score: 9148,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_011",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 1076,
        score: 9562,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_002",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-18T19:00:00+09:00",
        durationSeconds: 2118,
        score: 4124,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_024",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-14T23:00:00+09:00",
        durationSeconds: 1901,
        score: 2999,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-13T23:00:00+09:00",
        durationSeconds: 2076,
        score: 2583,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_025",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-07T19:00:00+09:00",
        durationSeconds: 1320,
        score: 3731,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_013",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-06T22:00:00+09:00",
        durationSeconds: 1548,
        score: 1922,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_003",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-04T21:00:00+09:00",
        durationSeconds: 1486,
        score: 1707,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_026",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-30T23:00:00+09:00",
        durationSeconds: 1727,
        score: 206,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_014",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-29T20:00:00+09:00",
        durationSeconds: 1266,
        score: 3681,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_004",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-27T19:00:00+09:00",
        durationSeconds: 1661,
        score: 904,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_027",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-23T18:00:00+09:00",
        durationSeconds: 1910,
        score: 9448,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_015",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-22T21:00:00+09:00",
        durationSeconds: 1209,
        score: 3731,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_028",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-16T21:00:00+09:00",
        durationSeconds: 2318,
        score: 4280,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_016",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-15T22:00:00+09:00",
        durationSeconds: 1431,
        score: 3697,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_005",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-13T18:00:00+09:00",
        durationSeconds: 2091,
        score: 5404,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_029",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-09T19:00:00+09:00",
        durationSeconds: 1054,
        score: 6656,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_017",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 909,
        score: 3768,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_006",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-06T19:00:00+09:00",
        durationSeconds: 2174,
        score: 4646,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_030",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-02T21:00:00+09:00",
        durationSeconds: 2373,
        score: 2162,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_018",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-01T18:00:00+09:00",
        durationSeconds: 1980,
        score: 776,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_031",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-26T22:00:00+09:00",
        durationSeconds: 2129,
        score: 9967,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_019",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 2219,
        score: 832,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_007",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-23T18:00:00+09:00",
        durationSeconds: 2031,
        score: 7155,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_032",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-19T18:00:00+09:00",
        durationSeconds: 1369,
        score: 4559,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_020",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-18T22:00:00+09:00",
        durationSeconds: 2235,
        score: 804,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_008",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 1864,
        score: 9435,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_001_033",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 1312,
        score: 4249,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "2",
    channelId: "UC_mock_002",
    name: "天霧ヨル",
    description: "企業勢VTuberとしてお絵描き配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V002",
    bannerUrl: "https://placehold.co/640x180?text=V002",
    youtubeUrl: "https://www.youtube.com/@example-v002",
    subscriberCount: 325677,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_purple", approved: true },
      { value: "eye_blue", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "voice_boyish", approved: true },
      { value: "genre_drawing", approved: false },
      { value: "personality_gentle", approved: true },
      { value: "personality_calm", approved: false },
      { value: "personality_funny", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_tuesday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_002_001",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T23:00:00+09:00",
        durationSeconds: 5354,
        score: 4032,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_002",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T21:00:00+09:00",
        durationSeconds: 6209,
        score: 6169,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_003",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T22:00:00+09:00",
        durationSeconds: 4822,
        score: 3440,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_004",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T18:00:00+09:00",
        durationSeconds: 8246,
        score: 2168,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-07T19:00:00+09:00",
        durationSeconds: 8320,
        score: 5846,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_006",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-30T20:00:00+09:00",
        durationSeconds: 8948,
        score: 3574,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_007",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-23T23:00:00+09:00",
        durationSeconds: 4655,
        score: 5415,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-16T23:00:00+09:00",
        durationSeconds: 9959,
        score: 9359,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_009",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-09T20:00:00+09:00",
        durationSeconds: 4880,
        score: 9159,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_010",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-02T20:00:00+09:00",
        durationSeconds: 9072,
        score: 2152,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-26T19:00:00+09:00",
        durationSeconds: 10606,
        score: 5884,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_012",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-19T19:00:00+09:00",
        durationSeconds: 7529,
        score: 714,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_002_013",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 6395,
        score: 8239,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "3",
    channelId: "UC_mock_003",
    name: "銀河ライデン",
    description: "配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V003",
    bannerUrl: "https://placehold.co/640x180?text=V003",
    youtubeUrl: "https://www.youtube.com/@example-v003",
    subscriberCount: 1324972,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_zh", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_orange", approved: true },
      { value: "eye_red", approved: false },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_cute", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_other", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "personality_natural", approved: true },
      // stream_collab,
      // stream_viewer_partcition,
      // "stream_time_night",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_003_001",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 2454,
        score: 1370,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_013",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-30T23:00:00+09:00",
        durationSeconds: 2982,
        score: 7319,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_012",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-30T19:00:00+09:00",
        durationSeconds: 1236,
        score: 4594,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_002",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-17T18:00:00+09:00",
        durationSeconds: 2450,
        score: 5937,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_014",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-16T19:00:00+09:00",
        durationSeconds: 3557,
        score: 8937,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_003",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 2484,
        score: 3344,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_015",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-09T22:00:00+09:00",
        durationSeconds: 1098,
        score: 5782,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_004",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-03T21:00:00+09:00",
        durationSeconds: 1839,
        score: 7478,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_016",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-02T23:00:00+09:00",
        durationSeconds: 2848,
        score: 8924,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_005",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-26T21:00:00+09:00",
        durationSeconds: 1401,
        score: 4312,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_017",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-25T18:00:00+09:00",
        durationSeconds: 1909,
        score: 2953,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_006",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 1632,
        score: 1133,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_018",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 1148,
        score: 7144,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_007",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-12T18:00:00+09:00",
        durationSeconds: 2096,
        score: 8966,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_019",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-11T20:00:00+09:00",
        durationSeconds: 1298,
        score: 1750,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_008",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-05T23:00:00+09:00",
        durationSeconds: 1428,
        score: 3363,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_020",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-04T22:00:00+09:00",
        durationSeconds: 2100,
        score: 6532,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_009",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-29T22:00:00+09:00",
        durationSeconds: 3193,
        score: 3072,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_021",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-28T20:00:00+09:00",
        durationSeconds: 2257,
        score: 8782,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_010",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-22T18:00:00+09:00",
        durationSeconds: 2519,
        score: 1564,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_003_022",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 1403,
        score: 4692,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_003_011",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-15T18:00:00+09:00",
        durationSeconds: 1869,
        score: 6753,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "4",
    channelId: "UC_mock_004",
    name: "風間ゆき",
    description: "配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V004",
    bannerUrl: "https://placehold.co/640x180?text=V004",
    youtubeUrl: "https://www.youtube.com/@example-v004",
    subscriberCount: 1620560,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: false },
      { value: "model_3d", approved: true },
      { value: "model_live2d", approved: false },
      { value: "hair_white", approved: true },
      { value: "eye_orange", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_cool", approved: true },
      { value: "genre_other", approved: true },
      { value: "personality_serious", approved: true },
      { value: "personality_chaotic", approved: true },
      // "stream_time_evening",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_sunday", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_004_011",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-08-02T18:00:00+09:00",
        durationSeconds: 1872,
        score: 6473,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_020",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-07-30T23:00:00+09:00",
        durationSeconds: 1540,
        score: 8132,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_021",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 1932,
        score: 8471,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_001",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 2293,
        score: 4836,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_012",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-26T23:00:00+09:00",
        durationSeconds: 3537,
        score: 2734,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_022",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-23T18:00:00+09:00",
        durationSeconds: 2200,
        score: 484,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_002",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-20T19:00:00+09:00",
        durationSeconds: 1651,
        score: 9058,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_023",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-16T20:00:00+09:00",
        durationSeconds: 1878,
        score: 8154,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_003",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-13T23:00:00+09:00",
        durationSeconds: 3271,
        score: 6030,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_013",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 2104,
        score: 254,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_024",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-09T18:00:00+09:00",
        durationSeconds: 3015,
        score: 2033,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_004",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T18:00:00+09:00",
        durationSeconds: 1929,
        score: 6743,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_025",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-02T19:00:00+09:00",
        durationSeconds: 1325,
        score: 3449,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_014",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-28T21:00:00+09:00",
        durationSeconds: 2000,
        score: 5977,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_026",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-25T22:00:00+09:00",
        durationSeconds: 2253,
        score: 471,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_005",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-22T20:00:00+09:00",
        durationSeconds: 2653,
        score: 2115,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_027",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-18T22:00:00+09:00",
        durationSeconds: 1262,
        score: 5097,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_006",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-15T18:00:00+09:00",
        durationSeconds: 2052,
        score: 5964,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_015",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-14T20:00:00+09:00",
        durationSeconds: 2531,
        score: 4954,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_028",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-11T20:00:00+09:00",
        durationSeconds: 1113,
        score: 8713,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_007",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-08T21:00:00+09:00",
        durationSeconds: 1219,
        score: 4697,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_016",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-07T21:00:00+09:00",
        durationSeconds: 3467,
        score: 8196,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_008",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-01T23:00:00+09:00",
        durationSeconds: 2326,
        score: 6053,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_017",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-31T22:00:00+09:00",
        durationSeconds: 1957,
        score: 482,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_029",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-28T19:00:00+09:00",
        durationSeconds: 2990,
        score: 9902,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_009",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 3351,
        score: 3490,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_030",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 1117,
        score: 6752,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_010",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T23:00:00+09:00",
        durationSeconds: 2424,
        score: 5246,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_018",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 1757,
        score: 3047,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_031",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-14T20:00:00+09:00",
        durationSeconds: 3351,
        score: 986,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_004_019",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-10T20:00:00+09:00",
        durationSeconds: 2630,
        score: 8834,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "5",
    channelId: "UC_mock_005",
    name: "白鳥リン",
    description: "お絵描き配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V005",
    bannerUrl: "https://placehold.co/640x180?text=V005",
    youtubeUrl: "https://www.youtube.com/@example-v005",
    subscriberCount: 510119,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: false },
      { value: "hair_blonde", approved: true },
      { value: "eye_heterochromia", approved: false },
      { value: "hair_length_medium", approved: true },
      { value: "voice_pitch_middle", approved: false },
      { value: "voice_soft", approved: true },
      { value: "voice_cute", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_serious", approved: true },
      // "stream_time_early_morning",
      { value: "stream_frequency_low", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_005_001",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T19:00:00+09:00",
        durationSeconds: 2771,
        score: 2748,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_002",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T18:00:00+09:00",
        durationSeconds: 9089,
        score: 4175,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_012",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-29T18:00:00+09:00",
        durationSeconds: 2262,
        score: 6304,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_022",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 2166,
        score: 6841,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_023",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 10226,
        score: 1268,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-18T19:00:00+09:00",
        durationSeconds: 7299,
        score: 6995,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_013",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-15T22:00:00+09:00",
        durationSeconds: 2704,
        score: 3042,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_024",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-13T18:00:00+09:00",
        durationSeconds: 5373,
        score: 376,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_004",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-11T19:00:00+09:00",
        durationSeconds: 2045,
        score: 9930,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_005",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-04T21:00:00+09:00",
        durationSeconds: 1440,
        score: 7419,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_014",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 6290,
        score: 1850,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_025",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-06-29T20:00:00+09:00",
        durationSeconds: 1324,
        score: 9236,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_006",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-27T22:00:00+09:00",
        durationSeconds: 5028,
        score: 7417,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_015",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 8544,
        score: 8134,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_026",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-22T21:00:00+09:00",
        durationSeconds: 5657,
        score: 8106,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_007",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-20T18:00:00+09:00",
        durationSeconds: 3178,
        score: 802,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_016",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-17T20:00:00+09:00",
        durationSeconds: 2574,
        score: 7445,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_008",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-13T18:00:00+09:00",
        durationSeconds: 8379,
        score: 6321,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_017",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-10T19:00:00+09:00",
        durationSeconds: 3562,
        score: 5559,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_027",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-08T21:00:00+09:00",
        durationSeconds: 6815,
        score: 4474,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_009",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-06T18:00:00+09:00",
        durationSeconds: 2386,
        score: 3767,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_018",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-03T19:00:00+09:00",
        durationSeconds: 5374,
        score: 4532,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_010",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-30T21:00:00+09:00",
        durationSeconds: 7573,
        score: 6744,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_019",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-27T23:00:00+09:00",
        durationSeconds: 2061,
        score: 4462,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_028",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-05-25T19:00:00+09:00",
        durationSeconds: 4635,
        score: 8766,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_011",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-23T22:00:00+09:00",
        durationSeconds: 2350,
        score: 3797,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_020",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-20T23:00:00+09:00",
        durationSeconds: 3630,
        score: 6118,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_029",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-18T20:00:00+09:00",
        durationSeconds: 1775,
        score: 2234,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_005_021",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-13T18:00:00+09:00",
        durationSeconds: 5389,
        score: 6406,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_005_030",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 3540,
        score: 5361,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "6",
    channelId: "UC_mock_006",
    name: "緑川ウスバ",
    description: "企業勢VTuberとして料理配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V006",
    bannerUrl: "https://placehold.co/640x180?text=V006",
    youtubeUrl: "https://www.youtube.com/@example-v006",
    subscriberCount: 451810,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_black", approved: true },
      { value: "eye_pink", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "accessory_wings", approved: false },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_minecraft", approved: false },
      { value: "game_rpg", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_cool", approved: true },
      { value: "personality_chaotic", approved: true },
      // stream_long
      // "stream_time_midnight",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_006_001",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T23:00:00+09:00",
        durationSeconds: 1528,
        score: 8075,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_023",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-08-02T20:00:00+09:00",
        durationSeconds: 1732,
        score: 7444,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_012",
        title: "【Minecraft】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-31T21:00:00+09:00",
        durationSeconds: 6506,
        score: 7810,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_024",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-26T19:00:00+09:00",
        durationSeconds: 1648,
        score: 4787,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_013",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-24T19:00:00+09:00",
        durationSeconds: 1053,
        score: 3473,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_002",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-22T22:00:00+09:00",
        durationSeconds: 1388,
        score: 7628,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_025",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-19T22:00:00+09:00",
        durationSeconds: 1936,
        score: 9732,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_014",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-17T18:00:00+09:00",
        durationSeconds: 1674,
        score: 8996,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_003",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-15T22:00:00+09:00",
        durationSeconds: 1330,
        score: 5929,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_026",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 1821,
        score: 5585,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_004",
        title: "【RPG】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-08T19:00:00+09:00",
        durationSeconds: 4902,
        score: 8173,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_006_027",
        title: "【RPG】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-05T20:00:00+09:00",
        durationSeconds: 7173,
        score: 5325,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_015",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-03T22:00:00+09:00",
        durationSeconds: 2269,
        score: 2469,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_005",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-01T22:00:00+09:00",
        durationSeconds: 2707,
        score: 9774,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_028",
        title: "【RPG】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-28T21:00:00+09:00",
        durationSeconds: 2413,
        score: 1101,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_016",
        title: "【Minecraft】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-26T18:00:00+09:00",
        durationSeconds: 7079,
        score: 5483,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_006",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-24T23:00:00+09:00",
        durationSeconds: 1450,
        score: 4992,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_029",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-21T21:00:00+09:00",
        durationSeconds: 3684,
        score: 5158,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_006_017",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-19T22:00:00+09:00",
        durationSeconds: 1138,
        score: 1825,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_007",
        title: "【Minecraft】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-17T23:00:00+09:00",
        durationSeconds: 2335,
        score: 8144,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_006_030",
        title: "【RPG】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-14T21:00:00+09:00",
        durationSeconds: 1960,
        score: 1969,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_006_018",
        title: "【Minecraft】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-12T22:00:00+09:00",
        durationSeconds: 6464,
        score: 4211,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_008",
        title: "【RPG】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-10T18:00:00+09:00",
        durationSeconds: 6205,
        score: 3653,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_031",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-07T21:00:00+09:00",
        durationSeconds: 1214,
        score: 1439,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_019",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-05T20:00:00+09:00",
        durationSeconds: 2369,
        score: 6629,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_009",
        title: "【RPG】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-03T19:00:00+09:00",
        durationSeconds: 7059,
        score: 2137,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_006_032",
        title: "【Minecraft】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-31T18:00:00+09:00",
        durationSeconds: 3316,
        score: 1680,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_006_020",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-29T20:00:00+09:00",
        durationSeconds: 2092,
        score: 1060,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_010",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-27T23:00:00+09:00",
        durationSeconds: 1222,
        score: 9666,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_033",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-24T22:00:00+09:00",
        durationSeconds: 3676,
        score: 3093,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_021",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-22T21:00:00+09:00",
        durationSeconds: 1012,
        score: 4415,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_034",
        title: "【RPG】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 1802,
        score: 449,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_006_022",
        title: "【Minecraft】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-15T18:00:00+09:00",
        durationSeconds: 3158,
        score: 4611,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_006_011",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-13T21:00:00+09:00",
        durationSeconds: 2034,
        score: 319,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_006_035",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-10T21:00:00+09:00",
        durationSeconds: 1888,
        score: 8202,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "7",
    channelId: "UC_mock_007",
    name: "星宮ゆき",
    description: "個人勢VTuberとしてASMR配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V007",
    bannerUrl: "https://placehold.co/640x180?text=V007",
    youtubeUrl: "https://www.youtube.com/@example-v007",
    subscriberCount: 91898,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_light_blue", approved: true },
      { value: "eye_brown", approved: false },
      { value: "hair_length_long", approved: false },
      { value: "accessory_horns", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_clear", approved: false },
      { value: "voice_powerful", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "personality_serious", approved: false },
      { value: "personality_relaxing", approved: true },
      // stream_collab,
      // stream_long
      // "stream_time_early_morning",
      { value: "stream_frequency_low", approved: true },
      { value: "day_thursday", approved: false },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_007_001",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 4352,
        score: 3695,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_002",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 2893,
        score: 9072,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_012",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 5067,
        score: 7698,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_003",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-23T18:00:00+09:00",
        durationSeconds: 4186,
        score: 4198,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_004",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-16T20:00:00+09:00",
        durationSeconds: 4411,
        score: 8924,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_005",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-09T23:00:00+09:00",
        durationSeconds: 5185,
        score: 2687,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_013",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-06T20:00:00+09:00",
        durationSeconds: 2382,
        score: 1415,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_006",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-02T19:00:00+09:00",
        durationSeconds: 3437,
        score: 5059,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_014",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-29T22:00:00+09:00",
        durationSeconds: 4613,
        score: 5666,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_007",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-25T23:00:00+09:00",
        durationSeconds: 5188,
        score: 4436,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_015",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-22T22:00:00+09:00",
        durationSeconds: 4454,
        score: 7061,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_008",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 4682,
        score: 5583,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_009",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-11T23:00:00+09:00",
        durationSeconds: 4003,
        score: 8384,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_016",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-08T21:00:00+09:00",
        durationSeconds: 4413,
        score: 5396,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_017",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-01T22:00:00+09:00",
        durationSeconds: 3609,
        score: 150,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_010",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-28T18:00:00+09:00",
        durationSeconds: 2912,
        score: 2634,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_018",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-25T20:00:00+09:00",
        durationSeconds: 3124,
        score: 588,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_011",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 3385,
        score: 1062,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_019",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-18T19:00:00+09:00",
        durationSeconds: 2591,
        score: 2167,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_007_020",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-11T23:00:00+09:00",
        durationSeconds: 2388,
        score: 1337,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "8",
    channelId: "UC_mock_008",
    name: "星宮ウツギ",
    description: "ゲーム配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V008",
    bannerUrl: "https://placehold.co/640x180?text=V008",
    youtubeUrl: "https://www.youtube.com/@example-v008",
    subscriberCount: 688,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_en", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_brown", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_fighting", approved: true },
      { value: "game_rhythm", approved: true },
      { value: "personality_chaotic", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_funny", approved: true },
      // "stream_time_morning",
      { value: "stream_frequency_high", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_008_011",
        title: "【音ゲー】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-08-05T23:00:00+09:00",
        durationSeconds: 6458,
        score: 708,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_001",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T19:00:00+09:00",
        durationSeconds: 3919,
        score: 3308,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_021",
        title: "【格闘ゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-08-02T19:00:00+09:00",
        durationSeconds: 5073,
        score: 9783,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_012",
        title: "【音ゲー】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-29T18:00:00+09:00",
        durationSeconds: 2661,
        score: 4868,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_002",
        title: "【音ゲー】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 3787,
        score: 231,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_022",
        title: "【音ゲー】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-26T18:00:00+09:00",
        durationSeconds: 6992,
        score: 1221,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_013",
        title: "【音ゲー】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-22T22:00:00+09:00",
        durationSeconds: 6252,
        score: 3923,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_003",
        title: "【音ゲー】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T18:00:00+09:00",
        durationSeconds: 5439,
        score: 1480,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_023",
        title: "【格闘ゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-19T18:00:00+09:00",
        durationSeconds: 3966,
        score: 504,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_014",
        title: "【格闘ゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-15T21:00:00+09:00",
        durationSeconds: 3121,
        score: 7642,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_024",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 4624,
        score: 645,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_015",
        title: "【格闘ゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-08T20:00:00+09:00",
        durationSeconds: 5743,
        score: 1901,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_004",
        title: "【格闘ゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-07T21:00:00+09:00",
        durationSeconds: 1993,
        score: 1483,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_016",
        title: "【格闘ゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 4130,
        score: 1309,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_005",
        title: "【格闘ゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-30T20:00:00+09:00",
        durationSeconds: 2773,
        score: 8024,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_025",
        title: "【格闘ゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-06-21T19:00:00+09:00",
        durationSeconds: 4004,
        score: 9536,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_006",
        title: "【格闘ゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-16T20:00:00+09:00",
        durationSeconds: 5743,
        score: 1286,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_026",
        title: "【格闘ゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-14T22:00:00+09:00",
        durationSeconds: 6305,
        score: 3778,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_007",
        title: "【格闘ゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-09T18:00:00+09:00",
        durationSeconds: 3644,
        score: 9400,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_027",
        title: "【格闘ゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-07T20:00:00+09:00",
        durationSeconds: 2414,
        score: 7612,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_017",
        title: "【音ゲー】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-03T18:00:00+09:00",
        durationSeconds: 4698,
        score: 9861,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_008",
        title: "【音ゲー】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-02T20:00:00+09:00",
        durationSeconds: 6836,
        score: 391,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_028",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-05-31T22:00:00+09:00",
        durationSeconds: 5172,
        score: 904,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_018",
        title: "【音ゲー】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-27T21:00:00+09:00",
        durationSeconds: 6763,
        score: 6779,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_009",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-26T21:00:00+09:00",
        durationSeconds: 6364,
        score: 434,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_029",
        title: "【音ゲー】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-24T22:00:00+09:00",
        durationSeconds: 6234,
        score: 8662,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_019",
        title: "【音ゲー】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-20T21:00:00+09:00",
        durationSeconds: 5061,
        score: 4954,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_010",
        title: "【格闘ゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-19T18:00:00+09:00",
        durationSeconds: 5759,
        score: 3762,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_008_030",
        title: "【格闘ゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 2094,
        score: 672,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_020",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-13T19:00:00+09:00",
        durationSeconds: 5437,
        score: 3107,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_008_031",
        title: "【格闘ゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-10T20:00:00+09:00",
        durationSeconds: 3033,
        score: 9799,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      }
    ],
  },
  {
    id: "9",
    channelId: "UC_mock_009",
    name: "緑川ギンガ",
    description: "個人勢VTuberとして同時視聴配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V009",
    bannerUrl: "https://placehold.co/640x180?text=V009",
    youtubeUrl: "https://www.youtube.com/@example-v009",
    subscriberCount: 57125,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: false },
      { value: "model_live2d", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_pink", approved: false },
      { value: "eye_red", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_husky", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "personality_serious", approved: true },
      // stream_long
      // "stream_time_early_morning",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_009_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 4371,
        score: 1094,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_001",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 4609,
        score: 5488,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-17T21:00:00+09:00",
        durationSeconds: 4640,
        score: 4564,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_004",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-10T18:00:00+09:00",
        durationSeconds: 4229,
        score: 7467,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_005",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-03T21:00:00+09:00",
        durationSeconds: 5136,
        score: 4786,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_006",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-26T21:00:00+09:00",
        durationSeconds: 5739,
        score: 3080,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_007",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-19T23:00:00+09:00",
        durationSeconds: 8080,
        score: 4056,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-12T18:00:00+09:00",
        durationSeconds: 4119,
        score: 1075,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_009",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-05T18:00:00+09:00",
        durationSeconds: 6422,
        score: 7239,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_009_010",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-15T19:00:00+09:00",
        durationSeconds: 4368,
        score: 4872,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "10",
    channelId: "UC_mock_010",
    name: "空木ルナ",
    description: "歌枠をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V010",
    bannerUrl: "https://placehold.co/640x180?text=V010",
    youtubeUrl: "https://www.youtube.com/@example-v010",
    subscriberCount: 3667,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_pink", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_husky", approved: false },
      { value: "genre_singing", approved: true },
      { value: "personality_energetic", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_midnight",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_010_001",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T18:00:00+09:00",
        durationSeconds: 2167,
        score: 4433,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_002",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-25T22:00:00+09:00",
        durationSeconds: 1635,
        score: 3971,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-18T22:00:00+09:00",
        durationSeconds: 2708,
        score: 2538,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_004",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-11T18:00:00+09:00",
        durationSeconds: 2213,
        score: 9594,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_005",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-04T22:00:00+09:00",
        durationSeconds: 1991,
        score: 392,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_006",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-27T22:00:00+09:00",
        durationSeconds: 2377,
        score: 9440,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_007",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 1499,
        score: 4913,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_008",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-13T20:00:00+09:00",
        durationSeconds: 2286,
        score: 8815,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_009",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-30T19:00:00+09:00",
        durationSeconds: 2260,
        score: 4281,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_010",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-23T22:00:00+09:00",
        durationSeconds: 2719,
        score: 6247,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_010_011",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 3030,
        score: 9087,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "11",
    channelId: "UC_mock_011",
    name: "月城ツキ",
    description: "お絵描き配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V011",
    bannerUrl: "https://placehold.co/640x180?text=V011",
    youtubeUrl: "https://www.youtube.com/@example-v011",
    subscriberCount: 19647,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_purple", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "genre_watchalong", approved: false },
      { value: "personality_gentle", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_cool", approved: false },
      // stream_long
      // stream_collab,
      // "stream_time_evening",
      { value: "stream_frequency_daily", approved: false },
      { value: "day_thursday", approved: true },
      { value: "day_sunday", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_011_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-30T23:00:00+09:00",
        durationSeconds: 3684,
        score: 1775,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_001",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T19:00:00+09:00",
        durationSeconds: 7557,
        score: 7394,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_023",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-28T21:00:00+09:00",
        durationSeconds: 8950,
        score: 725,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_013",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-26T19:00:00+09:00",
        durationSeconds: 8837,
        score: 4087,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_003",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-23T18:00:00+09:00",
        durationSeconds: 6269,
        score: 4820,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_024",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-21T18:00:00+09:00",
        durationSeconds: 3981,
        score: 6171,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_014",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-19T20:00:00+09:00",
        durationSeconds: 5886,
        score: 9442,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_004",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-16T19:00:00+09:00",
        durationSeconds: 8782,
        score: 9870,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_025",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-14T23:00:00+09:00",
        durationSeconds: 5669,
        score: 5251,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_015",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-12T20:00:00+09:00",
        durationSeconds: 5224,
        score: 472,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_005",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-09T20:00:00+09:00",
        durationSeconds: 8676,
        score: 8065,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_026",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-07T21:00:00+09:00",
        durationSeconds: 8015,
        score: 5641,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_016",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-05T23:00:00+09:00",
        durationSeconds: 7267,
        score: 8473,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_006",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-02T22:00:00+09:00",
        durationSeconds: 8340,
        score: 6778,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_027",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-30T22:00:00+09:00",
        durationSeconds: 5620,
        score: 1605,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_017",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-28T23:00:00+09:00",
        durationSeconds: 8383,
        score: 8437,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_007",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-25T20:00:00+09:00",
        durationSeconds: 6689,
        score: 5278,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_028",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-23T21:00:00+09:00",
        durationSeconds: 4110,
        score: 9833,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-18T22:00:00+09:00",
        durationSeconds: 4612,
        score: 8659,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_018",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-14T20:00:00+09:00",
        durationSeconds: 4736,
        score: 5089,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_009",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-11T21:00:00+09:00",
        durationSeconds: 5250,
        score: 4275,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_029",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-09T18:00:00+09:00",
        durationSeconds: 6475,
        score: 1715,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_019",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-07T18:00:00+09:00",
        durationSeconds: 4443,
        score: 6130,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_010",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-04T23:00:00+09:00",
        durationSeconds: 5830,
        score: 2920,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_030",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-02T22:00:00+09:00",
        durationSeconds: 10057,
        score: 9192,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_020",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-31T19:00:00+09:00",
        durationSeconds: 6503,
        score: 1810,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-28T22:00:00+09:00",
        durationSeconds: 8858,
        score: 4329,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_031",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-26T21:00:00+09:00",
        durationSeconds: 6405,
        score: 1894,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_011_021",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-24T18:00:00+09:00",
        durationSeconds: 3793,
        score: 6289,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_032",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-19T19:00:00+09:00",
        durationSeconds: 8598,
        score: 9974,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_022",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-17T22:00:00+09:00",
        durationSeconds: 6121,
        score: 8486,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_011_012",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-14T18:00:00+09:00",
        durationSeconds: 7234,
        score: 3556,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "12",
    channelId: "UC_mock_012",
    name: "桜庭カザマ",
    description: "雑談配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V012",
    bannerUrl: "https://placehold.co/640x180?text=V012",
    youtubeUrl: "https://www.youtube.com/@example-v012",
    subscriberCount: 1357382,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_blonde", approved: false },
      { value: "eye_green", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_animal_ears", approved: false },
      { value: "accessory_wings", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_cute", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_talk", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "talk_topic", approved: true },
      { value: "personality_funny", approved: true },
      // stream_long
      // "stream_time_morning",
      { value: "stream_frequency_high", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_012_001",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 2063,
        score: 3077,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_012_002",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 1640,
        score: 5540,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_012_003",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-17T23:00:00+09:00",
        durationSeconds: 4956,
        score: 8068,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_012_004",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 2220,
        score: 404,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_012_005",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-03T23:00:00+09:00",
        durationSeconds: 1618,
        score: 5696,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_012_006",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 2301,
        score: 4574,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_012_007",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-19T23:00:00+09:00",
        durationSeconds: 2381,
        score: 7530,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_012_008",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-12T21:00:00+09:00",
        durationSeconds: 4651,
        score: 1329,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_012_009",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-05T21:00:00+09:00",
        durationSeconds: 2422,
        score: 6701,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_012_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-22T20:00:00+09:00",
        durationSeconds: 1896,
        score: 2416,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "13",
    channelId: "UC_mock_013",
    name: "月城つむぎ",
    description: "企業勢VTuberとして雑談配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V013",
    bannerUrl: "https://placehold.co/640x180?text=V013",
    youtubeUrl: "https://www.youtube.com/@example-v013",
    subscriberCount: 1707,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: false },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_blonde", approved: true },
      { value: "eye_blue", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_husky", approved: true },
      { value: "voice_mature", approved: true },
      { value: "genre_talk", approved: false },
      { value: "genre_singing", approved: true },
      { value: "talk_topic", approved: false },
      { value: "personality_energetic", approved: true },
      { value: "personality_funny", approved: true },
      // "stream_time_early_morning",
      { value: "stream_frequency_low", approved: false },
      { value: "day_sunday", approved: true },
      { value: "day_saturday", approved: false },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_013_022",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-08-05T21:00:00+09:00",
        durationSeconds: 4376,
        score: 3814,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_001",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-02T23:00:00+09:00",
        durationSeconds: 2306,
        score: 3584,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_013",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 3806,
        score: 4597,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_014",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 4158,
        score: 9321,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_002",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-26T23:00:00+09:00",
        durationSeconds: 2741,
        score: 5888,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_023",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-22T18:00:00+09:00",
        durationSeconds: 2145,
        score: 8874,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_003",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-19T22:00:00+09:00",
        durationSeconds: 1503,
        score: 1458,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_015",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-18T18:00:00+09:00",
        durationSeconds: 2830,
        score: 1964,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_024",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-15T22:00:00+09:00",
        durationSeconds: 2075,
        score: 2593,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_004",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 3164,
        score: 4961,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_016",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-11T23:00:00+09:00",
        durationSeconds: 1246,
        score: 8592,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_025",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-08T21:00:00+09:00",
        durationSeconds: 4138,
        score: 5761,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_005",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-05T18:00:00+09:00",
        durationSeconds: 2056,
        score: 2959,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_017",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-04T22:00:00+09:00",
        durationSeconds: 4717,
        score: 7344,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_026",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 2583,
        score: 576,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_006",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-28T19:00:00+09:00",
        durationSeconds: 3658,
        score: 6835,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_018",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-27T20:00:00+09:00",
        durationSeconds: 4249,
        score: 3925,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_027",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 3611,
        score: 1868,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_007",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-21T21:00:00+09:00",
        durationSeconds: 3278,
        score: 7932,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_019",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-20T23:00:00+09:00",
        durationSeconds: 4430,
        score: 5123,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_028",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-17T21:00:00+09:00",
        durationSeconds: 1861,
        score: 5802,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_008",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-14T20:00:00+09:00",
        durationSeconds: 5063,
        score: 5548,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_029",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-10T23:00:00+09:00",
        durationSeconds: 4632,
        score: 7629,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_009",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-07T18:00:00+09:00",
        durationSeconds: 3613,
        score: 9783,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_030",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-03T20:00:00+09:00",
        durationSeconds: 3821,
        score: 7392,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_010",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-31T21:00:00+09:00",
        durationSeconds: 2260,
        score: 5877,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_031",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-27T21:00:00+09:00",
        durationSeconds: 2626,
        score: 8150,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_011",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-24T19:00:00+09:00",
        durationSeconds: 2753,
        score: 6110,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_020",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-23T22:00:00+09:00",
        durationSeconds: 5147,
        score: 3640,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_013_032",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-20T20:00:00+09:00",
        durationSeconds: 2651,
        score: 9806,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_021",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-16T22:00:00+09:00",
        durationSeconds: 1419,
        score: 4485,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_033",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-13T20:00:00+09:00",
        durationSeconds: 3405,
        score: 2220,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_013_012",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-10T22:00:00+09:00",
        durationSeconds: 5196,
        score: 4071,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      }
    ],
  },
  {
    id: "14",
    channelId: "UC_mock_014",
    name: "星宮シズク",
    description: "配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V014",
    bannerUrl: "https://placehold.co/640x180?text=V014",
    youtubeUrl: "https://www.youtube.com/@example-v014",
    subscriberCount: 58965,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_zh", approved: false },
      { value: "model_png", approved: true },
      { value: "hair_white", approved: true },
      { value: "eye_red", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_other", approved: true },
      { value: "personality_funny", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_cool", approved: false },
      // stream_viewer_partcition,
      // stream_long
      // "stream_time_afternoon",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_014_001",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-28T20:00:00+09:00",
        durationSeconds: 2902,
        score: 1194,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_014_002",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-14T23:00:00+09:00",
        durationSeconds: 1597,
        score: 5239,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_014_003",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-07T20:00:00+09:00",
        durationSeconds: 1545,
        score: 9887,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_014_004",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-23T22:00:00+09:00",
        durationSeconds: 2739,
        score: 7550,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_014_005",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-09T23:00:00+09:00",
        durationSeconds: 1639,
        score: 9778,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_014_006",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-02T18:00:00+09:00",
        durationSeconds: 1740,
        score: 6208,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_014_007",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-26T18:00:00+09:00",
        durationSeconds: 1706,
        score: 5909,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "15",
    channelId: "UC_mock_015",
    name: "桜庭ウスバ",
    description: "配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V015",
    bannerUrl: "https://placehold.co/640x180?text=V015",
    youtubeUrl: "https://www.youtube.com/@example-v015",
    subscriberCount: 3385,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: false },
      { value: "model_live2d", approved: false },
      { value: "hair_orange", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_clear", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_other", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_energetic", approved: false },
      // stream_long
      // stream_collab,
      // "stream_time_evening",
      { value: "stream_frequency_low", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_015_026",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-08-04T21:00:00+09:00",
        durationSeconds: 1094,
        score: 2212,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_013",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-03T19:00:00+09:00",
        durationSeconds: 1590,
        score: 5351,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 2309,
        score: 7201,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_001",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 3173,
        score: 7423,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_027",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 3029,
        score: 8413,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_014",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-27T23:00:00+09:00",
        durationSeconds: 3020,
        score: 4635,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_003",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T21:00:00+09:00",
        durationSeconds: 2574,
        score: 9964,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_028",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-21T23:00:00+09:00",
        durationSeconds: 2211,
        score: 3713,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_015",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-20T21:00:00+09:00",
        durationSeconds: 2656,
        score: 7346,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_004",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 1257,
        score: 1969,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_029",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-07-14T23:00:00+09:00",
        durationSeconds: 2186,
        score: 8581,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_016",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-13T20:00:00+09:00",
        durationSeconds: 2315,
        score: 1183,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_005",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-11T21:00:00+09:00",
        durationSeconds: 1882,
        score: 788,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_017",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-06T18:00:00+09:00",
        durationSeconds: 2114,
        score: 1946,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_006",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-04T18:00:00+09:00",
        durationSeconds: 2016,
        score: 9951,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_018",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 1838,
        score: 3421,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_007",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-27T18:00:00+09:00",
        durationSeconds: 2693,
        score: 2962,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_030",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-23T21:00:00+09:00",
        durationSeconds: 2410,
        score: 2826,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_019",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-22T20:00:00+09:00",
        durationSeconds: 1219,
        score: 7592,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_008",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 2844,
        score: 8862,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_031",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-16T21:00:00+09:00",
        durationSeconds: 1962,
        score: 1040,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_020",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-15T19:00:00+09:00",
        durationSeconds: 3293,
        score: 8791,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_009",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-13T23:00:00+09:00",
        durationSeconds: 2617,
        score: 4081,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_032",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-09T18:00:00+09:00",
        durationSeconds: 3621,
        score: 515,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_021",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-08T18:00:00+09:00",
        durationSeconds: 2861,
        score: 3788,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_010",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-06T22:00:00+09:00",
        durationSeconds: 1976,
        score: 9439,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_033",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-06-02T20:00:00+09:00",
        durationSeconds: 3070,
        score: 576,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_022",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-06-01T19:00:00+09:00",
        durationSeconds: 1537,
        score: 7835,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_011",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-30T19:00:00+09:00",
        durationSeconds: 3325,
        score: 5434,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_034",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-26T19:00:00+09:00",
        durationSeconds: 2262,
        score: 2230,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_023",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-25T20:00:00+09:00",
        durationSeconds: 3515,
        score: 5715,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_024",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-18T21:00:00+09:00",
        durationSeconds: 1681,
        score: 8614,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_012",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-16T22:00:00+09:00",
        durationSeconds: 3138,
        score: 6132,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_015_035",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 3437,
        score: 8861,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_015_025",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 1149,
        score: 1556,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "16",
    channelId: "UC_mock_016",
    name: "月城ミナヅキ",
    description: "配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V016",
    bannerUrl: "https://placehold.co/640x180?text=V016",
    youtubeUrl: "https://www.youtube.com/@example-v016",
    subscriberCount: 66345,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_live2d", approved: false },
      { value: "model_png", approved: true },
      { value: "hair_yellow", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "voice_pitch_very_high", approved: false },
      { value: "voice_mature", approved: true },
      { value: "voice_whisper", approved: false },
      { value: "genre_other", approved: true },
      { value: "personality_natural", approved: false },
      { value: "personality_calm", approved: true },
      // stream_collab,
      // stream_viewer_partcition,
      // "stream_time_morning",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_wednesday", approved: false },
      { value: "day_saturday", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_016_001",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T18:00:00+09:00",
        durationSeconds: 1899,
        score: 9235,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_024",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-08-04T20:00:00+09:00",
        durationSeconds: 3204,
        score: 2372,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_012",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-01T22:00:00+09:00",
        durationSeconds: 2127,
        score: 1262,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_013",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 2871,
        score: 1962,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_002",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-29T19:00:00+09:00",
        durationSeconds: 3404,
        score: 3376,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_025",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 1307,
        score: 5419,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_014",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-25T19:00:00+09:00",
        durationSeconds: 1765,
        score: 9964,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_003",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-22T20:00:00+09:00",
        durationSeconds: 954,
        score: 1518,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_026",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-21T19:00:00+09:00",
        durationSeconds: 3244,
        score: 6464,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_004",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-15T23:00:00+09:00",
        durationSeconds: 2401,
        score: 620,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_015",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-11T21:00:00+09:00",
        durationSeconds: 2133,
        score: 9967,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_005",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-08T21:00:00+09:00",
        durationSeconds: 3061,
        score: 3422,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_027",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-07T19:00:00+09:00",
        durationSeconds: 3143,
        score: 3104,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_016",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 2061,
        score: 1352,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_028",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-30T18:00:00+09:00",
        durationSeconds: 3449,
        score: 8052,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_017",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-27T18:00:00+09:00",
        durationSeconds: 1255,
        score: 1311,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_006",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 1674,
        score: 7021,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_029",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-23T21:00:00+09:00",
        durationSeconds: 2134,
        score: 9413,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_018",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-20T19:00:00+09:00",
        durationSeconds: 2954,
        score: 5266,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_007",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-17T19:00:00+09:00",
        durationSeconds: 924,
        score: 2932,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_030",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-16T23:00:00+09:00",
        durationSeconds: 1157,
        score: 5348,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_019",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-13T21:00:00+09:00",
        durationSeconds: 2665,
        score: 4273,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_008",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-10T19:00:00+09:00",
        durationSeconds: 1961,
        score: 7111,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_031",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-09T21:00:00+09:00",
        durationSeconds: 2798,
        score: 8832,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_020",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 2451,
        score: 8414,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_009",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-03T19:00:00+09:00",
        durationSeconds: 2296,
        score: 2750,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_032",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-02T20:00:00+09:00",
        durationSeconds: 2513,
        score: 1870,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_021",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-30T18:00:00+09:00",
        durationSeconds: 2861,
        score: 6531,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_033",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-26T18:00:00+09:00",
        durationSeconds: 1076,
        score: 9242,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_022",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-23T19:00:00+09:00",
        durationSeconds: 2294,
        score: 5207,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_010",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-20T18:00:00+09:00",
        durationSeconds: 1515,
        score: 7805,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_034",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-19T23:00:00+09:00",
        durationSeconds: 2677,
        score: 5854,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_023",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-16T20:00:00+09:00",
        durationSeconds: 2922,
        score: 5940,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_011",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-13T20:00:00+09:00",
        durationSeconds: 2314,
        score: 8099,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_016_035",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 3647,
        score: 8057,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "17",
    channelId: "UC_mock_017",
    name: "黒崎カエデ",
    description: "雑談配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V017",
    bannerUrl: "https://placehold.co/640x180?text=V017",
    youtubeUrl: "https://www.youtube.com/@example-v017",
    subscriberCount: 615,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_white", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_medium", approved: false },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "voice_husky", approved: true },
      { value: "genre_talk", approved: false },
      { value: "genre_cooking", approved: true },
      { value: "talk_topic", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_funny", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_midnight",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_017_008",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-08-02T23:00:00+09:00",
        durationSeconds: 4694,
        score: 8603,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_017_001",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-28T20:00:00+09:00",
        durationSeconds: 1259,
        score: 9354,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_009",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-07-26T23:00:00+09:00",
        durationSeconds: 1651,
        score: 5675,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-19T18:00:00+09:00",
        durationSeconds: 1498,
        score: 5546,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_002",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-14T19:00:00+09:00",
        durationSeconds: 1761,
        score: 6468,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_011",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-12T19:00:00+09:00",
        durationSeconds: 2023,
        score: 5866,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_017_012",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-05T23:00:00+09:00",
        durationSeconds: 1166,
        score: 5970,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_013",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-06-28T23:00:00+09:00",
        durationSeconds: 2857,
        score: 829,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_017_014",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-21T21:00:00+09:00",
        durationSeconds: 3736,
        score: 6228,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_017_015",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-14T18:00:00+09:00",
        durationSeconds: 2471,
        score: 2595,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_017_003",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-06-09T23:00:00+09:00",
        durationSeconds: 2376,
        score: 4450,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_016",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-07T22:00:00+09:00",
        durationSeconds: 2117,
        score: 111,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_004",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-02T23:00:00+09:00",
        durationSeconds: 1112,
        score: 7406,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_017",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-31T22:00:00+09:00",
        durationSeconds: 1451,
        score: 163,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_005",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-05-26T20:00:00+09:00",
        durationSeconds: 2622,
        score: 9517,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_017_018",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-24T18:00:00+09:00",
        durationSeconds: 2261,
        score: 7073,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      },
      {
        videoId: "mock_video_017_006",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-05-19T18:00:00+09:00",
        durationSeconds: 1934,
        score: 1855,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_007",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 977,
        score: 1047,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_017_019",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-10T19:00:00+09:00",
        durationSeconds: 4484,
        score: 3900,
        attributes: [
          "genre_talk",
          "talk_topic",
        ],
      }
    ],
  },
  {
    id: "18",
    channelId: "UC_mock_018",
    name: "天霧ウスバ",
    description: "ゲーム配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V018",
    bannerUrl: "https://placehold.co/640x180?text=V018",
    youtubeUrl: "https://www.youtube.com/@example-v018",
    subscriberCount: 569412,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_multicolor", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_cute", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "genre_game", approved: true },
      { value: "game_rpg", approved: false },
      { value: "game_simulation", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_natural", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_early_morning",
      { value: "stream_frequency_high", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_018_012",
        title: "【シミュレーションゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-03T18:00:00+09:00",
        durationSeconds: 2316,
        score: 7659,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_018_001",
        title: "【シミュレーションゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 6455,
        score: 2392,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_018_002",
        title: "【シミュレーションゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T18:00:00+09:00",
        durationSeconds: 3111,
        score: 1077,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_018_013",
        title: "【シミュレーションゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 6710,
        score: 1487,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_003",
        title: "【シミュレーションゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-18T23:00:00+09:00",
        durationSeconds: 3261,
        score: 9111,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_014",
        title: "【RPG】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-13T19:00:00+09:00",
        durationSeconds: 3767,
        score: 8534,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_004",
        title: "【RPG】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-11T22:00:00+09:00",
        durationSeconds: 4082,
        score: 2884,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_018_015",
        title: "【シミュレーションゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-06T18:00:00+09:00",
        durationSeconds: 6506,
        score: 5089,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_005",
        title: "【RPG】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-04T23:00:00+09:00",
        durationSeconds: 2344,
        score: 218,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_016",
        title: "【RPG】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 4998,
        score: 7470,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_017",
        title: "【シミュレーションゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-22T20:00:00+09:00",
        durationSeconds: 6551,
        score: 7595,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_018_006",
        title: "【RPG】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 4169,
        score: 7735,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_018",
        title: "【RPG】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-15T21:00:00+09:00",
        durationSeconds: 2501,
        score: 4571,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_018_007",
        title: "【シミュレーションゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-13T18:00:00+09:00",
        durationSeconds: 3192,
        score: 936,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_019",
        title: "【シミュレーションゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 2409,
        score: 8092,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_008",
        title: "【シミュレーションゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-06T18:00:00+09:00",
        durationSeconds: 3377,
        score: 1724,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_009",
        title: "【RPG】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-30T21:00:00+09:00",
        durationSeconds: 3989,
        score: 9882,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_018_020",
        title: "【RPG】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 5429,
        score: 6258,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_010",
        title: "【RPG】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-23T18:00:00+09:00",
        durationSeconds: 1879,
        score: 5760,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_021",
        title: "【RPG】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-18T22:00:00+09:00",
        durationSeconds: 2223,
        score: 1242,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      },
      {
        videoId: "mock_video_018_011",
        title: "【RPG】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 6401,
        score: 9845,
        attributes: [
          "genre_game",
          "game_simulation",
        ],
      }
    ],
  },
  {
    id: "19",
    channelId: "UC_mock_019",
    name: "花城シズク",
    description: "ASMR配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V019",
    bannerUrl: "https://placehold.co/640x180?text=V019",
    youtubeUrl: "https://www.youtube.com/@example-v019",
    subscriberCount: 493507,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: false },
      { value: "model_png", approved: true },
      { value: "hair_pink", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "genre_watchalong", approved: false },
      { value: "personality_chaotic", approved: true },
      { value: "personality_cool", approved: true },
      { value: "personality_serious", approved: false },
      // "stream_time_night",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_sunday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_019_011",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 4349,
        score: 3891,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_010",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 4687,
        score: 4289,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_012",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-24T22:00:00+09:00",
        durationSeconds: 8863,
        score: 4828,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_001",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-19T22:00:00+09:00",
        durationSeconds: 2367,
        score: 4613,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_013",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-17T23:00:00+09:00",
        durationSeconds: 6811,
        score: 7787,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-12T19:00:00+09:00",
        durationSeconds: 7643,
        score: 5223,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_014",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-10T22:00:00+09:00",
        durationSeconds: 4132,
        score: 3619,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_003",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-05T21:00:00+09:00",
        durationSeconds: 4813,
        score: 2015,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_015",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-03T21:00:00+09:00",
        durationSeconds: 5926,
        score: 8356,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_016",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-26T18:00:00+09:00",
        durationSeconds: 2836,
        score: 2894,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_004",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-21T19:00:00+09:00",
        durationSeconds: 2240,
        score: 354,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_017",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-19T19:00:00+09:00",
        durationSeconds: 3412,
        score: 8903,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_005",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-14T18:00:00+09:00",
        durationSeconds: 6775,
        score: 3177,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_018",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-12T19:00:00+09:00",
        durationSeconds: 2007,
        score: 7707,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_006",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-07T20:00:00+09:00",
        durationSeconds: 4389,
        score: 5028,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_019",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-29T21:00:00+09:00",
        durationSeconds: 7468,
        score: 8706,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_007",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-24T20:00:00+09:00",
        durationSeconds: 4213,
        score: 914,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_020",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-22T20:00:00+09:00",
        durationSeconds: 5219,
        score: 8540,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_019_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-17T21:00:00+09:00",
        durationSeconds: 4952,
        score: 3002,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_021",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 7266,
        score: 3475,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_019_009",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-10T19:00:00+09:00",
        durationSeconds: 1896,
        score: 806,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "20",
    channelId: "UC_mock_020",
    name: "空木テツヤ",
    description: "料理配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V020",
    bannerUrl: "https://placehold.co/640x180?text=V020",
    youtubeUrl: "https://www.youtube.com/@example-v020",
    subscriberCount: 50402,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: false },
      { value: "hair_orange", approved: true },
      { value: "eye_orange", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_wings", approved: false },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_whisper", approved: false },
      { value: "voice_powerful", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_funny", approved: false },
      // "stream_time_night",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_020_013",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-05T19:00:00+09:00",
        durationSeconds: 7786,
        score: 3230,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_025",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-08-04T19:00:00+09:00",
        durationSeconds: 1645,
        score: 2441,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_001",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 7685,
        score: 8525,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_002",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 1461,
        score: 2263,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_026",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-28T18:00:00+09:00",
        durationSeconds: 10717,
        score: 9972,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_003",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T19:00:00+09:00",
        durationSeconds: 10432,
        score: 1804,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_014",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-22T23:00:00+09:00",
        durationSeconds: 5950,
        score: 8232,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_004",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-18T18:00:00+09:00",
        durationSeconds: 10130,
        score: 5842,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_015",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-15T23:00:00+09:00",
        durationSeconds: 3775,
        score: 8508,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_027",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-14T18:00:00+09:00",
        durationSeconds: 967,
        score: 957,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_005",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-11T23:00:00+09:00",
        durationSeconds: 5813,
        score: 5888,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_016",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-08T19:00:00+09:00",
        durationSeconds: 1405,
        score: 3517,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_028",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-07T22:00:00+09:00",
        durationSeconds: 2332,
        score: 4604,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_006",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-04T18:00:00+09:00",
        durationSeconds: 6924,
        score: 5493,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_017",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-01T21:00:00+09:00",
        durationSeconds: 2268,
        score: 3165,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_007",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-27T23:00:00+09:00",
        durationSeconds: 7696,
        score: 6762,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_018",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-24T21:00:00+09:00",
        durationSeconds: 1390,
        score: 9135,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_029",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-23T23:00:00+09:00",
        durationSeconds: 1279,
        score: 7832,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_008",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-20T18:00:00+09:00",
        durationSeconds: 2192,
        score: 1538,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_019",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-17T23:00:00+09:00",
        durationSeconds: 9954,
        score: 2036,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_030",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-16T23:00:00+09:00",
        durationSeconds: 4411,
        score: 7555,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_009",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-13T18:00:00+09:00",
        durationSeconds: 5382,
        score: 9144,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_020",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-10T23:00:00+09:00",
        durationSeconds: 8069,
        score: 5903,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_031",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-09T19:00:00+09:00",
        durationSeconds: 8890,
        score: 6173,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_010",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-06T18:00:00+09:00",
        durationSeconds: 1724,
        score: 8663,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_021",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-03T18:00:00+09:00",
        durationSeconds: 2374,
        score: 8396,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_032",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-02T22:00:00+09:00",
        durationSeconds: 1981,
        score: 1190,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_022",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-27T21:00:00+09:00",
        durationSeconds: 2267,
        score: 6821,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_033",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-26T23:00:00+09:00",
        durationSeconds: 6251,
        score: 5274,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-23T20:00:00+09:00",
        durationSeconds: 6506,
        score: 8894,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_023",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-20T23:00:00+09:00",
        durationSeconds: 1627,
        score: 4506,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_020_034",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-19T21:00:00+09:00",
        durationSeconds: 3713,
        score: 5939,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_012",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 6463,
        score: 4187,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_024",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-13T21:00:00+09:00",
        durationSeconds: 4735,
        score: 6349,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_020_035",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 1699,
        score: 5379,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "21",
    channelId: "UC_mock_021",
    name: "雪代リン",
    description: "作業配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V021",
    bannerUrl: "https://placehold.co/640x180?text=V021",
    youtubeUrl: "https://www.youtube.com/@example-v021",
    subscriberCount: 8310,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_blonde", approved: true },
      { value: "eye_brown", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_very_high", approved: false },
      { value: "voice_soft", approved: true },
      { value: "voice_boyish", approved: false },
      { value: "genre_study", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_funny", approved: true },
      { value: "personality_serious", approved: true },
      // stream_collab,
      // "stream_time_afternoon",
      { value: "stream_frequency_high", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_021_001",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T22:00:00+09:00",
        durationSeconds: 10211,
        score: 4097,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_010",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 5734,
        score: 954,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_011",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 6256,
        score: 8393,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_002",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-29T19:00:00+09:00",
        durationSeconds: 7299,
        score: 1667,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_012",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-25T23:00:00+09:00",
        durationSeconds: 4357,
        score: 190,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_013",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-18T23:00:00+09:00",
        durationSeconds: 5480,
        score: 1295,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_003",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-15T23:00:00+09:00",
        durationSeconds: 8225,
        score: 5429,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-11T19:00:00+09:00",
        durationSeconds: 5072,
        score: 5467,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_004",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-01T23:00:00+09:00",
        durationSeconds: 9794,
        score: 8778,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_015",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-27T19:00:00+09:00",
        durationSeconds: 7784,
        score: 4989,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_005",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 8158,
        score: 6712,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_016",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-20T19:00:00+09:00",
        durationSeconds: 5646,
        score: 8919,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_006",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-17T19:00:00+09:00",
        durationSeconds: 7324,
        score: 1301,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_017",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-13T22:00:00+09:00",
        durationSeconds: 8253,
        score: 9,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-10T22:00:00+09:00",
        durationSeconds: 9708,
        score: 3902,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_018",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-30T19:00:00+09:00",
        durationSeconds: 4961,
        score: 7994,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_008",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-27T21:00:00+09:00",
        durationSeconds: 8403,
        score: 8660,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_019",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-23T21:00:00+09:00",
        durationSeconds: 8236,
        score: 1868,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_020",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-16T23:00:00+09:00",
        durationSeconds: 4354,
        score: 3989,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_021_009",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-13T21:00:00+09:00",
        durationSeconds: 6853,
        score: 5642,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "22",
    channelId: "UC_mock_022",
    name: "白鳥カザマ",
    description: "料理配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V022",
    bannerUrl: "https://placehold.co/640x180?text=V022",
    youtubeUrl: "https://www.youtube.com/@example-v022",
    subscriberCount: 8086,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_navy", approved: true },
      { value: "eye_blue", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "accessory_wings", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "personality_cheerful", approved: true },
      // stream_collab,
      // "stream_time_night",
      { value: "stream_frequency_high", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_022_001",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T22:00:00+09:00",
        durationSeconds: 1058,
        score: 1847,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_022_002",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T23:00:00+09:00",
        durationSeconds: 9951,
        score: 2363,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_022_003",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T21:00:00+09:00",
        durationSeconds: 1693,
        score: 3039,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_022_004",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T20:00:00+09:00",
        durationSeconds: 1372,
        score: 6411,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_022_005",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T21:00:00+09:00",
        durationSeconds: 7165,
        score: 2040,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_022_006",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T20:00:00+09:00",
        durationSeconds: 10315,
        score: 7988,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_022_007",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T23:00:00+09:00",
        durationSeconds: 9903,
        score: 5300,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_022_008",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T22:00:00+09:00",
        durationSeconds: 8465,
        score: 1083,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_022_009",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-01T23:00:00+09:00",
        durationSeconds: 1368,
        score: 3324,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_022_010",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 6356,
        score: 8935,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_022_011",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-18T20:00:00+09:00",
        durationSeconds: 1286,
        score: 675,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_022_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 1207,
        score: 7919,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "23",
    channelId: "UC_mock_023",
    name: "朱雀アカネ",
    description: "企業勢VTuberとして歌枠を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V023",
    bannerUrl: "https://placehold.co/640x180?text=V023",
    youtubeUrl: "https://www.youtube.com/@example-v023",
    subscriberCount: 7066,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_multicolor", approved: false },
      { value: "eye_blue", approved: false },
      { value: "hair_length_short", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_husky", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "genre_singing", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_chaotic", approved: true },
      { value: "personality_funny", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_high", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_023_001",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T23:00:00+09:00",
        durationSeconds: 2954,
        score: 762,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_002",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-24T20:00:00+09:00",
        durationSeconds: 2741,
        score: 1663,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-10T20:00:00+09:00",
        durationSeconds: 1319,
        score: 7019,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_004",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-03T20:00:00+09:00",
        durationSeconds: 1217,
        score: 5834,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_005",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-26T21:00:00+09:00",
        durationSeconds: 1206,
        score: 8230,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_006",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-19T23:00:00+09:00",
        durationSeconds: 2397,
        score: 6276,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_007",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-12T18:00:00+09:00",
        durationSeconds: 2851,
        score: 3745,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-29T20:00:00+09:00",
        durationSeconds: 1544,
        score: 2759,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_009",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-22T19:00:00+09:00",
        durationSeconds: 3552,
        score: 4331,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_023_010",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-15T21:00:00+09:00",
        durationSeconds: 1291,
        score: 1555,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "24",
    channelId: "UC_mock_024",
    name: "桜庭テツヤ",
    description: "同時視聴配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V024",
    bannerUrl: "https://placehold.co/640x180?text=V024",
    youtubeUrl: "https://www.youtube.com/@example-v024",
    subscriberCount: 399134,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_zh", approved: false },
      { value: "model_png", approved: true },
      { value: "hair_silver", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_cute", approved: false },
      { value: "voice_androgynous", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_relaxing", approved: true },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_afternoon",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_friday", approved: false },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_024_001",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T23:00:00+09:00",
        durationSeconds: 3565,
        score: 9340,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_023",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-08-02T18:00:00+09:00",
        durationSeconds: 1402,
        score: 2734,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_014",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 2636,
        score: 6771,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_013",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 3324,
        score: 4598,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_002",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 2657,
        score: 7029,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_024",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-26T18:00:00+09:00",
        durationSeconds: 8467,
        score: 9391,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_015",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-24T20:00:00+09:00",
        durationSeconds: 3174,
        score: 3651,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 3514,
        score: 3558,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_025",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-19T21:00:00+09:00",
        durationSeconds: 4266,
        score: 4301,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_004",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T22:00:00+09:00",
        durationSeconds: 1701,
        score: 3970,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_026",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 2636,
        score: 2779,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_016",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-10T19:00:00+09:00",
        durationSeconds: 4520,
        score: 3370,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_005",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T21:00:00+09:00",
        durationSeconds: 7827,
        score: 9627,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_027",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-05T22:00:00+09:00",
        durationSeconds: 5215,
        score: 9390,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_017",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-03T23:00:00+09:00",
        durationSeconds: 3038,
        score: 5605,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_006",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 3259,
        score: 6862,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_028",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-28T21:00:00+09:00",
        durationSeconds: 2013,
        score: 4847,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_018",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-26T21:00:00+09:00",
        durationSeconds: 3622,
        score: 2389,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_007",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T23:00:00+09:00",
        durationSeconds: 1305,
        score: 2736,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_029",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-21T21:00:00+09:00",
        durationSeconds: 5318,
        score: 7677,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_019",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-19T18:00:00+09:00",
        durationSeconds: 5748,
        score: 6575,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_008",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T20:00:00+09:00",
        durationSeconds: 6088,
        score: 4832,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_030",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-14T21:00:00+09:00",
        durationSeconds: 7646,
        score: 6008,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_009",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-08T18:00:00+09:00",
        durationSeconds: 1425,
        score: 1226,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_031",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-07T23:00:00+09:00",
        durationSeconds: 1371,
        score: 3623,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_010",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-01T22:00:00+09:00",
        durationSeconds: 5339,
        score: 1853,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_032",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-31T22:00:00+09:00",
        durationSeconds: 2130,
        score: 8465,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_020",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-29T18:00:00+09:00",
        durationSeconds: 6758,
        score: 1986,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_011",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-25T20:00:00+09:00",
        durationSeconds: 2169,
        score: 1824,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_033",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-24T23:00:00+09:00",
        durationSeconds: 7409,
        score: 6067,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_021",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 5146,
        score: 8014,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_034",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-17T22:00:00+09:00",
        durationSeconds: 2215,
        score: 7849,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_022",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-15T20:00:00+09:00",
        durationSeconds: 7484,
        score: 4811,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_024_012",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-11T23:00:00+09:00",
        durationSeconds: 2330,
        score: 4133,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_024_035",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-10T22:00:00+09:00",
        durationSeconds: 1560,
        score: 7226,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "25",
    channelId: "UC_mock_025",
    name: "桜庭ツキ",
    description: "歌枠をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V025",
    bannerUrl: "https://placehold.co/640x180?text=V025",
    youtubeUrl: "https://www.youtube.com/@example-v025",
    subscriberCount: 6887,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_black", approved: true },
      { value: "eye_black", approved: false },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_very_high", approved: false },
      { value: "voice_husky", approved: true },
      { value: "voice_mature", approved: true },
      { value: "genre_singing", approved: true },
      { value: "genre_study", approved: false },
      { value: "personality_cool", approved: true },
      // stream_collab,
      // stream_long
      // "stream_time_midnight",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_025_002",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T21:00:00+09:00",
        durationSeconds: 6535,
        score: 9168,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_001",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T21:00:00+09:00",
        durationSeconds: 2722,
        score: 9165,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_011",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-29T23:00:00+09:00",
        durationSeconds: 3568,
        score: 2563,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_003",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T22:00:00+09:00",
        durationSeconds: 2013,
        score: 8393,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_012",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-22T19:00:00+09:00",
        durationSeconds: 7908,
        score: 5623,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_004",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T21:00:00+09:00",
        durationSeconds: 3558,
        score: 6874,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_013",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-15T22:00:00+09:00",
        durationSeconds: 2132,
        score: 9163,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_005",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 3559,
        score: 7270,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-08T20:00:00+09:00",
        durationSeconds: 6024,
        score: 7494,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_006",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-03T22:00:00+09:00",
        durationSeconds: 1382,
        score: 3916,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_015",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-01T22:00:00+09:00",
        durationSeconds: 7102,
        score: 4347,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-26T22:00:00+09:00",
        durationSeconds: 6804,
        score: 1464,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_016",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-24T22:00:00+09:00",
        durationSeconds: 5694,
        score: 7551,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 2884,
        score: 9026,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_017",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-17T22:00:00+09:00",
        durationSeconds: 3029,
        score: 1543,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_018",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-10T22:00:00+09:00",
        durationSeconds: 4708,
        score: 1846,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_009",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-05T20:00:00+09:00",
        durationSeconds: 5481,
        score: 1652,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_019",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-03T22:00:00+09:00",
        durationSeconds: 8435,
        score: 9016,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_025_010",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-29T22:00:00+09:00",
        durationSeconds: 2006,
        score: 633,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_025_020",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-20T20:00:00+09:00",
        durationSeconds: 10059,
        score: 5766,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "26",
    channelId: "UC_mock_026",
    name: "夜久そら",
    description: "歌枠をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V026",
    bannerUrl: "https://placehold.co/640x180?text=V026",
    youtubeUrl: "https://www.youtube.com/@example-v026",
    subscriberCount: 62116,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_blonde", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_cute", approved: false },
      { value: "genre_singing", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_fps", approved: false },
      { value: "game_horror", approved: true },
      { value: "personality_chaotic", approved: true },
      // stream_viewer_partcition,
      // "stream_time_evening",
      { value: "stream_frequency_high", approved: false },
      { value: "day_thursday", approved: true },
      { value: "day_wednesday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_026_002",
        title: "【FPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-30T20:00:00+09:00",
        durationSeconds: 3691,
        score: 7327,
        attributes: [
          "genre_game",
          "game_fps",
        ],
      },
      {
        videoId: "mock_video_026_001",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T19:00:00+09:00",
        durationSeconds: 2839,
        score: 5187,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_014",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-29T18:00:00+09:00",
        durationSeconds: 2589,
        score: 1046,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-23T19:00:00+09:00",
        durationSeconds: 3051,
        score: 4861,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_015",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-22T23:00:00+09:00",
        durationSeconds: 1898,
        score: 4485,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_004",
        title: "【ホラーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-16T18:00:00+09:00",
        durationSeconds: 5579,
        score: 7063,
        attributes: [
          "genre_game",
          "game_fps",
        ],
      },
      {
        videoId: "mock_video_026_016",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-15T19:00:00+09:00",
        durationSeconds: 1709,
        score: 9078,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_005",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-09T22:00:00+09:00",
        durationSeconds: 1757,
        score: 9544,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_017",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-08T20:00:00+09:00",
        durationSeconds: 2331,
        score: 6793,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_006",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-02T18:00:00+09:00",
        durationSeconds: 2632,
        score: 543,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_018",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-07-01T18:00:00+09:00",
        durationSeconds: 2877,
        score: 4739,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_007",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-25T21:00:00+09:00",
        durationSeconds: 1883,
        score: 2553,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_019",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-24T22:00:00+09:00",
        durationSeconds: 1204,
        score: 3887,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_008",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 1310,
        score: 2322,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_020",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-17T20:00:00+09:00",
        durationSeconds: 3247,
        score: 3550,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_009",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-11T21:00:00+09:00",
        durationSeconds: 1666,
        score: 6081,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_021",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-10T20:00:00+09:00",
        durationSeconds: 2571,
        score: 5817,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_010",
        title: "【ホラーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-04T19:00:00+09:00",
        durationSeconds: 6601,
        score: 2320,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_026_022",
        title: "【FPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-06-03T23:00:00+09:00",
        durationSeconds: 6588,
        score: 4786,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_026_011",
        title: "【ホラーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-28T21:00:00+09:00",
        durationSeconds: 5175,
        score: 4759,
        attributes: [
          "genre_game",
          "game_fps",
        ],
      },
      {
        videoId: "mock_video_026_023",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-27T20:00:00+09:00",
        durationSeconds: 2884,
        score: 4778,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_012",
        title: "【ホラーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-21T21:00:00+09:00",
        durationSeconds: 1858,
        score: 4947,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_026_024",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-20T19:00:00+09:00",
        durationSeconds: 2813,
        score: 8749,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_013",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-14T19:00:00+09:00",
        durationSeconds: 2928,
        score: 9346,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_026_025",
        title: "【FPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-05-13T23:00:00+09:00",
        durationSeconds: 2058,
        score: 3214,
        attributes: [
          "genre_game",
          "game_fps",
        ],
      }
    ],
  },
  {
    id: "27",
    channelId: "UC_mock_027",
    name: "朱雀そら",
    description: "ゲーム配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V027",
    bannerUrl: "https://placehold.co/640x180?text=V027",
    youtubeUrl: "https://www.youtube.com/@example-v027",
    subscriberCount: 4027,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_silver", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_medium", approved: false },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "genre_game", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "game_retro", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_gentle", approved: true },
      // stream_viewer_partcition,
      // "stream_time_evening",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_sunday", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_027_001",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-02T18:00:00+09:00",
        durationSeconds: 1940,
        score: 8245,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_013",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 3011,
        score: 188,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_014",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-08-01T19:00:00+09:00",
        durationSeconds: 4175,
        score: 2824,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_002",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-26T20:00:00+09:00",
        durationSeconds: 3194,
        score: 9106,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_015",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-25T20:00:00+09:00",
        durationSeconds: 2429,
        score: 1517,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_003",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-19T19:00:00+09:00",
        durationSeconds: 6945,
        score: 8816,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_004",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 5221,
        score: 3863,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_016",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-11T22:00:00+09:00",
        durationSeconds: 5703,
        score: 8631,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_005",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-05T19:00:00+09:00",
        durationSeconds: 6448,
        score: 781,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_017",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 4252,
        score: 7230,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_006",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-28T23:00:00+09:00",
        durationSeconds: 3269,
        score: 1793,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_007",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-21T22:00:00+09:00",
        durationSeconds: 4388,
        score: 188,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_008",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-14T21:00:00+09:00",
        durationSeconds: 2700,
        score: 2888,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_009",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-07T23:00:00+09:00",
        durationSeconds: 1940,
        score: 3291,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_018",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 2018,
        score: 6640,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_010",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-31T23:00:00+09:00",
        durationSeconds: 5238,
        score: 9357,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_019",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-30T23:00:00+09:00",
        durationSeconds: 4434,
        score: 6199,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_020",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-23T21:00:00+09:00",
        durationSeconds: 2427,
        score: 8319,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_011",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 2553,
        score: 7247,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_027_021",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 4748,
        score: 3592,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_027_012",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-10T23:00:00+09:00",
        durationSeconds: 6688,
        score: 1664,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      }
    ],
  },
  {
    id: "28",
    channelId: "UC_mock_028",
    name: "雪代カザマ",
    description: "料理配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V028",
    bannerUrl: "https://placehold.co/640x180?text=V028",
    youtubeUrl: "https://www.youtube.com/@example-v028",
    subscriberCount: 6993,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_gray", approved: true },
      { value: "eye_blue", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_low", approved: false },
      { value: "voice_mature", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "personality_funny", approved: true },
      // stream_collab,
      // "stream_time_evening",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_thursday", approved: false },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_028_024",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-08-05T18:00:00+09:00",
        durationSeconds: 1172,
        score: 566,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_001",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T22:00:00+09:00",
        durationSeconds: 2197,
        score: 5539,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_013",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-30T22:00:00+09:00",
        durationSeconds: 2221,
        score: 3062,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_014",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 948,
        score: 7626,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_025",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-29T20:00:00+09:00",
        durationSeconds: 1765,
        score: 2396,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_002",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 1957,
        score: 2690,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_015",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-23T21:00:00+09:00",
        durationSeconds: 1565,
        score: 6150,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_026",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-22T20:00:00+09:00",
        durationSeconds: 1257,
        score: 9560,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_003",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T23:00:00+09:00",
        durationSeconds: 2280,
        score: 9823,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_016",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-16T22:00:00+09:00",
        durationSeconds: 1043,
        score: 7007,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_027",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-15T18:00:00+09:00",
        durationSeconds: 1705,
        score: 2984,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_028",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-08T22:00:00+09:00",
        durationSeconds: 2335,
        score: 6177,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_004",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T22:00:00+09:00",
        durationSeconds: 2038,
        score: 5211,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_017",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-02T21:00:00+09:00",
        durationSeconds: 1772,
        score: 8678,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_005",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-29T18:00:00+09:00",
        durationSeconds: 1166,
        score: 5564,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_018",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-25T22:00:00+09:00",
        durationSeconds: 1243,
        score: 3616,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_029",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 1768,
        score: 8736,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_006",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-22T23:00:00+09:00",
        durationSeconds: 920,
        score: 5441,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_019",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 1121,
        score: 5034,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_030",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-17T20:00:00+09:00",
        durationSeconds: 1069,
        score: 5151,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_007",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-15T23:00:00+09:00",
        durationSeconds: 2020,
        score: 7193,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_020",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-11T23:00:00+09:00",
        durationSeconds: 2037,
        score: 3030,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_008",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 1904,
        score: 9470,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_021",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-04T18:00:00+09:00",
        durationSeconds: 2145,
        score: 7489,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_031",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-03T19:00:00+09:00",
        durationSeconds: 1170,
        score: 3306,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_009",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-01T20:00:00+09:00",
        durationSeconds: 2274,
        score: 7904,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_022",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-28T21:00:00+09:00",
        durationSeconds: 1872,
        score: 6260,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_032",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-27T22:00:00+09:00",
        durationSeconds: 2100,
        score: 7251,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_010",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-25T23:00:00+09:00",
        durationSeconds: 1862,
        score: 7996,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_033",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-20T22:00:00+09:00",
        durationSeconds: 2209,
        score: 4881,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_011",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-18T23:00:00+09:00",
        durationSeconds: 1400,
        score: 6495,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_023",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-14T19:00:00+09:00",
        durationSeconds: 1636,
        score: 5807,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_034",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-13T22:00:00+09:00",
        durationSeconds: 2139,
        score: 6902,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_028_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 1946,
        score: 1331,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "29",
    channelId: "UC_mock_029",
    name: "藍原そら",
    description: "同時視聴配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V029",
    bannerUrl: "https://placehold.co/640x180?text=V029",
    youtubeUrl: "https://www.youtube.com/@example-v029",
    subscriberCount: 1204479,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_gray", approved: true },
      { value: "eye_yellow", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_middle", approved: false },
      { value: "voice_powerful", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "genre_watchalong", approved: true },
      { value: "genre_study", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_cool", approved: true },
      { value: "personality_chaotic", approved: true },
      // "stream_time_early_morning",
      { value: "stream_frequency_daily", approved: false },
      { value: "day_monday", approved: true },
      { value: "day_thursday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_029_001",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T21:00:00+09:00",
        durationSeconds: 10402,
        score: 3822,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_021",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-08-02T21:00:00+09:00",
        durationSeconds: 9740,
        score: 375,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_013",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-30T22:00:00+09:00",
        durationSeconds: 6248,
        score: 1213,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_012",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 6921,
        score: 5156,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_002",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 9690,
        score: 652,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_022",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-26T18:00:00+09:00",
        durationSeconds: 5863,
        score: 2677,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_023",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-19T23:00:00+09:00",
        durationSeconds: 7887,
        score: 1630,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_014",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-16T23:00:00+09:00",
        durationSeconds: 4199,
        score: 4507,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_003",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-13T18:00:00+09:00",
        durationSeconds: 8369,
        score: 4852,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_024",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-12T18:00:00+09:00",
        durationSeconds: 5204,
        score: 1353,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_015",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-09T22:00:00+09:00",
        durationSeconds: 6800,
        score: 2929,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_004",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T20:00:00+09:00",
        durationSeconds: 4204,
        score: 9847,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_025",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-05T20:00:00+09:00",
        durationSeconds: 8184,
        score: 4131,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_016",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-02T20:00:00+09:00",
        durationSeconds: 8751,
        score: 9718,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_026",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-28T20:00:00+09:00",
        durationSeconds: 5163,
        score: 211,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_005",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-22T18:00:00+09:00",
        durationSeconds: 8474,
        score: 9519,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_027",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-21T22:00:00+09:00",
        durationSeconds: 7313,
        score: 1893,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_017",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-18T23:00:00+09:00",
        durationSeconds: 3900,
        score: 625,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_006",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-15T19:00:00+09:00",
        durationSeconds: 6786,
        score: 7086,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_028",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-14T19:00:00+09:00",
        durationSeconds: 7264,
        score: 8420,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_018",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-11T18:00:00+09:00",
        durationSeconds: 9339,
        score: 4898,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_007",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-08T22:00:00+09:00",
        durationSeconds: 4024,
        score: 5818,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_029",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-07T18:00:00+09:00",
        durationSeconds: 4621,
        score: 663,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_019",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-04T18:00:00+09:00",
        durationSeconds: 6790,
        score: 3566,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_008",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-01T20:00:00+09:00",
        durationSeconds: 6266,
        score: 1590,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_030",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-31T19:00:00+09:00",
        durationSeconds: 4981,
        score: 5828,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_020",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-28T23:00:00+09:00",
        durationSeconds: 7066,
        score: 5523,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_009",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-25T20:00:00+09:00",
        durationSeconds: 5511,
        score: 2003,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_010",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T20:00:00+09:00",
        durationSeconds: 3926,
        score: 8961,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_029_031",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-17T23:00:00+09:00",
        durationSeconds: 3629,
        score: 5938,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_011",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T20:00:00+09:00",
        durationSeconds: 9737,
        score: 3486,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_029_032",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-10T23:00:00+09:00",
        durationSeconds: 3939,
        score: 5632,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "30",
    channelId: "UC_mock_030",
    name: "紅葉リン",
    description: "個人勢VTuberとしてゲーム配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V030",
    bannerUrl: "https://placehold.co/640x180?text=V030",
    youtubeUrl: "https://www.youtube.com/@example-v030",
    subscriberCount: 9669,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: false },
      { value: "model_live2d", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_light_green", approved: false },
      { value: "eye_brown", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "accessory_tail", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_fps", approved: true },
      { value: "game_indie", approved: true },
      { value: "personality_relaxing", approved: false },
      { value: "personality_funny", approved: false },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_early_morning",
      { value: "stream_frequency_irregular", approved: false },
      { value: "day_thursday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_030_002",
        title: "【FPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-30T23:00:00+09:00",
        durationSeconds: 7164,
        score: 4895,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_001",
        title: "【インディーゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T22:00:00+09:00",
        durationSeconds: 6070,
        score: 5629,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_003",
        title: "【FPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-23T23:00:00+09:00",
        durationSeconds: 5392,
        score: 9981,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_004",
        title: "【インディーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-09T22:00:00+09:00",
        durationSeconds: 6511,
        score: 7836,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_005",
        title: "【FPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-25T20:00:00+09:00",
        durationSeconds: 6376,
        score: 6872,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_006",
        title: "【インディーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-11T23:00:00+09:00",
        durationSeconds: 3282,
        score: 6082,
        attributes: [
          "genre_game",
          "game_fps",
        ],
      },
      {
        videoId: "mock_video_030_007",
        title: "【インディーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-04T21:00:00+09:00",
        durationSeconds: 2733,
        score: 6041,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_008",
        title: "【FPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-28T23:00:00+09:00",
        durationSeconds: 5067,
        score: 8089,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_009",
        title: "【インディーゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-21T21:00:00+09:00",
        durationSeconds: 5276,
        score: 1878,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_030_010",
        title: "【FPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-14T22:00:00+09:00",
        durationSeconds: 5388,
        score: 4402,
        attributes: [
          "genre_game",
          "game_fps",
        ],
      }
    ],
  },
  {
    id: "31",
    channelId: "UC_mock_031",
    name: "薄羽カエデ",
    description: "歌枠をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V031",
    bannerUrl: "https://placehold.co/640x180?text=V031",
    youtubeUrl: "https://www.youtube.com/@example-v031",
    subscriberCount: 964337,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_light_green", approved: true },
      { value: "eye_yellow", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_animal_ears", approved: true },
      { value: "accessory_wings", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_cute", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_natural", approved: true },
      { value: "personality_cool", approved: true },
      // stream_long
      // "stream_time_midnight",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_saturday", approved: false },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_031_001",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 1346,
        score: 4031,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_012",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 3138,
        score: 1397,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_013",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-23T18:00:00+09:00",
        durationSeconds: 2287,
        score: 5802,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-18T21:00:00+09:00",
        durationSeconds: 3486,
        score: 5119,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_014",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-16T23:00:00+09:00",
        durationSeconds: 2200,
        score: 9260,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-11T21:00:00+09:00",
        durationSeconds: 2589,
        score: 3881,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_015",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-09T20:00:00+09:00",
        durationSeconds: 2656,
        score: 5391,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_004",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-04T21:00:00+09:00",
        durationSeconds: 1327,
        score: 3261,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_016",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-02T22:00:00+09:00",
        durationSeconds: 1402,
        score: 9700,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_005",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-27T20:00:00+09:00",
        durationSeconds: 2463,
        score: 2161,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_017",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-25T23:00:00+09:00",
        durationSeconds: 1672,
        score: 8751,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_006",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 3036,
        score: 8505,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_018",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-18T20:00:00+09:00",
        durationSeconds: 2100,
        score: 6340,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_007",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-13T21:00:00+09:00",
        durationSeconds: 2774,
        score: 6568,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_019",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-11T18:00:00+09:00",
        durationSeconds: 1512,
        score: 7440,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_008",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-06T18:00:00+09:00",
        durationSeconds: 1487,
        score: 220,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_020",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-04T18:00:00+09:00",
        durationSeconds: 1493,
        score: 1067,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_009",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-30T19:00:00+09:00",
        durationSeconds: 1487,
        score: 8704,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_021",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-28T18:00:00+09:00",
        durationSeconds: 3010,
        score: 1807,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_010",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-23T19:00:00+09:00",
        durationSeconds: 2389,
        score: 3849,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_022",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-21T19:00:00+09:00",
        durationSeconds: 3240,
        score: 6772,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_011",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 2635,
        score: 9533,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_031_023",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-14T22:00:00+09:00",
        durationSeconds: 3165,
        score: 3444,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "32",
    channelId: "UC_mock_032",
    name: "黒崎アカネ",
    description: "企業勢VTuberとして歌枠を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V032",
    bannerUrl: "https://placehold.co/640x180?text=V032",
    youtubeUrl: "https://www.youtube.com/@example-v032",
    subscriberCount: 357811,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_en", approved: true },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_green", approved: true },
      { value: "eye_yellow", approved: false },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_very_high", approved: false },
      { value: "voice_soft", approved: false },
      { value: "voice_boyish", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_cool", approved: true },
      { value: "personality_energetic", approved: true },
      // "stream_time_early_morning",
      { value: "stream_frequency_low", approved: false },
      { value: "day_saturday", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_monday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_032_014",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-08-05T22:00:00+09:00",
        durationSeconds: 3264,
        score: 3776,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_001",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 1948,
        score: 7018,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 1227,
        score: 8261,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_015",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-29T23:00:00+09:00",
        durationSeconds: 2478,
        score: 2133,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_003",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T22:00:00+09:00",
        durationSeconds: 2907,
        score: 8293,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_016",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-22T21:00:00+09:00",
        durationSeconds: 3173,
        score: 4622,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_027",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 2110,
        score: 2870,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_004",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-18T22:00:00+09:00",
        durationSeconds: 2297,
        score: 8411,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_017",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-15T18:00:00+09:00",
        durationSeconds: 3484,
        score: 9050,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_028",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-13T21:00:00+09:00",
        durationSeconds: 1905,
        score: 5850,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_005",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-11T18:00:00+09:00",
        durationSeconds: 2413,
        score: 3572,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_018",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-07-08T18:00:00+09:00",
        durationSeconds: 2449,
        score: 176,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_029",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-07-06T19:00:00+09:00",
        durationSeconds: 3658,
        score: 9370,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_006",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-04T20:00:00+09:00",
        durationSeconds: 1494,
        score: 8312,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_019",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-07-01T23:00:00+09:00",
        durationSeconds: 1732,
        score: 4642,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_030",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-29T20:00:00+09:00",
        durationSeconds: 1997,
        score: 4884,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_007",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-27T23:00:00+09:00",
        durationSeconds: 2806,
        score: 6674,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_020",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-24T21:00:00+09:00",
        durationSeconds: 1311,
        score: 2909,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_031",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-22T19:00:00+09:00",
        durationSeconds: 3448,
        score: 4927,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-20T19:00:00+09:00",
        durationSeconds: 1471,
        score: 9560,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_021",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-17T22:00:00+09:00",
        durationSeconds: 3146,
        score: 3329,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_032",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-15T21:00:00+09:00",
        durationSeconds: 2209,
        score: 2131,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_009",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-13T19:00:00+09:00",
        durationSeconds: 2219,
        score: 1103,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_022",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-06-10T18:00:00+09:00",
        durationSeconds: 1204,
        score: 646,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_033",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-06-08T19:00:00+09:00",
        durationSeconds: 1337,
        score: 2643,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_010",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 3288,
        score: 3257,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_023",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-06-03T22:00:00+09:00",
        durationSeconds: 3150,
        score: 9566,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_034",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-06-01T18:00:00+09:00",
        durationSeconds: 3145,
        score: 398,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_011",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-30T21:00:00+09:00",
        durationSeconds: 3109,
        score: 6216,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_024",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-27T18:00:00+09:00",
        durationSeconds: 1863,
        score: 393,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_035",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 2212,
        score: 5698,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_012",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-23T23:00:00+09:00",
        durationSeconds: 2011,
        score: 9316,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_025",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-05-20T22:00:00+09:00",
        durationSeconds: 2615,
        score: 612,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_036",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream36",
        startedAt: "2026-05-18T21:00:00+09:00",
        durationSeconds: 2462,
        score: 3216,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_013",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-16T22:00:00+09:00",
        durationSeconds: 3432,
        score: 198,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_026",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-05-13T23:00:00+09:00",
        durationSeconds: 2834,
        score: 4315,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_032_037",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream37",
        startedAt: "2026-05-11T20:00:00+09:00",
        durationSeconds: 3212,
        score: 688,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "33",
    channelId: "UC_mock_033",
    name: "夜久ウツギ",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V033",
    bannerUrl: "https://placehold.co/640x180?text=V033",
    youtubeUrl: "https://www.youtube.com/@example-v033",
    subscriberCount: 607352,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_navy", approved: true },
      { value: "eye_black", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_wings", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_soft", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "genre_other", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_chaotic", approved: false },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_morning",
      { value: "stream_frequency_low", approved: false },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_033_001",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T23:00:00+09:00",
        durationSeconds: 1494,
        score: 1122,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_033_002",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T22:00:00+09:00",
        durationSeconds: 10615,
        score: 4755,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_033_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T23:00:00+09:00",
        durationSeconds: 4905,
        score: 2094,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_033_004",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T22:00:00+09:00",
        durationSeconds: 4234,
        score: 2561,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_033_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T20:00:00+09:00",
        durationSeconds: 10808,
        score: 1157,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_033_006",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 3273,
        score: 6797,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_033_007",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T18:00:00+09:00",
        durationSeconds: 2836,
        score: 9230,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_033_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T19:00:00+09:00",
        durationSeconds: 7698,
        score: 4507,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_033_009",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-08T18:00:00+09:00",
        durationSeconds: 5129,
        score: 2643,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_033_010",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-01T22:00:00+09:00",
        durationSeconds: 4139,
        score: 7091,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_033_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-25T19:00:00+09:00",
        durationSeconds: 5370,
        score: 4361,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "34",
    channelId: "UC_mock_034",
    name: "星宮つむぎ",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V034",
    bannerUrl: "https://placehold.co/640x180?text=V034",
    youtubeUrl: "https://www.youtube.com/@example-v034",
    subscriberCount: 1426451,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_brown", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_halo", approved: false },
      { value: "accessory_glasses", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "personality_calm", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_034_001",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-26T23:00:00+09:00",
        durationSeconds: 8973,
        score: 6329,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_002",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-19T19:00:00+09:00",
        durationSeconds: 7858,
        score: 65,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-12T19:00:00+09:00",
        durationSeconds: 10342,
        score: 2877,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_004",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-05T20:00:00+09:00",
        durationSeconds: 4458,
        score: 1294,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_005",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-28T19:00:00+09:00",
        durationSeconds: 9362,
        score: 115,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_006",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-21T19:00:00+09:00",
        durationSeconds: 4327,
        score: 614,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_007",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-07T19:00:00+09:00",
        durationSeconds: 8912,
        score: 9877,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_008",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-24T23:00:00+09:00",
        durationSeconds: 6821,
        score: 2021,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_009",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 5189,
        score: 6147,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_034_010",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-10T20:00:00+09:00",
        durationSeconds: 10301,
        score: 4391,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "35",
    channelId: "UC_mock_035",
    name: "空木リン",
    description: "個人勢VTuberとして作業配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V035",
    bannerUrl: "https://placehold.co/640x180?text=V035",
    youtubeUrl: "https://www.youtube.com/@example-v035",
    subscriberCount: 270432,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: false },
      { value: "hair_brown", approved: true },
      { value: "eye_green", approved: false },
      { value: "hair_length_long", approved: false },
      { value: "accessory_hat", approved: true },
      { value: "accessory_animal_ears", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_mature", approved: true },
      { value: "genre_study", approved: true },
      { value: "genre_other", approved: true },
      { value: "personality_gentle", approved: true },
      // "stream_time_morning",
      { value: "stream_frequency_low", approved: true },
      { value: "day_thursday", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_035_012",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 7680,
        score: 2211,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_001",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T23:00:00+09:00",
        durationSeconds: 1680,
        score: 4699,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_022",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-27T22:00:00+09:00",
        durationSeconds: 10423,
        score: 3033,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_013",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-24T22:00:00+09:00",
        durationSeconds: 5778,
        score: 7648,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_023",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-20T19:00:00+09:00",
        durationSeconds: 2029,
        score: 812,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-17T22:00:00+09:00",
        durationSeconds: 10604,
        score: 4420,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_002",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-16T20:00:00+09:00",
        durationSeconds: 9447,
        score: 6757,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_024",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-13T21:00:00+09:00",
        durationSeconds: 1394,
        score: 603,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_015",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-10T21:00:00+09:00",
        durationSeconds: 1854,
        score: 3394,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_003",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-09T20:00:00+09:00",
        durationSeconds: 3129,
        score: 6736,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_025",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-06T19:00:00+09:00",
        durationSeconds: 1997,
        score: 2194,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_016",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-03T23:00:00+09:00",
        durationSeconds: 2997,
        score: 7813,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_004",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-02T21:00:00+09:00",
        durationSeconds: 3624,
        score: 959,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_005",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-25T23:00:00+09:00",
        durationSeconds: 2284,
        score: 5721,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_017",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 2304,
        score: 3637,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_006",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-18T21:00:00+09:00",
        durationSeconds: 5905,
        score: 232,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_026",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-15T23:00:00+09:00",
        durationSeconds: 3315,
        score: 1588,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_018",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-12T23:00:00+09:00",
        durationSeconds: 1084,
        score: 700,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_007",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-11T21:00:00+09:00",
        durationSeconds: 3473,
        score: 4743,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_027",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 5758,
        score: 858,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_019",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-05T22:00:00+09:00",
        durationSeconds: 10150,
        score: 3152,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_008",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-04T22:00:00+09:00",
        durationSeconds: 3169,
        score: 348,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_020",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-29T18:00:00+09:00",
        durationSeconds: 3083,
        score: 9480,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_009",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-28T18:00:00+09:00",
        durationSeconds: 5294,
        score: 6740,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_028",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-05-25T23:00:00+09:00",
        durationSeconds: 3169,
        score: 7640,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_010",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-21T18:00:00+09:00",
        durationSeconds: 3301,
        score: 8982,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_029",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-18T23:00:00+09:00",
        durationSeconds: 7400,
        score: 5708,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_035_021",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 1981,
        score: 7390,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_011",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-14T23:00:00+09:00",
        durationSeconds: 2273,
        score: 3812,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_035_030",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-11T19:00:00+09:00",
        durationSeconds: 990,
        score: 1616,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "36",
    channelId: "UC_mock_036",
    name: "月城ギンガ",
    description: "作業配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V036",
    bannerUrl: "https://placehold.co/640x180?text=V036",
    youtubeUrl: "https://www.youtube.com/@example-v036",
    subscriberCount: 691539,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_en", approved: false },
      { value: "model_live2d", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_light_blue", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_wings", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_mature", approved: true },
      { value: "genre_study", approved: true },
      { value: "genre_singing", approved: false },
      { value: "personality_relaxing", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_afternoon",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_thursday", approved: true },
      { value: "day_sunday", approved: false },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_036_023",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-08-04T23:00:00+09:00",
        durationSeconds: 7849,
        score: 7245,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_012",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-02T19:00:00+09:00",
        durationSeconds: 8213,
        score: 6041,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_001",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 3306,
        score: 6707,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_024",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-28T18:00:00+09:00",
        durationSeconds: 2650,
        score: 8145,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_013",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-26T21:00:00+09:00",
        durationSeconds: 10699,
        score: 60,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_002",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-23T19:00:00+09:00",
        durationSeconds: 4842,
        score: 8756,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_025",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-21T22:00:00+09:00",
        durationSeconds: 3232,
        score: 8755,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_003",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-16T22:00:00+09:00",
        durationSeconds: 1978,
        score: 4895,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-12T21:00:00+09:00",
        durationSeconds: 5235,
        score: 6383,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_004",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-09T19:00:00+09:00",
        durationSeconds: 8398,
        score: 836,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_026",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-07T22:00:00+09:00",
        durationSeconds: 5860,
        score: 3750,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_015",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-05T22:00:00+09:00",
        durationSeconds: 8717,
        score: 4807,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_027",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-30T20:00:00+09:00",
        durationSeconds: 4295,
        score: 2124,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_016",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-28T18:00:00+09:00",
        durationSeconds: 2539,
        score: 1854,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_005",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-25T19:00:00+09:00",
        durationSeconds: 2696,
        score: 9133,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_028",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-23T19:00:00+09:00",
        durationSeconds: 9789,
        score: 4922,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_017",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-21T18:00:00+09:00",
        durationSeconds: 6758,
        score: 9358,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_006",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 9081,
        score: 2138,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_029",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-16T22:00:00+09:00",
        durationSeconds: 1418,
        score: 4446,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_018",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-14T22:00:00+09:00",
        durationSeconds: 1616,
        score: 7419,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-11T20:00:00+09:00",
        durationSeconds: 8458,
        score: 1501,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_019",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-07T20:00:00+09:00",
        durationSeconds: 2843,
        score: 8833,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_008",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-04T18:00:00+09:00",
        durationSeconds: 3044,
        score: 1742,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_020",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-31T21:00:00+09:00",
        durationSeconds: 2900,
        score: 5398,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_009",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-28T22:00:00+09:00",
        durationSeconds: 6949,
        score: 4012,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_030",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-26T21:00:00+09:00",
        durationSeconds: 4737,
        score: 8783,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_021",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-24T21:00:00+09:00",
        durationSeconds: 8900,
        score: 628,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_010",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-21T22:00:00+09:00",
        durationSeconds: 2188,
        score: 4144,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_031",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-19T23:00:00+09:00",
        durationSeconds: 9164,
        score: 8085,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_011",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-14T19:00:00+09:00",
        durationSeconds: 6049,
        score: 7732,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_036_032",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 3616,
        score: 4323,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_036_022",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-10T19:00:00+09:00",
        durationSeconds: 3192,
        score: 713,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "37",
    channelId: "UC_mock_037",
    name: "夜久シズク",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V037",
    bannerUrl: "https://placehold.co/640x180?text=V037",
    youtubeUrl: "https://www.youtube.com/@example-v037",
    subscriberCount: 703,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: false },
      { value: "hair_navy", approved: true },
      { value: "eye_brown", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_androgynous", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "personality_calm", approved: true },
      // stream_long
      // "stream_time_afternoon",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_037_001",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T23:00:00+09:00",
        durationSeconds: 7990,
        score: 2025,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_037_002",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-29T20:00:00+09:00",
        durationSeconds: 5956,
        score: 447,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_037_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-22T18:00:00+09:00",
        durationSeconds: 9316,
        score: 7053,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_037_004",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-15T22:00:00+09:00",
        durationSeconds: 5922,
        score: 2172,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_037_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-08T22:00:00+09:00",
        durationSeconds: 4081,
        score: 5421,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_037_006",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 4353,
        score: 6259,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_037_007",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 5552,
        score: 7522,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_037_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-17T21:00:00+09:00",
        durationSeconds: 6161,
        score: 7283,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_037_009",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-10T19:00:00+09:00",
        durationSeconds: 5723,
        score: 1464,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_037_010",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-03T18:00:00+09:00",
        durationSeconds: 9055,
        score: 8379,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_037_011",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-27T21:00:00+09:00",
        durationSeconds: 5267,
        score: 5708,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_037_012",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-13T20:00:00+09:00",
        durationSeconds: 6613,
        score: 6276,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "38",
    channelId: "UC_mock_038",
    name: "花城サクラ",
    description: "個人勢VTuberとして歌枠を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V038",
    bannerUrl: "https://placehold.co/640x180?text=V038",
    youtubeUrl: "https://www.youtube.com/@example-v038",
    subscriberCount: 62203,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_orange", approved: true },
      { value: "eye_orange", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_middle", approved: false },
      { value: "voice_boyish", approved: true },
      { value: "voice_cool", approved: true },
      { value: "genre_singing", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_horror", approved: true },
      { value: "game_retro", approved: true },
      { value: "personality_cheerful", approved: false },
      { value: "personality_energetic", approved: false },
      // "stream_time_midnight",
      { value: "stream_frequency_low", approved: true },
      { value: "day_saturday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_038_001",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 2013,
        score: 9644,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_038_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-25T21:00:00+09:00",
        durationSeconds: 2575,
        score: 4550,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_038_003",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-11T21:00:00+09:00",
        durationSeconds: 1539,
        score: 5327,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_038_004",
        title: "【ホラーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-04T23:00:00+09:00",
        durationSeconds: 4903,
        score: 7568,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_038_005",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-27T18:00:00+09:00",
        durationSeconds: 1861,
        score: 494,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_038_006",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-20T23:00:00+09:00",
        durationSeconds: 3196,
        score: 6372,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_038_007",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 1290,
        score: 5106,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_038_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-23T23:00:00+09:00",
        durationSeconds: 2162,
        score: 3041,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_038_009",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-16T23:00:00+09:00",
        durationSeconds: 1809,
        score: 7092,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "39",
    channelId: "UC_mock_039",
    name: "藍原カザマ",
    description: "ゲーム配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V039",
    bannerUrl: "https://placehold.co/640x180?text=V039",
    youtubeUrl: "https://www.youtube.com/@example-v039",
    subscriberCount: 1253602,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_blue", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_medium", approved: false },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_game", approved: false },
      { value: "genre_other", approved: true },
      { value: "game_puzzle", approved: true },
      { value: "personality_cheerful", approved: false },
      { value: "personality_energetic", approved: true },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_afternoon",
      { value: "stream_frequency_high", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_039_001",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T21:00:00+09:00",
        durationSeconds: 2058,
        score: 2117,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_020",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-08-02T21:00:00+09:00",
        durationSeconds: 2813,
        score: 9005,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_010",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-31T23:00:00+09:00",
        durationSeconds: 3076,
        score: 2942,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_021",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-07-26T21:00:00+09:00",
        durationSeconds: 2430,
        score: 124,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_011",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-24T21:00:00+09:00",
        durationSeconds: 6068,
        score: 5208,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_002",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-22T18:00:00+09:00",
        durationSeconds: 2398,
        score: 2413,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_022",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-19T19:00:00+09:00",
        durationSeconds: 2239,
        score: 3394,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_012",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-17T21:00:00+09:00",
        durationSeconds: 2682,
        score: 7860,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_003",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-15T22:00:00+09:00",
        durationSeconds: 5825,
        score: 6974,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_023",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-12T18:00:00+09:00",
        durationSeconds: 1560,
        score: 5835,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_013",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 1762,
        score: 8372,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_004",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-08T18:00:00+09:00",
        durationSeconds: 6529,
        score: 7938,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_024",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-05T20:00:00+09:00",
        durationSeconds: 4369,
        score: 3141,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_014",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-03T23:00:00+09:00",
        durationSeconds: 1135,
        score: 903,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_005",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-01T23:00:00+09:00",
        durationSeconds: 2258,
        score: 7363,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_025",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-06-28T22:00:00+09:00",
        durationSeconds: 2456,
        score: 4975,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_026",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-21T19:00:00+09:00",
        durationSeconds: 2102,
        score: 1189,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_015",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-19T18:00:00+09:00",
        durationSeconds: 2248,
        score: 5803,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_006",
        title: "【パズルゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-17T19:00:00+09:00",
        durationSeconds: 4253,
        score: 3499,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_007",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-10T22:00:00+09:00",
        durationSeconds: 7015,
        score: 15,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_027",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-07T23:00:00+09:00",
        durationSeconds: 3295,
        score: 5286,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_016",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-05T22:00:00+09:00",
        durationSeconds: 2910,
        score: 9591,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_028",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-05-31T20:00:00+09:00",
        durationSeconds: 4010,
        score: 446,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_039_017",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-29T20:00:00+09:00",
        durationSeconds: 1794,
        score: 3739,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_008",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-27T18:00:00+09:00",
        durationSeconds: 1582,
        score: 3069,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_018",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-22T19:00:00+09:00",
        durationSeconds: 1375,
        score: 1902,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_029",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-17T18:00:00+09:00",
        durationSeconds: 3264,
        score: 8321,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_019",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-15T23:00:00+09:00",
        durationSeconds: 1750,
        score: 2398,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_009",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-13T21:00:00+09:00",
        durationSeconds: 1499,
        score: 5493,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_039_030",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-10T20:00:00+09:00",
        durationSeconds: 2119,
        score: 4491,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "40",
    channelId: "UC_mock_040",
    name: "白鳥ゆき",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V040",
    bannerUrl: "https://placehold.co/640x180?text=V040",
    youtubeUrl: "https://www.youtube.com/@example-v040",
    subscriberCount: 527138,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: false },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_gray", approved: true },
      { value: "eye_pink", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "accessory_animal_ears", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_husky", approved: false },
      { value: "voice_cool", approved: false },
      { value: "genre_drawing", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_calm", approved: false },
      // "stream_time_evening",
      { value: "stream_frequency_high", approved: true },
      { value: "day_monday", approved: false },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_040_001",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T21:00:00+09:00",
        durationSeconds: 5360,
        score: 4209,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_010",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-08-02T18:00:00+09:00",
        durationSeconds: 6223,
        score: 2004,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_002",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T19:00:00+09:00",
        durationSeconds: 4383,
        score: 8526,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_040_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T23:00:00+09:00",
        durationSeconds: 4496,
        score: 1446,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_011",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-19T23:00:00+09:00",
        durationSeconds: 7480,
        score: 8430,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_004",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T20:00:00+09:00",
        durationSeconds: 8460,
        score: 4232,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_012",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-12T21:00:00+09:00",
        durationSeconds: 7659,
        score: 1467,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T21:00:00+09:00",
        durationSeconds: 8811,
        score: 8980,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_040_013",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-05T22:00:00+09:00",
        durationSeconds: 7529,
        score: 4521,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_040_014",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-28T21:00:00+09:00",
        durationSeconds: 10468,
        score: 5740,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_040_006",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-22T21:00:00+09:00",
        durationSeconds: 4429,
        score: 421,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_015",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-21T20:00:00+09:00",
        durationSeconds: 9747,
        score: 4892,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_040_007",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-15T21:00:00+09:00",
        durationSeconds: 5000,
        score: 862,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_040_016",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-14T22:00:00+09:00",
        durationSeconds: 7125,
        score: 9554,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_017",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-07T20:00:00+09:00",
        durationSeconds: 8385,
        score: 1833,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_040_018",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-31T20:00:00+09:00",
        durationSeconds: 7100,
        score: 4711,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 5242,
        score: 1241,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_019",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-24T18:00:00+09:00",
        durationSeconds: 4334,
        score: 9198,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_020",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 4648,
        score: 8328,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_040_009",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-11T22:00:00+09:00",
        durationSeconds: 4171,
        score: 2390,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "41",
    channelId: "UC_mock_041",
    name: "白鳥ライデン",
    description: "作業配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V041",
    bannerUrl: "https://placehold.co/640x180?text=V041",
    youtubeUrl: "https://www.youtube.com/@example-v041",
    subscriberCount: 2495249,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: false },
      { value: "model_png", approved: true },
      { value: "hair_black", approved: true },
      { value: "eye_yellow", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_cool", approved: true },
      { value: "genre_study", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_serious", approved: true },
      // "stream_time_midnight",
      { value: "stream_frequency_high", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_041_001",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 9622,
        score: 836,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_010",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-25T23:00:00+09:00",
        durationSeconds: 4629,
        score: 9982,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_002",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-24T20:00:00+09:00",
        durationSeconds: 6814,
        score: 3458,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_011",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 9570,
        score: 8863,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_012",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-11T21:00:00+09:00",
        durationSeconds: 6483,
        score: 1261,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_003",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-10T20:00:00+09:00",
        durationSeconds: 4058,
        score: 8929,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_013",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-06-27T20:00:00+09:00",
        durationSeconds: 10212,
        score: 8266,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_004",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-26T21:00:00+09:00",
        durationSeconds: 9567,
        score: 2124,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-20T20:00:00+09:00",
        durationSeconds: 5124,
        score: 3372,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_015",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-13T22:00:00+09:00",
        durationSeconds: 6481,
        score: 2546,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_005",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-12T20:00:00+09:00",
        durationSeconds: 9791,
        score: 7665,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_016",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-06T22:00:00+09:00",
        durationSeconds: 4532,
        score: 4135,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_006",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-05T21:00:00+09:00",
        durationSeconds: 9351,
        score: 7796,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_017",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-30T21:00:00+09:00",
        durationSeconds: 8207,
        score: 5368,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-29T21:00:00+09:00",
        durationSeconds: 9017,
        score: 1280,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_018",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-23T23:00:00+09:00",
        durationSeconds: 3842,
        score: 1151,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_008",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-22T18:00:00+09:00",
        durationSeconds: 9364,
        score: 1304,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_019",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-16T21:00:00+09:00",
        durationSeconds: 4681,
        score: 6128,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_041_009",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-15T20:00:00+09:00",
        durationSeconds: 4897,
        score: 7833,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "42",
    channelId: "UC_mock_042",
    name: "黒崎そら",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V042",
    bannerUrl: "https://placehold.co/640x180?text=V042",
    youtubeUrl: "https://www.youtube.com/@example-v042",
    subscriberCount: 41508,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_green", approved: true },
      { value: "eye_light_blue", approved: false },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_headphones", approved: false },
      { value: "accessory_tail", approved: false },
      { value: "voice_pitch_very_high", approved: false },
      { value: "voice_cute", approved: false },
      { value: "genre_drawing", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_rhythm", approved: true },
      { value: "game_horror", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_calm", approved: true },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_morning",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_042_001",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T22:00:00+09:00",
        durationSeconds: 10767,
        score: 315,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_042_002",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-29T18:00:00+09:00",
        durationSeconds: 8624,
        score: 4210,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_042_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-15T20:00:00+09:00",
        durationSeconds: 8156,
        score: 6743,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_042_004",
        title: "【ホラーゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-08T22:00:00+09:00",
        durationSeconds: 7130,
        score: 3910,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_042_005",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-01T19:00:00+09:00",
        durationSeconds: 7163,
        score: 6055,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_042_006",
        title: "【ホラーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-24T21:00:00+09:00",
        durationSeconds: 2679,
        score: 2839,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_042_007",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-17T23:00:00+09:00",
        durationSeconds: 6784,
        score: 9973,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_042_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-10T22:00:00+09:00",
        durationSeconds: 5247,
        score: 492,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_042_009",
        title: "【ホラーゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-03T23:00:00+09:00",
        durationSeconds: 4929,
        score: 2069,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_042_010",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-27T19:00:00+09:00",
        durationSeconds: 5058,
        score: 43,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_042_011",
        title: "【ホラーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-20T21:00:00+09:00",
        durationSeconds: 3603,
        score: 4778,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      }
    ],
  },
  {
    id: "43",
    channelId: "UC_mock_043",
    name: "藍原ミナヅキ",
    description: "個人勢VTuberとして歌枠を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V043",
    bannerUrl: "https://placehold.co/640x180?text=V043",
    youtubeUrl: "https://www.youtube.com/@example-v043",
    subscriberCount: 2074,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "model_3d", approved: false },
      { value: "hair_pink", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_singing", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "personality_relaxing", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_low", approved: true },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_043_001",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T19:00:00+09:00",
        durationSeconds: 1409,
        score: 9572,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_043_002",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-29T18:00:00+09:00",
        durationSeconds: 1623,
        score: 7949,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_043_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-22T22:00:00+09:00",
        durationSeconds: 2844,
        score: 2234,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_043_004",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-15T18:00:00+09:00",
        durationSeconds: 6647,
        score: 9590,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_043_005",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 2968,
        score: 5446,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_043_006",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-24T22:00:00+09:00",
        durationSeconds: 9837,
        score: 3090,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_043_007",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-10T20:00:00+09:00",
        durationSeconds: 1882,
        score: 7918,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_043_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-03T23:00:00+09:00",
        durationSeconds: 5543,
        score: 3757,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_043_009",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-27T23:00:00+09:00",
        durationSeconds: 3347,
        score: 5459,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_043_010",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-13T21:00:00+09:00",
        durationSeconds: 2333,
        score: 7416,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "44",
    channelId: "UC_mock_044",
    name: "黒崎シズク",
    description: "企業勢VTuberとしてASMR配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V044",
    bannerUrl: "https://placehold.co/640x180?text=V044",
    youtubeUrl: "https://www.youtube.com/@example-v044",
    subscriberCount: 928213,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_silver", approved: false },
      { value: "eye_pink", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "accessory_animal_ears", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_soft", approved: true },
      { value: "voice_cool", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_gentle", approved: false },
      { value: "personality_cheerful", approved: true },
      { value: "personality_energetic", approved: false },
      // stream_collab,
      // "stream_time_afternoon",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_044_002",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 3264,
        score: 1372,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_044_001",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 1811,
        score: 630,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_044_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-17T23:00:00+09:00",
        durationSeconds: 2612,
        score: 8893,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_044_004",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-10T20:00:00+09:00",
        durationSeconds: 5327,
        score: 5179,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_044_005",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-26T23:00:00+09:00",
        durationSeconds: 1611,
        score: 8717,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_044_006",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-19T19:00:00+09:00",
        durationSeconds: 2029,
        score: 3972,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_044_007",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-12T23:00:00+09:00",
        durationSeconds: 4634,
        score: 9104,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_044_008",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-05T18:00:00+09:00",
        durationSeconds: 4397,
        score: 82,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_044_009",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-29T21:00:00+09:00",
        durationSeconds: 2118,
        score: 32,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_044_010",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-22T20:00:00+09:00",
        durationSeconds: 1264,
        score: 6025,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_044_011",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 2323,
        score: 5742,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "45",
    channelId: "UC_mock_045",
    name: "風間つむぎ",
    description: "個人勢VTuberとしてASMR配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V045",
    bannerUrl: "https://placehold.co/640x180?text=V045",
    youtubeUrl: "https://www.youtube.com/@example-v045",
    subscriberCount: 948107,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_live2d", approved: false },
      { value: "model_png", approved: true },
      { value: "hair_multicolor", approved: true },
      { value: "eye_black", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "accessory_wings", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "personality_cool", approved: true },
      // "stream_time_evening",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_friday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_045_001",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T18:00:00+09:00",
        durationSeconds: 4910,
        score: 120,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_012",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-03T21:00:00+09:00",
        durationSeconds: 2274,
        score: 5580,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_022",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 5205,
        score: 9471,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_023",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-31T21:00:00+09:00",
        durationSeconds: 4972,
        score: 6304,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_002",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 5235,
        score: 432,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_013",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-27T19:00:00+09:00",
        durationSeconds: 2918,
        score: 5960,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_024",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-24T18:00:00+09:00",
        durationSeconds: 3483,
        score: 7666,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_003",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T20:00:00+09:00",
        durationSeconds: 2541,
        score: 7915,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_014",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-20T22:00:00+09:00",
        durationSeconds: 4309,
        score: 665,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_025",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-17T18:00:00+09:00",
        durationSeconds: 4010,
        score: 7131,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_004",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T18:00:00+09:00",
        durationSeconds: 1896,
        score: 8751,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_015",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-13T23:00:00+09:00",
        durationSeconds: 2665,
        score: 5665,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_026",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-10T22:00:00+09:00",
        durationSeconds: 3575,
        score: 5206,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_027",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-03T19:00:00+09:00",
        durationSeconds: 2778,
        score: 1817,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_005",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-30T20:00:00+09:00",
        durationSeconds: 3829,
        score: 1935,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_006",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-23T19:00:00+09:00",
        durationSeconds: 2472,
        score: 6505,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_016",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-22T18:00:00+09:00",
        durationSeconds: 4641,
        score: 6805,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_028",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 2614,
        score: 5655,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_017",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-15T20:00:00+09:00",
        durationSeconds: 5294,
        score: 3403,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_029",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-12T23:00:00+09:00",
        durationSeconds: 4923,
        score: 2317,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_007",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-09T18:00:00+09:00",
        durationSeconds: 2609,
        score: 5675,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_030",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-05T19:00:00+09:00",
        durationSeconds: 2763,
        score: 982,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_008",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-02T22:00:00+09:00",
        durationSeconds: 3982,
        score: 5302,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_018",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-01T21:00:00+09:00",
        durationSeconds: 4714,
        score: 9753,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_031",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-29T22:00:00+09:00",
        durationSeconds: 4687,
        score: 7318,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_009",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-26T20:00:00+09:00",
        durationSeconds: 5179,
        score: 1758,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_019",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 3412,
        score: 2296,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_032",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-22T22:00:00+09:00",
        durationSeconds: 3575,
        score: 2950,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_010",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-19T20:00:00+09:00",
        durationSeconds: 3881,
        score: 624,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_020",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-18T18:00:00+09:00",
        durationSeconds: 5091,
        score: 4506,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_033",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 3810,
        score: 7374,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_011",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-12T22:00:00+09:00",
        durationSeconds: 5023,
        score: 7781,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_045_021",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-11T23:00:00+09:00",
        durationSeconds: 3087,
        score: 8991,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "46",
    channelId: "UC_mock_046",
    name: "朱雀ウツギ",
    description: "個人勢VTuberとして料理配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V046",
    bannerUrl: "https://placehold.co/640x180?text=V046",
    youtubeUrl: "https://www.youtube.com/@example-v046",
    subscriberCount: 58993,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_red", approved: false },
      { value: "eye_red", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "accessory_wings", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_retro", approved: true },
      { value: "game_indie", approved: true },
      { value: "personality_cheerful", approved: true },
      // stream_long
      // "stream_time_night",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_sunday", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_046_022",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-08-05T20:00:00+09:00",
        durationSeconds: 7067,
        score: 6548,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_046_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-04T20:00:00+09:00",
        durationSeconds: 1342,
        score: 5166,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_001",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-02T18:00:00+09:00",
        durationSeconds: 3731,
        score: 2909,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_023",
        title: "【インディーゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-29T23:00:00+09:00",
        durationSeconds: 5253,
        score: 500,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_013",
        title: "【インディーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-28T18:00:00+09:00",
        durationSeconds: 5792,
        score: 5042,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_046_002",
        title: "【インディーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-26T22:00:00+09:00",
        durationSeconds: 4071,
        score: 6703,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_024",
        title: "【インディーゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-22T21:00:00+09:00",
        durationSeconds: 3407,
        score: 1456,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_046_014",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-21T22:00:00+09:00",
        durationSeconds: 4742,
        score: 5930,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_003",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-19T19:00:00+09:00",
        durationSeconds: 4330,
        score: 1079,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_025",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-15T22:00:00+09:00",
        durationSeconds: 2015,
        score: 4974,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_015",
        title: "【インディーゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-14T19:00:00+09:00",
        durationSeconds: 5018,
        score: 8230,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_046_004",
        title: "【インディーゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 3440,
        score: 4272,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_026",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-08T22:00:00+09:00",
        durationSeconds: 1200,
        score: 7265,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_016",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-07T23:00:00+09:00",
        durationSeconds: 3317,
        score: 6550,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_005",
        title: "【インディーゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-05T23:00:00+09:00",
        durationSeconds: 2767,
        score: 610,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_046_017",
        title: "【インディーゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-30T22:00:00+09:00",
        durationSeconds: 5376,
        score: 3547,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_027",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-24T23:00:00+09:00",
        durationSeconds: 2117,
        score: 7311,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_018",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-23T20:00:00+09:00",
        durationSeconds: 2414,
        score: 8345,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_006",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-21T20:00:00+09:00",
        durationSeconds: 1769,
        score: 5292,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_028",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-17T21:00:00+09:00",
        durationSeconds: 1346,
        score: 1492,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_029",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-10T21:00:00+09:00",
        durationSeconds: 2421,
        score: 7788,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_019",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-09T19:00:00+09:00",
        durationSeconds: 5112,
        score: 4434,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_007",
        title: "【インディーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-07T20:00:00+09:00",
        durationSeconds: 3617,
        score: 6769,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_030",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-03T18:00:00+09:00",
        durationSeconds: 6533,
        score: 826,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_008",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-31T19:00:00+09:00",
        durationSeconds: 3708,
        score: 1875,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_031",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-27T23:00:00+09:00",
        durationSeconds: 6852,
        score: 8214,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_009",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-24T22:00:00+09:00",
        durationSeconds: 913,
        score: 6348,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_032",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-20T22:00:00+09:00",
        durationSeconds: 1935,
        score: 1998,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      },
      {
        videoId: "mock_video_046_020",
        title: "【インディーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-19T18:00:00+09:00",
        durationSeconds: 5029,
        score: 447,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-17T18:00:00+09:00",
        durationSeconds: 2394,
        score: 5883,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_033",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-13T18:00:00+09:00",
        durationSeconds: 2222,
        score: 1144,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_046_021",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-12T18:00:00+09:00",
        durationSeconds: 1244,
        score: 824,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_046_011",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-10T20:00:00+09:00",
        durationSeconds: 6433,
        score: 8766,
        attributes: [
          "genre_game",
          "game_indie",
        ],
      }
    ],
  },
  {
    id: "47",
    channelId: "UC_mock_047",
    name: "風間ツキ",
    description: "お絵描き配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V047",
    bannerUrl: "https://placehold.co/640x180?text=V047",
    youtubeUrl: "https://www.youtube.com/@example-v047",
    subscriberCount: 431662,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: false },
      { value: "model_3d", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_brown", approved: true },
      { value: "eye_red", approved: true },
      { value: "hair_length_very_long", approved: false },
      { value: "accessory_tail", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "genre_drawing", approved: false },
      { value: "personality_serious", approved: true },
      { value: "personality_cool", approved: false },
      { value: "personality_relaxing", approved: true },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_early_morning",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_047_001",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T18:00:00+09:00",
        durationSeconds: 4691,
        score: 3755,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_002",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T18:00:00+09:00",
        durationSeconds: 4345,
        score: 587,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_003",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T23:00:00+09:00",
        durationSeconds: 5651,
        score: 989,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_004",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T18:00:00+09:00",
        durationSeconds: 3869,
        score: 8964,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-07T22:00:00+09:00",
        durationSeconds: 9556,
        score: 8323,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_006",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-30T20:00:00+09:00",
        durationSeconds: 8633,
        score: 5216,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_007",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-23T18:00:00+09:00",
        durationSeconds: 3721,
        score: 3648,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-16T23:00:00+09:00",
        durationSeconds: 5825,
        score: 6873,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_009",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-09T23:00:00+09:00",
        durationSeconds: 6225,
        score: 7019,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_010",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-02T23:00:00+09:00",
        durationSeconds: 8096,
        score: 8913,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_011",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-26T23:00:00+09:00",
        durationSeconds: 4895,
        score: 9537,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_012",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-19T18:00:00+09:00",
        durationSeconds: 7417,
        score: 2786,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_047_013",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-12T20:00:00+09:00",
        durationSeconds: 6831,
        score: 8581,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "48",
    channelId: "UC_mock_048",
    name: "花城ウツギ",
    description: "ASMR配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V048",
    bannerUrl: "https://placehold.co/640x180?text=V048",
    youtubeUrl: "https://www.youtube.com/@example-v048",
    subscriberCount: 358217,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_en", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_light_green", approved: true },
      { value: "eye_heterochromia", approved: false },
      { value: "hair_length_very_long", approved: true },
      { value: "accessory_animal_ears", approved: true },
      { value: "accessory_wings", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_asmr", approved: false },
      { value: "genre_singing", approved: false },
      { value: "personality_funny", approved: true },
      { value: "personality_cheerful", approved: true },
      // "stream_time_evening",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_048_001",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T18:00:00+09:00",
        durationSeconds: 1515,
        score: 4563,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_025",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-08-03T22:00:00+09:00",
        durationSeconds: 3277,
        score: 8845,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_013",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-01T22:00:00+09:00",
        durationSeconds: 2195,
        score: 1180,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_014",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-08-01T18:00:00+09:00",
        durationSeconds: 2063,
        score: 5941,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-29T19:00:00+09:00",
        durationSeconds: 1778,
        score: 1225,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_015",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-25T20:00:00+09:00",
        durationSeconds: 4848,
        score: 7054,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_003",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-22T19:00:00+09:00",
        durationSeconds: 2283,
        score: 4533,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_026",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-20T21:00:00+09:00",
        durationSeconds: 4485,
        score: 5286,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_016",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 3751,
        score: 1350,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_004",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-15T23:00:00+09:00",
        durationSeconds: 4211,
        score: 1795,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_017",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-11T20:00:00+09:00",
        durationSeconds: 5071,
        score: 2152,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_027",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-06T19:00:00+09:00",
        durationSeconds: 2346,
        score: 2689,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_018",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 2346,
        score: 7142,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_005",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 2211,
        score: 2749,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_028",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-29T19:00:00+09:00",
        durationSeconds: 5134,
        score: 2193,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_019",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-27T18:00:00+09:00",
        durationSeconds: 2796,
        score: 9596,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_006",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-24T21:00:00+09:00",
        durationSeconds: 5262,
        score: 9618,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_029",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-22T19:00:00+09:00",
        durationSeconds: 2958,
        score: 3330,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_020",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-20T19:00:00+09:00",
        durationSeconds: 2442,
        score: 5464,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_007",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-17T22:00:00+09:00",
        durationSeconds: 1666,
        score: 5258,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_030",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-15T22:00:00+09:00",
        durationSeconds: 2358,
        score: 319,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_021",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-13T21:00:00+09:00",
        durationSeconds: 3253,
        score: 2110,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_008",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-10T18:00:00+09:00",
        durationSeconds: 2586,
        score: 6673,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_031",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-08T20:00:00+09:00",
        durationSeconds: 3707,
        score: 541,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_022",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-06-06T22:00:00+09:00",
        durationSeconds: 3582,
        score: 3990,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_009",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-03T21:00:00+09:00",
        durationSeconds: 1609,
        score: 5027,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_032",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-01T20:00:00+09:00",
        durationSeconds: 1741,
        score: 5072,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_010",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-27T21:00:00+09:00",
        durationSeconds: 1352,
        score: 2761,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_033",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-25T20:00:00+09:00",
        durationSeconds: 4378,
        score: 3620,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_048_023",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-23T21:00:00+09:00",
        durationSeconds: 3271,
        score: 4128,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_011",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-20T21:00:00+09:00",
        durationSeconds: 2834,
        score: 9303,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_024",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-16T23:00:00+09:00",
        durationSeconds: 2256,
        score: 7504,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_048_012",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-13T21:00:00+09:00",
        durationSeconds: 3257,
        score: 149,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "49",
    channelId: "UC_mock_049",
    name: "水無月カエデ",
    description: "配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V049",
    bannerUrl: "https://placehold.co/640x180?text=V049",
    youtubeUrl: "https://www.youtube.com/@example-v049",
    subscriberCount: 2098,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_gray", approved: false },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_halo", approved: false },
      { value: "accessory_wings", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_cute", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "genre_other", approved: true },
      { value: "genre_talk", approved: true },
      { value: "talk_consultation", approved: true },
      { value: "personality_natural", approved: true },
      { value: "personality_calm", approved: true },
      // "stream_time_afternoon",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_thursday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_049_013",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 3140,
        score: 4915,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_012",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 1015,
        score: 4197,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_002",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 963,
        score: 7751,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_001",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T20:00:00+09:00",
        durationSeconds: 2371,
        score: 2919,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_014",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-24T20:00:00+09:00",
        durationSeconds: 4684,
        score: 9281,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_015",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 2897,
        score: 6071,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_003",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-16T22:00:00+09:00",
        durationSeconds: 2797,
        score: 4550,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_016",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-10T19:00:00+09:00",
        durationSeconds: 2351,
        score: 7533,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_017",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-03T20:00:00+09:00",
        durationSeconds: 3102,
        score: 3434,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_004",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-02T18:00:00+09:00",
        durationSeconds: 1112,
        score: 1105,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_018",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 2974,
        score: 1765,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_005",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-25T21:00:00+09:00",
        durationSeconds: 2545,
        score: 4789,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_019",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-19T22:00:00+09:00",
        durationSeconds: 3300,
        score: 3707,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_006",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-18T22:00:00+09:00",
        durationSeconds: 4510,
        score: 1904,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_020",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-12T23:00:00+09:00",
        durationSeconds: 2265,
        score: 1455,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_007",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-11T21:00:00+09:00",
        durationSeconds: 2340,
        score: 9756,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_008",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-04T20:00:00+09:00",
        durationSeconds: 1443,
        score: 3721,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_021",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-29T23:00:00+09:00",
        durationSeconds: 3018,
        score: 3934,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_009",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-28T19:00:00+09:00",
        durationSeconds: 1027,
        score: 1524,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_022",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 4928,
        score: 6573,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_049_010",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 2915,
        score: 2940,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_023",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-15T19:00:00+09:00",
        durationSeconds: 1166,
        score: 5660,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_049_011",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-14T20:00:00+09:00",
        durationSeconds: 2413,
        score: 4965,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "50",
    channelId: "UC_mock_050",
    name: "星宮ウスバ",
    description: "歌枠が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V050",
    bannerUrl: "https://placehold.co/640x180?text=V050",
    youtubeUrl: "https://www.youtube.com/@example-v050",
    subscriberCount: 9078,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_red", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_singing", approved: true },
      { value: "genre_study", approved: true },
      { value: "personality_calm", approved: true },
      // "stream_time_midnight",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_050_001",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T18:00:00+09:00",
        durationSeconds: 2233,
        score: 4647,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_050_002",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-25T20:00:00+09:00",
        durationSeconds: 4683,
        score: 6313,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_050_003",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-18T22:00:00+09:00",
        durationSeconds: 3451,
        score: 997,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_050_004",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-11T22:00:00+09:00",
        durationSeconds: 3058,
        score: 9525,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_050_005",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-04T20:00:00+09:00",
        durationSeconds: 1942,
        score: 1064,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_050_006",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-13T18:00:00+09:00",
        durationSeconds: 8008,
        score: 9048,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_050_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-06T19:00:00+09:00",
        durationSeconds: 5529,
        score: 1687,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_050_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-30T22:00:00+09:00",
        durationSeconds: 3168,
        score: 2396,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_050_009",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-23T19:00:00+09:00",
        durationSeconds: 3656,
        score: 5578,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_050_010",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-16T23:00:00+09:00",
        durationSeconds: 2725,
        score: 3647,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "51",
    channelId: "UC_mock_051",
    name: "雪代そら",
    description: "個人勢VTuberとしてゲーム配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V051",
    bannerUrl: "https://placehold.co/640x180?text=V051",
    youtubeUrl: "https://www.youtube.com/@example-v051",
    subscriberCount: 295,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_png", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_light_blue", approved: true },
      { value: "eye_blue", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_soft", approved: true },
      { value: "voice_husky", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_tps", approved: true },
      { value: "game_retro", approved: true },
      { value: "personality_serious", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_cheerful", approved: true },
      // stream_long
      // "stream_time_early_morning",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_friday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_051_001",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T23:00:00+09:00",
        durationSeconds: 1878,
        score: 9107,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_051_011",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 7108,
        score: 4105,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_012",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-24T18:00:00+09:00",
        durationSeconds: 5923,
        score: 3507,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_051_002",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-21T22:00:00+09:00",
        durationSeconds: 3334,
        score: 440,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_051_003",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-07T19:00:00+09:00",
        durationSeconds: 5513,
        score: 3229,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_013",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-03T23:00:00+09:00",
        durationSeconds: 4806,
        score: 9472,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_004",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-30T18:00:00+09:00",
        durationSeconds: 3240,
        score: 1990,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_051_014",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-26T19:00:00+09:00",
        durationSeconds: 4442,
        score: 6919,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_005",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-23T19:00:00+09:00",
        durationSeconds: 7171,
        score: 3512,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_015",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-19T19:00:00+09:00",
        durationSeconds: 6803,
        score: 2447,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_051_006",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-16T21:00:00+09:00",
        durationSeconds: 7001,
        score: 1051,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_016",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-12T22:00:00+09:00",
        durationSeconds: 3056,
        score: 9958,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_017",
        title: "【TPS】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-05T20:00:00+09:00",
        durationSeconds: 4357,
        score: 1702,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_007",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-02T23:00:00+09:00",
        durationSeconds: 6382,
        score: 1862,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_051_008",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-26T23:00:00+09:00",
        durationSeconds: 4584,
        score: 6543,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_009",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-19T21:00:00+09:00",
        durationSeconds: 4859,
        score: 287,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_018",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-15T19:00:00+09:00",
        durationSeconds: 2684,
        score: 795,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_051_010",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 2520,
        score: 9293,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      }
    ],
  },
  {
    id: "52",
    channelId: "UC_mock_052",
    name: "銀河そら",
    description: "企業勢VTuberとしてASMR配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V052",
    bannerUrl: "https://placehold.co/640x180?text=V052",
    youtubeUrl: "https://www.youtube.com/@example-v052",
    subscriberCount: 18109,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_red", approved: true },
      { value: "eye_red", approved: false },
      { value: "hair_length_medium", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_energetic", approved: true },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_early_morning",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_052_013",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-04T18:00:00+09:00",
        durationSeconds: 3119,
        score: 3534,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_001",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 4703,
        score: 3719,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_002",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T19:00:00+09:00",
        durationSeconds: 2234,
        score: 8790,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_027",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 3211,
        score: 9654,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_026",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 1914,
        score: 6499,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_014",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-28T21:00:00+09:00",
        durationSeconds: 2447,
        score: 4751,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_003",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T19:00:00+09:00",
        durationSeconds: 4373,
        score: 4754,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_028",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-24T19:00:00+09:00",
        durationSeconds: 2331,
        score: 4873,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_015",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-21T19:00:00+09:00",
        durationSeconds: 2777,
        score: 4813,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_004",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-18T19:00:00+09:00",
        durationSeconds: 5444,
        score: 2541,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_016",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-14T23:00:00+09:00",
        durationSeconds: 3474,
        score: 4221,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_005",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-11T19:00:00+09:00",
        durationSeconds: 2590,
        score: 7604,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_029",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-07-10T22:00:00+09:00",
        durationSeconds: 2830,
        score: 2961,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_017",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-07T20:00:00+09:00",
        durationSeconds: 4007,
        score: 9901,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_006",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 2132,
        score: 7763,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_018",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-30T22:00:00+09:00",
        durationSeconds: 3469,
        score: 4282,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_007",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-27T19:00:00+09:00",
        durationSeconds: 4491,
        score: 3733,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_030",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-26T22:00:00+09:00",
        durationSeconds: 5116,
        score: 5443,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_019",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-23T20:00:00+09:00",
        durationSeconds: 3011,
        score: 3675,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_008",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 4499,
        score: 649,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_031",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 5018,
        score: 3358,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_020",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-16T22:00:00+09:00",
        durationSeconds: 4743,
        score: 4237,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_032",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-12T22:00:00+09:00",
        durationSeconds: 5319,
        score: 1714,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_021",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-09T22:00:00+09:00",
        durationSeconds: 4912,
        score: 3691,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_009",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-06T19:00:00+09:00",
        durationSeconds: 2614,
        score: 4603,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_022",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-06-02T19:00:00+09:00",
        durationSeconds: 3314,
        score: 8748,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_010",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-30T19:00:00+09:00",
        durationSeconds: 4865,
        score: 9959,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_033",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-29T23:00:00+09:00",
        durationSeconds: 3084,
        score: 1778,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_023",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-26T21:00:00+09:00",
        durationSeconds: 4852,
        score: 9285,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_011",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-23T20:00:00+09:00",
        durationSeconds: 3286,
        score: 3767,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_034",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-22T18:00:00+09:00",
        durationSeconds: 3955,
        score: 7991,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_024",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-19T22:00:00+09:00",
        durationSeconds: 3943,
        score: 7955,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_012",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-16T20:00:00+09:00",
        durationSeconds: 4716,
        score: 3858,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_035",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-15T18:00:00+09:00",
        durationSeconds: 5123,
        score: 6527,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_052_025",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-05-12T22:00:00+09:00",
        durationSeconds: 3771,
        score: 3268,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "53",
    channelId: "UC_mock_053",
    name: "桜庭サクラ",
    description: "個人勢VTuberとして料理配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V053",
    bannerUrl: "https://placehold.co/640x180?text=V053",
    youtubeUrl: "https://www.youtube.com/@example-v053",
    subscriberCount: 72704,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: false },
      { value: "model_live2d", approved: false },
      { value: "model_3d", approved: true },
      { value: "hair_pink", approved: true },
      { value: "eye_red", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_whisper", approved: false },
      { value: "voice_husky", approved: true },
      { value: "genre_cooking", approved: false },
      { value: "personality_calm", approved: true },
      { value: "personality_chaotic", approved: true },
      // "stream_time_early_morning",
      { value: "stream_frequency_high", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_053_002",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 2066,
        score: 9680,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_001",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 1446,
        score: 5615,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_003",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T21:00:00+09:00",
        durationSeconds: 1485,
        score: 7833,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_004",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 2243,
        score: 6092,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_005",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-03T19:00:00+09:00",
        durationSeconds: 1244,
        score: 5966,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_006",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-26T23:00:00+09:00",
        durationSeconds: 2088,
        score: 6952,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_007",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 2012,
        score: 7752,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_008",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-12T19:00:00+09:00",
        durationSeconds: 1344,
        score: 3978,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_009",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-05T19:00:00+09:00",
        durationSeconds: 915,
        score: 593,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_010",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-29T22:00:00+09:00",
        durationSeconds: 2443,
        score: 6260,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_011",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 2326,
        score: 3690,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_053_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-15T20:00:00+09:00",
        durationSeconds: 1010,
        score: 5436,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "54",
    channelId: "UC_mock_054",
    name: "天霧そら",
    description: "ASMR配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V054",
    bannerUrl: "https://placehold.co/640x180?text=V054",
    youtubeUrl: "https://www.youtube.com/@example-v054",
    subscriberCount: 417503,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: false },
      { value: "hair_white", approved: false },
      { value: "eye_orange", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "voice_pitch_very_low", approved: false },
      { value: "voice_powerful", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_calm", approved: false },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_night",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_054_001",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 3646,
        score: 6410,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_011",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-30T22:00:00+09:00",
        durationSeconds: 4842,
        score: 5472,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_010",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 2908,
        score: 4699,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_002",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-24T18:00:00+09:00",
        durationSeconds: 4826,
        score: 2308,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_012",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-09T19:00:00+09:00",
        durationSeconds: 4711,
        score: 3505,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_003",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-03T18:00:00+09:00",
        durationSeconds: 1804,
        score: 7018,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_004",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 3828,
        score: 769,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_005",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-19T19:00:00+09:00",
        durationSeconds: 4422,
        score: 1458,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_013",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-06-18T23:00:00+09:00",
        durationSeconds: 3529,
        score: 2750,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_006",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-12T22:00:00+09:00",
        durationSeconds: 1894,
        score: 9761,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_014",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-11T21:00:00+09:00",
        durationSeconds: 3886,
        score: 2817,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_015",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-04T22:00:00+09:00",
        durationSeconds: 4696,
        score: 3492,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_007",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-29T19:00:00+09:00",
        durationSeconds: 3975,
        score: 568,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_016",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-05-28T23:00:00+09:00",
        durationSeconds: 3551,
        score: 8001,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_008",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-22T19:00:00+09:00",
        durationSeconds: 4050,
        score: 9958,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_009",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 4934,
        score: 1087,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_054_017",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-14T20:00:00+09:00",
        durationSeconds: 1973,
        score: 5843,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "55",
    channelId: "UC_mock_055",
    name: "朱雀ミナヅキ",
    description: "ゲーム配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V055",
    bannerUrl: "https://placehold.co/640x180?text=V055",
    youtubeUrl: "https://www.youtube.com/@example-v055",
    subscriberCount: 8836,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_light_blue", approved: true },
      { value: "eye_orange", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_clear", approved: true },
      { value: "voice_mature", approved: true },
      { value: "genre_game", approved: true },
      { value: "genre_study", approved: true },
      { value: "game_action", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_cool", approved: true },
      // stream_long
      // "stream_time_midnight",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_055_002",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 8135,
        score: 7997,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_055_001",
        title: "【アクションゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T19:00:00+09:00",
        durationSeconds: 4898,
        score: 3639,
        attributes: [
          "genre_game",
          "game_action",
        ],
      },
      {
        videoId: "mock_video_055_003",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T22:00:00+09:00",
        durationSeconds: 3672,
        score: 5940,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_055_004",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 5774,
        score: 3858,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_055_005",
        title: "【アクションゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-11T18:00:00+09:00",
        durationSeconds: 4612,
        score: 5188,
        attributes: [
          "genre_game",
          "game_action",
        ],
      },
      {
        videoId: "mock_video_055_006",
        title: "【アクションゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-04T18:00:00+09:00",
        durationSeconds: 5913,
        score: 6777,
        attributes: [
          "genre_game",
          "game_action",
        ],
      },
      {
        videoId: "mock_video_055_007",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-13T19:00:00+09:00",
        durationSeconds: 9937,
        score: 8558,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_055_008",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-06T19:00:00+09:00",
        durationSeconds: 5129,
        score: 301,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_055_009",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-30T23:00:00+09:00",
        durationSeconds: 7491,
        score: 2312,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_055_010",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-23T18:00:00+09:00",
        durationSeconds: 10493,
        score: 4011,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_055_011",
        title: "【アクションゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-16T20:00:00+09:00",
        durationSeconds: 5858,
        score: 7305,
        attributes: [
          "genre_game",
          "game_action",
        ],
      }
    ],
  },
  {
    id: "56",
    channelId: "UC_mock_056",
    name: "花城アカネ",
    description: "企業勢VTuberとして同時視聴配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V056",
    bannerUrl: "https://placehold.co/640x180?text=V056",
    youtubeUrl: "https://www.youtube.com/@example-v056",
    subscriberCount: 701,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_silver", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "accessory_glasses", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_action", approved: false },
      { value: "game_minecraft", approved: true },
      { value: "personality_serious", approved: true },
      { value: "personality_relaxing", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_056_001",
        title: "【Minecraft】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T23:00:00+09:00",
        durationSeconds: 4405,
        score: 7226,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_056_012",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 6310,
        score: 9196,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_013",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-01T19:00:00+09:00",
        durationSeconds: 5747,
        score: 4873,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_002",
        title: "【アクションゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T18:00:00+09:00",
        durationSeconds: 6589,
        score: 9690,
        attributes: [
          "genre_game",
          "game_action",
        ],
      },
      {
        videoId: "mock_video_056_014",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-25T21:00:00+09:00",
        durationSeconds: 4572,
        score: 9050,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_015",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-18T23:00:00+09:00",
        durationSeconds: 3735,
        score: 2643,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_056_003",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-13T23:00:00+09:00",
        durationSeconds: 7581,
        score: 6508,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_016",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-11T21:00:00+09:00",
        durationSeconds: 4081,
        score: 70,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_004",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T20:00:00+09:00",
        durationSeconds: 6182,
        score: 5001,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_017",
        title: "【アクションゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-04T21:00:00+09:00",
        durationSeconds: 3591,
        score: 4333,
        attributes: [
          "genre_game",
          "game_action",
        ],
      },
      {
        videoId: "mock_video_056_005",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-29T19:00:00+09:00",
        durationSeconds: 5023,
        score: 7917,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_018",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-27T19:00:00+09:00",
        durationSeconds: 6753,
        score: 5574,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_006",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-22T18:00:00+09:00",
        durationSeconds: 7620,
        score: 9933,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_007",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-15T20:00:00+09:00",
        durationSeconds: 4590,
        score: 8012,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-08T19:00:00+09:00",
        durationSeconds: 6732,
        score: 4638,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_019",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 5402,
        score: 8015,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_056_009",
        title: "【アクションゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-25T19:00:00+09:00",
        durationSeconds: 5475,
        score: 7695,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_056_010",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T23:00:00+09:00",
        durationSeconds: 6706,
        score: 9913,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_056_020",
        title: "【Minecraft】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 3520,
        score: 8078,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_056_011",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 5489,
        score: 5120,
        attributes: [
          "genre_game",
          "game_action",
        ],
      }
    ],
  },
  {
    id: "57",
    channelId: "UC_mock_057",
    name: "星宮ルナ",
    description: "雑談配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V057",
    bannerUrl: "https://placehold.co/640x180?text=V057",
    youtubeUrl: "https://www.youtube.com/@example-v057",
    subscriberCount: 54629,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: false },
      { value: "hair_multicolor", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_halo", approved: false },
      { value: "accessory_glasses", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "genre_talk", approved: true },
      { value: "genre_study", approved: true },
      { value: "talk_consultation", approved: true },
      { value: "personality_serious", approved: true },
      // stream_long
      // stream_collab,
      // "stream_time_night",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_057_001",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T18:00:00+09:00",
        durationSeconds: 3871,
        score: 2395,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_057_010",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-31T23:00:00+09:00",
        durationSeconds: 7736,
        score: 6640,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_009",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 2312,
        score: 4383,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_057_011",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-24T20:00:00+09:00",
        durationSeconds: 5590,
        score: 318,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_012",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-17T21:00:00+09:00",
        durationSeconds: 4449,
        score: 4388,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_057_002",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-15T23:00:00+09:00",
        durationSeconds: 10080,
        score: 5095,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_013",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-10T22:00:00+09:00",
        durationSeconds: 4184,
        score: 1367,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_003",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-08T22:00:00+09:00",
        durationSeconds: 9289,
        score: 5271,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-03T21:00:00+09:00",
        durationSeconds: 9832,
        score: 1473,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_004",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 4382,
        score: 1981,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_057_015",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-26T19:00:00+09:00",
        durationSeconds: 3744,
        score: 2215,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_057_005",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-24T20:00:00+09:00",
        durationSeconds: 3879,
        score: 3191,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_057_016",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 7719,
        score: 4976,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_006",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-10T23:00:00+09:00",
        durationSeconds: 5888,
        score: 3081,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_017",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-29T20:00:00+09:00",
        durationSeconds: 7119,
        score: 931,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_007",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-27T23:00:00+09:00",
        durationSeconds: 7977,
        score: 5514,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_018",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-22T22:00:00+09:00",
        durationSeconds: 5148,
        score: 1340,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_057_019",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-15T18:00:00+09:00",
        durationSeconds: 8653,
        score: 6112,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_057_008",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-13T18:00:00+09:00",
        durationSeconds: 5169,
        score: 2149,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      }
    ],
  },
  {
    id: "58",
    channelId: "UC_mock_058",
    name: "星宮サクラ",
    description: "企業勢VTuberとして歌枠を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V058",
    bannerUrl: "https://placehold.co/640x180?text=V058",
    youtubeUrl: "https://www.youtube.com/@example-v058",
    subscriberCount: 4414,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_red", approved: false },
      { value: "eye_orange", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_low", approved: false },
      { value: "voice_androgynous", approved: true },
      { value: "genre_singing", approved: false },
      { value: "personality_calm", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_energetic", approved: false },
      // stream_viewer_partcition,
      // "stream_time_midnight",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_tuesday", approved: false },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_058_012",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-04T20:00:00+09:00",
        durationSeconds: 1770,
        score: 3543,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_001",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T23:00:00+09:00",
        durationSeconds: 1597,
        score: 5666,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_013",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 3028,
        score: 869,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T23:00:00+09:00",
        durationSeconds: 1785,
        score: 3292,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_014",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-21T20:00:00+09:00",
        durationSeconds: 2657,
        score: 9994,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_003",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T23:00:00+09:00",
        durationSeconds: 2131,
        score: 2819,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_021",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-07-15T20:00:00+09:00",
        durationSeconds: 1510,
        score: 5571,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_015",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-14T21:00:00+09:00",
        durationSeconds: 2196,
        score: 474,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_004",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T18:00:00+09:00",
        durationSeconds: 3034,
        score: 157,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_005",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T19:00:00+09:00",
        durationSeconds: 2276,
        score: 1016,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_022",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-01T21:00:00+09:00",
        durationSeconds: 1948,
        score: 9913,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_006",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T19:00:00+09:00",
        durationSeconds: 2978,
        score: 9703,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_023",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 3633,
        score: 7132,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_016",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-23T21:00:00+09:00",
        durationSeconds: 1656,
        score: 8865,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_007",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T20:00:00+09:00",
        durationSeconds: 3166,
        score: 5004,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_024",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-06-17T19:00:00+09:00",
        durationSeconds: 2770,
        score: 5182,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T18:00:00+09:00",
        durationSeconds: 2257,
        score: 8044,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_025",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-06-10T22:00:00+09:00",
        durationSeconds: 1735,
        score: 4010,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_017",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-09T22:00:00+09:00",
        durationSeconds: 2786,
        score: 877,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_026",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-03T21:00:00+09:00",
        durationSeconds: 1936,
        score: 4116,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_009",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-01T18:00:00+09:00",
        durationSeconds: 3195,
        score: 1556,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_027",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-05-27T19:00:00+09:00",
        durationSeconds: 1761,
        score: 301,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_018",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-26T20:00:00+09:00",
        durationSeconds: 2106,
        score: 6815,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_010",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 3062,
        score: 4036,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_028",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-05-20T18:00:00+09:00",
        durationSeconds: 1977,
        score: 4796,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_019",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-19T20:00:00+09:00",
        durationSeconds: 1295,
        score: 6472,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_029",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-13T18:00:00+09:00",
        durationSeconds: 3121,
        score: 623,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_020",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 2943,
        score: 6186,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_058_011",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T22:00:00+09:00",
        durationSeconds: 3104,
        score: 9472,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "59",
    channelId: "UC_mock_059",
    name: "白鳥サクラ",
    description: "歌枠が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V059",
    bannerUrl: "https://placehold.co/640x180?text=V059",
    youtubeUrl: "https://www.youtube.com/@example-v059",
    subscriberCount: 517915,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_en", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_brown", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "accessory_tail", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_cheerful", approved: true },
      // stream_viewer_partcition,
      // "stream_time_evening",
      { value: "stream_frequency_low", approved: true },
      { value: "day_thursday", approved: false },
      { value: "day_tuesday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_059_009",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-08-04T21:00:00+09:00",
        durationSeconds: 2801,
        score: 6883,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_001",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T19:00:00+09:00",
        durationSeconds: 1447,
        score: 2412,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-23T23:00:00+09:00",
        durationSeconds: 3361,
        score: 1802,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_010",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-14T19:00:00+09:00",
        durationSeconds: 2225,
        score: 5644,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_003",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-02T19:00:00+09:00",
        durationSeconds: 2130,
        score: 9498,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_011",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-06-30T20:00:00+09:00",
        durationSeconds: 1602,
        score: 8324,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_004",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-25T20:00:00+09:00",
        durationSeconds: 1344,
        score: 4055,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_012",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-06-23T23:00:00+09:00",
        durationSeconds: 2960,
        score: 5829,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_005",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 1263,
        score: 86,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_013",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-06-16T23:00:00+09:00",
        durationSeconds: 2498,
        score: 9400,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_006",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-04T18:00:00+09:00",
        durationSeconds: 1477,
        score: 2263,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_007",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-28T20:00:00+09:00",
        durationSeconds: 2016,
        score: 8857,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_014",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-05-26T22:00:00+09:00",
        durationSeconds: 2264,
        score: 3085,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-21T22:00:00+09:00",
        durationSeconds: 2895,
        score: 5402,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_059_015",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 2243,
        score: 923,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "60",
    channelId: "UC_mock_060",
    name: "銀河みかん",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V060",
    bannerUrl: "https://placehold.co/640x180?text=V060",
    youtubeUrl: "https://www.youtube.com/@example-v060",
    subscriberCount: 390105,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: false },
      { value: "model_png", approved: true },
      { value: "hair_purple", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_middle", approved: false },
      { value: "voice_husky", approved: true },
      { value: "voice_cool", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "personality_chaotic", approved: true },
      // "stream_time_evening",
      { value: "stream_frequency_irregular", approved: false },
      { value: "day_friday", approved: true },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_060_010",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-08-05T19:00:00+09:00",
        durationSeconds: 6369,
        score: 1626,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_001",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 9024,
        score: 7466,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-29T23:00:00+09:00",
        durationSeconds: 4150,
        score: 2155,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_002",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-24T18:00:00+09:00",
        durationSeconds: 7868,
        score: 6581,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_012",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-22T19:00:00+09:00",
        durationSeconds: 7523,
        score: 6083,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 8508,
        score: 2494,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_004",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-10T21:00:00+09:00",
        durationSeconds: 3704,
        score: 6935,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_013",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-08T21:00:00+09:00",
        durationSeconds: 3729,
        score: 2760,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_014",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-01T20:00:00+09:00",
        durationSeconds: 7205,
        score: 7532,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_015",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-24T21:00:00+09:00",
        durationSeconds: 9858,
        score: 6162,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-19T19:00:00+09:00",
        durationSeconds: 9408,
        score: 7913,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_016",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-17T22:00:00+09:00",
        durationSeconds: 10486,
        score: 9950,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_006",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-12T19:00:00+09:00",
        durationSeconds: 5313,
        score: 3737,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_017",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-10T21:00:00+09:00",
        durationSeconds: 9420,
        score: 2781,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_007",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-05T23:00:00+09:00",
        durationSeconds: 7967,
        score: 920,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_018",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-03T23:00:00+09:00",
        durationSeconds: 6879,
        score: 9181,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_008",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-29T18:00:00+09:00",
        durationSeconds: 6163,
        score: 3556,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_019",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-27T23:00:00+09:00",
        durationSeconds: 9956,
        score: 3347,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_009",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-22T22:00:00+09:00",
        durationSeconds: 8671,
        score: 4725,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_020",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-20T19:00:00+09:00",
        durationSeconds: 8298,
        score: 3187,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_060_021",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-13T18:00:00+09:00",
        durationSeconds: 9391,
        score: 2705,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "61",
    channelId: "UC_mock_061",
    name: "月城アカネ",
    description: "同時視聴配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V061",
    bannerUrl: "https://placehold.co/640x180?text=V061",
    youtubeUrl: "https://www.youtube.com/@example-v061",
    subscriberCount: 1841851,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_navy", approved: true },
      { value: "eye_pink", approved: false },
      { value: "hair_length_very_short", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_cool", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_watchalong", approved: false },
      { value: "personality_funny", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_gentle", approved: true },
      // stream_collab,
      // stream_viewer_partcition,
      // "stream_time_afternoon",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_061_011",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-08-04T18:00:00+09:00",
        durationSeconds: 5308,
        score: 7465,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_001",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 5281,
        score: 6579,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_012",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-28T22:00:00+09:00",
        durationSeconds: 6914,
        score: 7633,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-24T23:00:00+09:00",
        durationSeconds: 8033,
        score: 6586,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_013",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-21T21:00:00+09:00",
        durationSeconds: 5593,
        score: 4710,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 7082,
        score: 1014,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_014",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-14T21:00:00+09:00",
        durationSeconds: 7841,
        score: 2245,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_004",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 7068,
        score: 604,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_015",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-07T22:00:00+09:00",
        durationSeconds: 7536,
        score: 7578,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_005",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-03T22:00:00+09:00",
        durationSeconds: 8655,
        score: 2566,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_016",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-30T18:00:00+09:00",
        durationSeconds: 3826,
        score: 2615,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_006",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-26T23:00:00+09:00",
        durationSeconds: 3655,
        score: 2748,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_017",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-16T18:00:00+09:00",
        durationSeconds: 9019,
        score: 4584,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_007",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-12T18:00:00+09:00",
        durationSeconds: 6495,
        score: 3343,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_018",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-09T22:00:00+09:00",
        durationSeconds: 5649,
        score: 6376,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_008",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-05T23:00:00+09:00",
        durationSeconds: 5464,
        score: 8867,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_019",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-02T18:00:00+09:00",
        durationSeconds: 4617,
        score: 2042,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_020",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-26T19:00:00+09:00",
        durationSeconds: 6581,
        score: 8221,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_009",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-22T18:00:00+09:00",
        durationSeconds: 7885,
        score: 5772,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_021",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-19T19:00:00+09:00",
        durationSeconds: 5948,
        score: 6916,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_010",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-15T18:00:00+09:00",
        durationSeconds: 5167,
        score: 5403,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_061_022",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 8100,
        score: 8759,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "62",
    channelId: "UC_mock_062",
    name: "風間サクラ",
    description: "同時視聴配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V062",
    bannerUrl: "https://placehold.co/640x180?text=V062",
    youtubeUrl: "https://www.youtube.com/@example-v062",
    subscriberCount: 65041,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_blonde", approved: true },
      { value: "eye_yellow", approved: false },
      { value: "hair_length_very_short", approved: false },
      { value: "accessory_halo", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_cute", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "personality_funny", approved: true },
      { value: "personality_relaxing", approved: true },
      // stream_collab,
      // stream_long
      // "stream_time_midnight",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_sunday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_062_011",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 3800,
        score: 6080,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_001",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-19T18:00:00+09:00",
        durationSeconds: 3850,
        score: 1294,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_012",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-17T23:00:00+09:00",
        durationSeconds: 4534,
        score: 1049,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_013",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-10T19:00:00+09:00",
        durationSeconds: 8786,
        score: 6359,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_002",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-05T18:00:00+09:00",
        durationSeconds: 8008,
        score: 584,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_014",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-03T19:00:00+09:00",
        durationSeconds: 5794,
        score: 9410,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_003",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-06-28T18:00:00+09:00",
        durationSeconds: 7174,
        score: 3445,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_015",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 8271,
        score: 4422,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_004",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-21T20:00:00+09:00",
        durationSeconds: 5060,
        score: 7332,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_016",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 6938,
        score: 4211,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_005",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-14T18:00:00+09:00",
        durationSeconds: 6288,
        score: 6491,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_017",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-12T21:00:00+09:00",
        durationSeconds: 8365,
        score: 2480,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_006",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-07T20:00:00+09:00",
        durationSeconds: 6680,
        score: 1435,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_007",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-31T20:00:00+09:00",
        durationSeconds: 4300,
        score: 513,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_018",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-29T19:00:00+09:00",
        durationSeconds: 4393,
        score: 5798,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-24T19:00:00+09:00",
        durationSeconds: 5740,
        score: 5906,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_019",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 7788,
        score: 2654,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_009",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-17T22:00:00+09:00",
        durationSeconds: 7840,
        score: 3089,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_020",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 6251,
        score: 8371,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_062_010",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-10T20:00:00+09:00",
        durationSeconds: 5577,
        score: 652,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "63",
    channelId: "UC_mock_063",
    name: "雷電ルナ",
    description: "個人勢VTuberとして同時視聴配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V063",
    bannerUrl: "https://placehold.co/640x180?text=V063",
    youtubeUrl: "https://www.youtube.com/@example-v063",
    subscriberCount: 87152,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_blue", approved: true },
      { value: "eye_purple", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "voice_husky", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "genre_study", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_natural", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_thursday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_063_012",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-02T19:00:00+09:00",
        durationSeconds: 4942,
        score: 2155,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_001",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 4116,
        score: 4113,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-30T20:00:00+09:00",
        durationSeconds: 8292,
        score: 648,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_013",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-26T22:00:00+09:00",
        durationSeconds: 4886,
        score: 3827,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-23T23:00:00+09:00",
        durationSeconds: 5917,
        score: 3715,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_014",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-19T23:00:00+09:00",
        durationSeconds: 4493,
        score: 2153,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_004",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-09T20:00:00+09:00",
        durationSeconds: 4685,
        score: 8965,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_015",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-05T18:00:00+09:00",
        durationSeconds: 10202,
        score: 8122,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_005",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-02T21:00:00+09:00",
        durationSeconds: 8046,
        score: 7400,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_016",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-28T19:00:00+09:00",
        durationSeconds: 3826,
        score: 8170,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_006",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-25T22:00:00+09:00",
        durationSeconds: 6189,
        score: 9933,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_017",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-14T18:00:00+09:00",
        durationSeconds: 5752,
        score: 831,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-11T22:00:00+09:00",
        durationSeconds: 5964,
        score: 8721,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_018",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-07T22:00:00+09:00",
        durationSeconds: 8283,
        score: 8104,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_008",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-04T23:00:00+09:00",
        durationSeconds: 8458,
        score: 8333,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_009",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-28T19:00:00+09:00",
        durationSeconds: 8122,
        score: 2512,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_019",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-24T22:00:00+09:00",
        durationSeconds: 5279,
        score: 301,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_010",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 5188,
        score: 6767,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_063_020",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-17T21:00:00+09:00",
        durationSeconds: 7071,
        score: 6907,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_011",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-14T19:00:00+09:00",
        durationSeconds: 8538,
        score: 4877,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_063_021",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-10T18:00:00+09:00",
        durationSeconds: 8817,
        score: 804,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "64",
    channelId: "UC_mock_064",
    name: "夜久ギンガ",
    description: "歌枠をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V064",
    bannerUrl: "https://placehold.co/640x180?text=V064",
    youtubeUrl: "https://www.youtube.com/@example-v064",
    subscriberCount: 3025,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_blonde", approved: false },
      { value: "eye_green", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_very_low", approved: false },
      { value: "voice_cool", approved: false },
      { value: "voice_mature", approved: true },
      { value: "genre_singing", approved: false },
      { value: "personality_serious", approved: true },
      { value: "personality_cool", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_064_021",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-08-02T20:00:00+09:00",
        durationSeconds: 2134,
        score: 314,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_009",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 3077,
        score: 2115,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_002",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T23:00:00+09:00",
        durationSeconds: 2008,
        score: 8612,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_001",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T21:00:00+09:00",
        durationSeconds: 2002,
        score: 1238,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_010",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-25T20:00:00+09:00",
        durationSeconds: 3259,
        score: 6471,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_022",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-19T20:00:00+09:00",
        durationSeconds: 2303,
        score: 3207,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_011",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 3625,
        score: 9850,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_023",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 2125,
        score: 6562,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_012",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-11T20:00:00+09:00",
        durationSeconds: 1418,
        score: 2097,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_024",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-05T23:00:00+09:00",
        durationSeconds: 3450,
        score: 1142,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_013",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-04T23:00:00+09:00",
        durationSeconds: 2472,
        score: 6230,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_003",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-03T20:00:00+09:00",
        durationSeconds: 1764,
        score: 9961,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_025",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-06-28T18:00:00+09:00",
        durationSeconds: 2804,
        score: 5416,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_014",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-27T20:00:00+09:00",
        durationSeconds: 1655,
        score: 3162,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_004",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 2764,
        score: 9668,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_026",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-21T23:00:00+09:00",
        durationSeconds: 1920,
        score: 8433,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_015",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-20T23:00:00+09:00",
        durationSeconds: 2167,
        score: 5763,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_005",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-19T22:00:00+09:00",
        durationSeconds: 2835,
        score: 5585,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_027",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-14T19:00:00+09:00",
        durationSeconds: 1216,
        score: 2429,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_016",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-13T22:00:00+09:00",
        durationSeconds: 1766,
        score: 7023,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_028",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-07T21:00:00+09:00",
        durationSeconds: 1383,
        score: 7841,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_017",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-06T22:00:00+09:00",
        durationSeconds: 3017,
        score: 5089,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_006",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-05T23:00:00+09:00",
        durationSeconds: 2326,
        score: 2591,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_029",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-31T23:00:00+09:00",
        durationSeconds: 2581,
        score: 57,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_018",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-30T20:00:00+09:00",
        durationSeconds: 2578,
        score: 7894,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_007",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-29T19:00:00+09:00",
        durationSeconds: 1606,
        score: 7623,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_019",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-23T22:00:00+09:00",
        durationSeconds: 2098,
        score: 4473,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_008",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-22T20:00:00+09:00",
        durationSeconds: 2318,
        score: 5508,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_030",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 2291,
        score: 9045,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_020",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-16T21:00:00+09:00",
        durationSeconds: 2468,
        score: 3293,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_064_031",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-10T21:00:00+09:00",
        durationSeconds: 3493,
        score: 3221,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "65",
    channelId: "UC_mock_065",
    name: "藍原ツキ",
    description: "個人勢VTuberとして料理配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V065",
    bannerUrl: "https://placehold.co/640x180?text=V065",
    youtubeUrl: "https://www.youtube.com/@example-v065",
    subscriberCount: 9029,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_pink", approved: true },
      { value: "eye_yellow", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_husky", approved: true },
      { value: "genre_cooking", approved: false },
      { value: "personality_funny", approved: true },
      { value: "personality_energetic", approved: true },
      // stream_viewer_partcition,
      // "stream_time_afternoon",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_065_001",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-27T23:00:00+09:00",
        durationSeconds: 1478,
        score: 8378,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_002",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-20T21:00:00+09:00",
        durationSeconds: 2421,
        score: 7171,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_003",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-13T19:00:00+09:00",
        durationSeconds: 1210,
        score: 5583,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_004",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T21:00:00+09:00",
        durationSeconds: 1378,
        score: 3794,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_005",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-29T21:00:00+09:00",
        durationSeconds: 1249,
        score: 7960,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_006",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-15T22:00:00+09:00",
        durationSeconds: 2178,
        score: 9402,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_007",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 1943,
        score: 9064,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_008",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-01T19:00:00+09:00",
        durationSeconds: 1486,
        score: 1387,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_009",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-25T21:00:00+09:00",
        durationSeconds: 1318,
        score: 6465,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T19:00:00+09:00",
        durationSeconds: 1227,
        score: 9087,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_065_011",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T22:00:00+09:00",
        durationSeconds: 1454,
        score: 6911,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "66",
    channelId: "UC_mock_066",
    name: "白鳥ツキ",
    description: "配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V066",
    bannerUrl: "https://placehold.co/640x180?text=V066",
    youtubeUrl: "https://www.youtube.com/@example-v066",
    subscriberCount: 2639823,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_red", approved: true },
      { value: "eye_pink", approved: false },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_androgynous", approved: false },
      { value: "genre_other", approved: false },
      { value: "genre_game", approved: true },
      { value: "game_fighting", approved: false },
      { value: "game_rhythm", approved: true },
      { value: "personality_serious", approved: false },
      { value: "personality_gentle", approved: true },
      // stream_long
      // "stream_time_evening",
      { value: "stream_frequency_low", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_066_001",
        title: "【格闘ゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-27T23:00:00+09:00",
        durationSeconds: 6834,
        score: 2539,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_066_002",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-20T19:00:00+09:00",
        durationSeconds: 975,
        score: 3960,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_066_003",
        title: "【格闘ゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-13T18:00:00+09:00",
        durationSeconds: 5588,
        score: 4733,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_066_004",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T23:00:00+09:00",
        durationSeconds: 2188,
        score: 2051,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_066_005",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-22T22:00:00+09:00",
        durationSeconds: 1704,
        score: 8416,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_066_006",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-15T22:00:00+09:00",
        durationSeconds: 4179,
        score: 6862,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_066_007",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 1817,
        score: 2980,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_066_008",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-01T23:00:00+09:00",
        durationSeconds: 4898,
        score: 7575,
        attributes: [
          "genre_game",
          "game_fighting",
        ],
      },
      {
        videoId: "mock_video_066_009",
        title: "【音ゲー】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-25T22:00:00+09:00",
        durationSeconds: 6244,
        score: 4508,
        attributes: [
          "genre_game",
          "game_rhythm",
        ],
      },
      {
        videoId: "mock_video_066_010",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T22:00:00+09:00",
        durationSeconds: 905,
        score: 9797,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "67",
    channelId: "UC_mock_067",
    name: "紅葉ギンガ",
    description: "歌枠が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V067",
    bannerUrl: "https://placehold.co/640x180?text=V067",
    youtubeUrl: "https://www.youtube.com/@example-v067",
    subscriberCount: 938,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_png", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_blue", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_singing", approved: false },
      { value: "personality_energetic", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_chaotic", approved: true },
      // stream_collab,
      // stream_long
      // "stream_time_midnight",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_067_002",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 3383,
        score: 6807,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_001",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 3400,
        score: 6265,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_003",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T23:00:00+09:00",
        durationSeconds: 1852,
        score: 4673,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_004",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 1557,
        score: 8243,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_005",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-10T22:00:00+09:00",
        durationSeconds: 2583,
        score: 3628,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_006",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-03T19:00:00+09:00",
        durationSeconds: 3003,
        score: 3921,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_007",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 2136,
        score: 3887,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_008",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-19T20:00:00+09:00",
        durationSeconds: 2720,
        score: 7585,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_009",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-12T23:00:00+09:00",
        durationSeconds: 1481,
        score: 5013,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_010",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-05T18:00:00+09:00",
        durationSeconds: 1863,
        score: 4230,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_011",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 1878,
        score: 3091,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_067_012",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-15T23:00:00+09:00",
        durationSeconds: 3484,
        score: 7237,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "68",
    channelId: "UC_mock_068",
    name: "花城みかん",
    description: "作業配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V068",
    bannerUrl: "https://placehold.co/640x180?text=V068",
    youtubeUrl: "https://www.youtube.com/@example-v068",
    subscriberCount: 789774,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_navy", approved: true },
      { value: "eye_purple", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_clear", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_study", approved: true },
      { value: "genre_other", approved: true },
      { value: "personality_funny", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_gentle", approved: true },
      // stream_viewer_partcition,
      // stream_long
      // "stream_time_morning",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_saturday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_068_001",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T21:00:00+09:00",
        durationSeconds: 4150,
        score: 9724,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_025",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 3063,
        score: 4963,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_013",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 8573,
        score: 8668,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_012",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 1834,
        score: 2939,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_002",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T21:00:00+09:00",
        durationSeconds: 1806,
        score: 3420,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_014",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-24T19:00:00+09:00",
        durationSeconds: 10774,
        score: 4301,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_003",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T18:00:00+09:00",
        durationSeconds: 10291,
        score: 9833,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_026",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-18T18:00:00+09:00",
        durationSeconds: 1030,
        score: 8394,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_015",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-17T21:00:00+09:00",
        durationSeconds: 7063,
        score: 175,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_004",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T18:00:00+09:00",
        durationSeconds: 4900,
        score: 2360,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_016",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 6198,
        score: 695,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_005",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T20:00:00+09:00",
        durationSeconds: 1013,
        score: 200,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_017",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-03T21:00:00+09:00",
        durationSeconds: 2580,
        score: 1801,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_006",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T22:00:00+09:00",
        durationSeconds: 2428,
        score: 6,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_027",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-27T18:00:00+09:00",
        durationSeconds: 10796,
        score: 8406,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_018",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-26T21:00:00+09:00",
        durationSeconds: 5476,
        score: 3855,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_007",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T23:00:00+09:00",
        durationSeconds: 9250,
        score: 1626,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_028",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-20T23:00:00+09:00",
        durationSeconds: 2077,
        score: 2638,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_019",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-19T20:00:00+09:00",
        durationSeconds: 1617,
        score: 9045,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_008",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T21:00:00+09:00",
        durationSeconds: 3477,
        score: 472,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_029",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-13T21:00:00+09:00",
        durationSeconds: 9267,
        score: 4251,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_020",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-12T18:00:00+09:00",
        durationSeconds: 2530,
        score: 1453,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_009",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-08T19:00:00+09:00",
        durationSeconds: 1266,
        score: 7682,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_030",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-06T20:00:00+09:00",
        durationSeconds: 3340,
        score: 7081,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_021",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-05T22:00:00+09:00",
        durationSeconds: 1695,
        score: 1577,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_031",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-30T21:00:00+09:00",
        durationSeconds: 1486,
        score: 2026,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_022",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-29T23:00:00+09:00",
        durationSeconds: 7138,
        score: 5656,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_032",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-23T20:00:00+09:00",
        durationSeconds: 9443,
        score: 7503,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_023",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 2955,
        score: 4095,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_010",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T22:00:00+09:00",
        durationSeconds: 1697,
        score: 7431,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_033",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-16T20:00:00+09:00",
        durationSeconds: 6392,
        score: 8824,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_068_024",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-15T23:00:00+09:00",
        durationSeconds: 2494,
        score: 4200,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_068_011",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T22:00:00+09:00",
        durationSeconds: 2793,
        score: 7073,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "69",
    channelId: "UC_mock_069",
    name: "空木ヨル",
    description: "お絵描き配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V069",
    bannerUrl: "https://placehold.co/640x180?text=V069",
    youtubeUrl: "https://www.youtube.com/@example-v069",
    subscriberCount: 452,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_red", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_long", approved: false },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_drawing", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_natural", approved: true },
      { value: "personality_serious", approved: true },
      // stream_viewer_partcition,
      // stream_long
      // "stream_time_morning",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_thursday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_069_012",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-05T18:00:00+09:00",
        durationSeconds: 3678,
        score: 8000,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_002",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 9765,
        score: 1155,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_001",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 7576,
        score: 6644,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_023",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-30T23:00:00+09:00",
        durationSeconds: 8784,
        score: 4170,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_024",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 10224,
        score: 5136,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_013",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-29T19:00:00+09:00",
        durationSeconds: 5465,
        score: 8015,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_003",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T22:00:00+09:00",
        durationSeconds: 4491,
        score: 3972,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_025",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-23T23:00:00+09:00",
        durationSeconds: 4627,
        score: 2386,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_014",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-22T19:00:00+09:00",
        durationSeconds: 8461,
        score: 3447,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_004",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T22:00:00+09:00",
        durationSeconds: 5809,
        score: 3834,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_026",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-16T23:00:00+09:00",
        durationSeconds: 9058,
        score: 2114,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_005",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-10T18:00:00+09:00",
        durationSeconds: 9999,
        score: 105,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_015",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-08T19:00:00+09:00",
        durationSeconds: 8051,
        score: 6390,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_006",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-03T22:00:00+09:00",
        durationSeconds: 7784,
        score: 6852,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_027",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-02T21:00:00+09:00",
        durationSeconds: 6770,
        score: 5621,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_016",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-01T21:00:00+09:00",
        durationSeconds: 5538,
        score: 5844,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_007",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-26T22:00:00+09:00",
        durationSeconds: 4058,
        score: 7974,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_017",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-17T23:00:00+09:00",
        durationSeconds: 8793,
        score: 957,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-12T19:00:00+09:00",
        durationSeconds: 7526,
        score: 5728,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_028",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-11T19:00:00+09:00",
        durationSeconds: 4167,
        score: 6945,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_018",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-10T22:00:00+09:00",
        durationSeconds: 4538,
        score: 3814,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_009",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-05T19:00:00+09:00",
        durationSeconds: 5580,
        score: 8400,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_029",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-04T21:00:00+09:00",
        durationSeconds: 5888,
        score: 6249,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_019",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-03T22:00:00+09:00",
        durationSeconds: 7061,
        score: 9454,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_030",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-28T20:00:00+09:00",
        durationSeconds: 8854,
        score: 9815,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_020",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-27T19:00:00+09:00",
        durationSeconds: 6896,
        score: 4243,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_010",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-22T21:00:00+09:00",
        durationSeconds: 4885,
        score: 7774,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_021",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-20T20:00:00+09:00",
        durationSeconds: 7362,
        score: 2194,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 7994,
        score: 5661,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_031",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-14T21:00:00+09:00",
        durationSeconds: 9259,
        score: 8406,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_069_022",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-13T18:00:00+09:00",
        durationSeconds: 7082,
        score: 2701,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "70",
    channelId: "UC_mock_070",
    name: "雫石ライデン",
    description: "作業配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V070",
    bannerUrl: "https://placehold.co/640x180?text=V070",
    youtubeUrl: "https://www.youtube.com/@example-v070",
    subscriberCount: 10321,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "model_png", approved: false },
      { value: "hair_green", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_cool", approved: false },
      { value: "genre_study", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_cool", approved: false },
      // "stream_time_morning",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_070_001",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T18:00:00+09:00",
        durationSeconds: 6665,
        score: 6218,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 8059,
        score: 5136,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_013",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-30T19:00:00+09:00",
        durationSeconds: 9279,
        score: 7006,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_002",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T18:00:00+09:00",
        durationSeconds: 9207,
        score: 3487,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_015",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-23T21:00:00+09:00",
        durationSeconds: 10654,
        score: 9334,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_003",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-14T23:00:00+09:00",
        durationSeconds: 10658,
        score: 2433,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_016",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-09T19:00:00+09:00",
        durationSeconds: 8627,
        score: 6411,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_004",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-07T22:00:00+09:00",
        durationSeconds: 9243,
        score: 2159,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_017",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-02T23:00:00+09:00",
        durationSeconds: 5068,
        score: 4758,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_005",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-30T18:00:00+09:00",
        durationSeconds: 3767,
        score: 9454,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_006",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-23T22:00:00+09:00",
        durationSeconds: 9493,
        score: 5292,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_018",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-18T22:00:00+09:00",
        durationSeconds: 10207,
        score: 3894,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-16T21:00:00+09:00",
        durationSeconds: 9661,
        score: 1113,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_019",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-11T20:00:00+09:00",
        durationSeconds: 10716,
        score: 3043,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_008",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-09T23:00:00+09:00",
        durationSeconds: 5439,
        score: 4830,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_009",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-02T22:00:00+09:00",
        durationSeconds: 9644,
        score: 4997,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_020",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-28T22:00:00+09:00",
        durationSeconds: 4534,
        score: 4989,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_010",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-26T20:00:00+09:00",
        durationSeconds: 6209,
        score: 2240,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_011",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-19T20:00:00+09:00",
        durationSeconds: 8339,
        score: 842,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_021",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-14T23:00:00+09:00",
        durationSeconds: 6310,
        score: 3256,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_070_012",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 10813,
        score: 4021,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "71",
    channelId: "UC_mock_071",
    name: "水無月サクラ",
    description: "作業配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V071",
    bannerUrl: "https://placehold.co/640x180?text=V071",
    youtubeUrl: "https://www.youtube.com/@example-v071",
    subscriberCount: 675348,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_navy", approved: true },
      { value: "eye_yellow", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "accessory_animal_ears", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_husky", approved: true },
      { value: "genre_study", approved: true },
      { value: "personality_serious", approved: true },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_early_morning",
      { value: "stream_frequency_low", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_071_002",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T22:00:00+09:00",
        durationSeconds: 4463,
        score: 1986,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_001",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 6485,
        score: 9260,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_003",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T21:00:00+09:00",
        durationSeconds: 5924,
        score: 7662,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_004",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-18T21:00:00+09:00",
        durationSeconds: 5323,
        score: 6434,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_005",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-11T23:00:00+09:00",
        durationSeconds: 5948,
        score: 8894,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_006",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-04T18:00:00+09:00",
        durationSeconds: 10092,
        score: 8052,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_007",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-27T21:00:00+09:00",
        durationSeconds: 9019,
        score: 6355,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_008",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-20T18:00:00+09:00",
        durationSeconds: 6300,
        score: 9603,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_009",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-13T22:00:00+09:00",
        durationSeconds: 7119,
        score: 9955,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_010",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-06T19:00:00+09:00",
        durationSeconds: 6533,
        score: 8522,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_011",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-23T22:00:00+09:00",
        durationSeconds: 5335,
        score: 6346,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_071_012",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 10536,
        score: 7573,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "72",
    channelId: "UC_mock_072",
    name: "朱雀サクラ",
    description: "個人勢VTuberとして同時視聴配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V072",
    bannerUrl: "https://placehold.co/640x180?text=V072",
    youtubeUrl: "https://www.youtube.com/@example-v072",
    subscriberCount: 649295,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: true },
      { value: "model_live2d", approved: false },
      { value: "model_3d", approved: true },
      { value: "hair_purple", approved: false },
      { value: "eye_green", approved: false },
      { value: "hair_length_long", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_cool", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "personality_chaotic", approved: true },
      { value: "personality_cool", approved: true },
      // stream_viewer_partcition,
      // stream_long
      // "stream_time_evening",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_072_001",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T23:00:00+09:00",
        durationSeconds: 6807,
        score: 9917,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_002",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 4869,
        score: 9442,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_003",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T21:00:00+09:00",
        durationSeconds: 7949,
        score: 4671,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_004",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T18:00:00+09:00",
        durationSeconds: 5030,
        score: 6474,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_005",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-10T21:00:00+09:00",
        durationSeconds: 6974,
        score: 921,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_006",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-03T22:00:00+09:00",
        durationSeconds: 6005,
        score: 4970,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_007",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-26T18:00:00+09:00",
        durationSeconds: 6158,
        score: 3726,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_008",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-19T19:00:00+09:00",
        durationSeconds: 5510,
        score: 5762,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_009",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-12T19:00:00+09:00",
        durationSeconds: 8005,
        score: 1995,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_010",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-05T20:00:00+09:00",
        durationSeconds: 3618,
        score: 4853,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_011",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-29T19:00:00+09:00",
        durationSeconds: 7522,
        score: 1994,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_012",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-22T20:00:00+09:00",
        durationSeconds: 8522,
        score: 3135,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_072_013",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 7908,
        score: 5624,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "73",
    channelId: "UC_mock_073",
    name: "雷電ウスバ",
    description: "同時視聴配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V073",
    bannerUrl: "https://placehold.co/640x180?text=V073",
    youtubeUrl: "https://www.youtube.com/@example-v073",
    subscriberCount: 7668,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_ja", approved: false },
      { value: "model_3d", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_gray", approved: true },
      { value: "eye_blue", approved: false },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "accessory_animal_ears", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_boyish", approved: true },
      { value: "genre_watchalong", approved: false },
      { value: "personality_funny", approved: true },
      { value: "personality_serious", approved: true },
      { value: "personality_relaxing", approved: true },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_evening",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_073_001",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T18:00:00+09:00",
        durationSeconds: 6398,
        score: 4892,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_002",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T21:00:00+09:00",
        durationSeconds: 6458,
        score: 9058,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 6983,
        score: 9093,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_004",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T21:00:00+09:00",
        durationSeconds: 4172,
        score: 6248,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_005",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T20:00:00+09:00",
        durationSeconds: 4346,
        score: 8159,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_006",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T19:00:00+09:00",
        durationSeconds: 8125,
        score: 5463,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_007",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T23:00:00+09:00",
        durationSeconds: 3723,
        score: 7680,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_008",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T23:00:00+09:00",
        durationSeconds: 4780,
        score: 1778,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_009",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-08T20:00:00+09:00",
        durationSeconds: 4324,
        score: 7264,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_010",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-01T18:00:00+09:00",
        durationSeconds: 6336,
        score: 5182,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_011",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-25T23:00:00+09:00",
        durationSeconds: 3713,
        score: 1830,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_012",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-18T23:00:00+09:00",
        durationSeconds: 4294,
        score: 594,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_073_013",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 6061,
        score: 4512,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "74",
    channelId: "UC_mock_074",
    name: "雫石カザマ",
    description: "歌枠をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V074",
    bannerUrl: "https://placehold.co/640x180?text=V074",
    youtubeUrl: "https://www.youtube.com/@example-v074",
    subscriberCount: 33546,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_black", approved: true },
      { value: "eye_black", approved: true },
      { value: "hair_length_very_long", approved: false },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_husky", approved: true },
      { value: "genre_singing", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_funny", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_early_morning",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_074_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-02T21:00:00+09:00",
        durationSeconds: 2142,
        score: 5074,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_001",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-29T22:00:00+09:00",
        durationSeconds: 2299,
        score: 2604,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_013",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-26T21:00:00+09:00",
        durationSeconds: 2087,
        score: 378,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_002",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-22T22:00:00+09:00",
        durationSeconds: 3649,
        score: 6435,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_014",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-19T20:00:00+09:00",
        durationSeconds: 1306,
        score: 7190,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-15T19:00:00+09:00",
        durationSeconds: 3149,
        score: 940,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_015",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-12T22:00:00+09:00",
        durationSeconds: 2212,
        score: 2413,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_004",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-08T19:00:00+09:00",
        durationSeconds: 967,
        score: 4445,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_016",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-05T22:00:00+09:00",
        durationSeconds: 1853,
        score: 8474,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_005",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-01T19:00:00+09:00",
        durationSeconds: 1199,
        score: 8811,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_017",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-28T18:00:00+09:00",
        durationSeconds: 1655,
        score: 8587,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_006",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-24T22:00:00+09:00",
        durationSeconds: 1722,
        score: 9669,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_018",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-21T21:00:00+09:00",
        durationSeconds: 2140,
        score: 8080,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_019",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-14T20:00:00+09:00",
        durationSeconds: 1510,
        score: 3989,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_007",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-10T18:00:00+09:00",
        durationSeconds: 3016,
        score: 4712,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_020",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-07T18:00:00+09:00",
        durationSeconds: 3416,
        score: 2718,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_008",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-03T19:00:00+09:00",
        durationSeconds: 1987,
        score: 6188,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_021",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-31T22:00:00+09:00",
        durationSeconds: 2314,
        score: 3124,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_009",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-27T19:00:00+09:00",
        durationSeconds: 2898,
        score: 2764,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_022",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-24T18:00:00+09:00",
        durationSeconds: 976,
        score: 3676,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_010",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-20T19:00:00+09:00",
        durationSeconds: 1720,
        score: 3814,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_023",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-17T19:00:00+09:00",
        durationSeconds: 1353,
        score: 9840,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_074_011",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-13T20:00:00+09:00",
        durationSeconds: 1561,
        score: 8765,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_074_024",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-10T23:00:00+09:00",
        durationSeconds: 1812,
        score: 4277,
        attributes: [
          "genre_singing",
        ],
      }
    ],
  },
  {
    id: "75",
    channelId: "UC_mock_075",
    name: "薄羽ゆき",
    description: "配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V075",
    bannerUrl: "https://placehold.co/640x180?text=V075",
    youtubeUrl: "https://www.youtube.com/@example-v075",
    subscriberCount: 2437,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: false },
      { value: "model_3d", approved: true },
      { value: "hair_silver", approved: true },
      { value: "eye_pink", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_animal_ears", approved: false },
      { value: "accessory_glasses", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "voice_androgynous", approved: true },
      { value: "genre_other", approved: false },
      { value: "genre_watchalong", approved: false },
      { value: "personality_calm", approved: true },
      // stream_viewer_partcition,
      // "stream_time_evening",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_friday", approved: false },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_075_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 8760,
        score: 8722,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_001",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 6473,
        score: 7990,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_015",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-30T22:00:00+09:00",
        durationSeconds: 4037,
        score: 4107,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_014",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-30T20:00:00+09:00",
        durationSeconds: 1505,
        score: 7889,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_003",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T18:00:00+09:00",
        durationSeconds: 2689,
        score: 3295,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_016",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-23T22:00:00+09:00",
        durationSeconds: 3630,
        score: 2444,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_004",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 2478,
        score: 4031,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_017",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-16T21:00:00+09:00",
        durationSeconds: 1341,
        score: 728,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_005",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-10T18:00:00+09:00",
        durationSeconds: 3596,
        score: 5198,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_018",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-07-09T20:00:00+09:00",
        durationSeconds: 1736,
        score: 2043,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_006",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-03T21:00:00+09:00",
        durationSeconds: 8633,
        score: 3783,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_019",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-07-02T20:00:00+09:00",
        durationSeconds: 1580,
        score: 4563,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_007",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 1538,
        score: 6763,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_020",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-25T23:00:00+09:00",
        durationSeconds: 2287,
        score: 4855,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-19T20:00:00+09:00",
        durationSeconds: 5470,
        score: 6645,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_021",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-18T19:00:00+09:00",
        durationSeconds: 7810,
        score: 3586,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_009",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-12T22:00:00+09:00",
        durationSeconds: 8009,
        score: 6015,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_010",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-05T23:00:00+09:00",
        durationSeconds: 8028,
        score: 1013,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_011",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-29T23:00:00+09:00",
        durationSeconds: 2334,
        score: 7005,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_022",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-28T20:00:00+09:00",
        durationSeconds: 2756,
        score: 4901,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_075_012",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 5983,
        score: 7307,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_023",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-21T18:00:00+09:00",
        durationSeconds: 7014,
        score: 6207,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_075_013",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-15T18:00:00+09:00",
        durationSeconds: 3202,
        score: 547,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "76",
    channelId: "UC_mock_076",
    name: "空木サクラ",
    description: "同時視聴配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V076",
    bannerUrl: "https://placehold.co/640x180?text=V076",
    youtubeUrl: "https://www.youtube.com/@example-v076",
    subscriberCount: 3282,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_en", approved: true },
      { value: "model_png", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_brown", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_androgynous", approved: true },
      { value: "genre_watchalong", approved: false },
      { value: "genre_game", approved: false },
      { value: "game_retro", approved: false },
      { value: "game_horror", approved: true },
      { value: "personality_cool", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_gentle", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_afternoon",
      { value: "stream_frequency_daily", approved: false },
      { value: "day_monday", approved: true },
      { value: "day_sunday", approved: true },
      { value: "day_friday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_076_001",
        title: "【ホラーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T22:00:00+09:00",
        durationSeconds: 6555,
        score: 2702,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_025",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 4954,
        score: 775,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_024",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 2176,
        score: 8707,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_012",
        title: "【ホラーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-26T21:00:00+09:00",
        durationSeconds: 4294,
        score: 1618,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_026",
        title: "【ホラーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-24T22:00:00+09:00",
        durationSeconds: 5100,
        score: 236,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-20T21:00:00+09:00",
        durationSeconds: 4693,
        score: 166,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_013",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-19T23:00:00+09:00",
        durationSeconds: 3933,
        score: 7085,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_027",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 4216,
        score: 1190,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_003",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-13T19:00:00+09:00",
        durationSeconds: 5130,
        score: 8623,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_014",
        title: "【ホラーゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-12T23:00:00+09:00",
        durationSeconds: 3868,
        score: 4962,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_028",
        title: "【ホラーゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 4050,
        score: 9293,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_004",
        title: "【ホラーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T18:00:00+09:00",
        durationSeconds: 3960,
        score: 4889,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_015",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-05T22:00:00+09:00",
        durationSeconds: 7094,
        score: 3626,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_005",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-29T18:00:00+09:00",
        durationSeconds: 2545,
        score: 1433,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_016",
        title: "【ホラーゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-28T19:00:00+09:00",
        durationSeconds: 4340,
        score: 5771,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_029",
        title: "【ホラーゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-26T20:00:00+09:00",
        durationSeconds: 5561,
        score: 8337,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_006",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-22T21:00:00+09:00",
        durationSeconds: 8647,
        score: 8898,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_017",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-21T21:00:00+09:00",
        durationSeconds: 4960,
        score: 8004,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_030",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-19T18:00:00+09:00",
        durationSeconds: 6406,
        score: 8875,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_018",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-14T18:00:00+09:00",
        durationSeconds: 3077,
        score: 3232,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_031",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-12T20:00:00+09:00",
        durationSeconds: 8884,
        score: 2722,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_007",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-08T21:00:00+09:00",
        durationSeconds: 4195,
        score: 2172,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_019",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-07T19:00:00+09:00",
        durationSeconds: 3653,
        score: 5030,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_032",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-05T20:00:00+09:00",
        durationSeconds: 6812,
        score: 2601,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_008",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-01T19:00:00+09:00",
        durationSeconds: 2103,
        score: 6316,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_020",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-31T22:00:00+09:00",
        durationSeconds: 7046,
        score: 230,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_009",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-25T19:00:00+09:00",
        durationSeconds: 4572,
        score: 5003,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      },
      {
        videoId: "mock_video_076_021",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-24T23:00:00+09:00",
        durationSeconds: 8858,
        score: 2556,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_033",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-22T20:00:00+09:00",
        durationSeconds: 7237,
        score: 2434,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_010",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T22:00:00+09:00",
        durationSeconds: 6435,
        score: 1457,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_022",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-17T23:00:00+09:00",
        durationSeconds: 7304,
        score: 205,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_034",
        title: "【ホラーゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-15T21:00:00+09:00",
        durationSeconds: 4147,
        score: 7275,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_076_011",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 5123,
        score: 8103,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_076_023",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-10T22:00:00+09:00",
        durationSeconds: 2120,
        score: 3966,
        attributes: [
          "genre_game",
          "game_horror",
        ],
      }
    ],
  },
  {
    id: "77",
    channelId: "UC_mock_077",
    name: "風間そら",
    description: "個人勢VTuberとしてゲーム配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V077",
    bannerUrl: "https://placehold.co/640x180?text=V077",
    youtubeUrl: "https://www.youtube.com/@example-v077",
    subscriberCount: 242643,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_ja", approved: false },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_brown", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "voice_soft", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_retro", approved: true },
      { value: "game_puzzle", approved: true },
      { value: "personality_relaxing", approved: true },
      // stream_long
      // "stream_time_evening",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_thursday", approved: false },
    ],
    videos: [
      {
        videoId: "mock_video_077_001",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T18:00:00+09:00",
        durationSeconds: 4108,
        score: 859,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_012",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 5055,
        score: 1951,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_021",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 4976,
        score: 3085,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_002",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 4084,
        score: 1533,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_022",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-23T21:00:00+09:00",
        durationSeconds: 2308,
        score: 3904,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_003",
        title: "【パズルゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T21:00:00+09:00",
        durationSeconds: 2231,
        score: 905,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_013",
        title: "【パズルゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-17T22:00:00+09:00",
        durationSeconds: 4407,
        score: 2815,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_023",
        title: "【パズルゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-16T19:00:00+09:00",
        durationSeconds: 4715,
        score: 8153,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_004",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T21:00:00+09:00",
        durationSeconds: 6310,
        score: 3122,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_024",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-09T18:00:00+09:00",
        durationSeconds: 4064,
        score: 4903,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_014",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-03T23:00:00+09:00",
        durationSeconds: 1945,
        score: 5082,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_025",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-02T19:00:00+09:00",
        durationSeconds: 2249,
        score: 1361,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_005",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-29T19:00:00+09:00",
        durationSeconds: 6787,
        score: 3477,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_006",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-22T23:00:00+09:00",
        durationSeconds: 2271,
        score: 1027,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_015",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 4258,
        score: 3335,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_026",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-06-18T19:00:00+09:00",
        durationSeconds: 5339,
        score: 7690,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_007",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-15T21:00:00+09:00",
        durationSeconds: 6018,
        score: 1948,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_016",
        title: "【パズルゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-12T22:00:00+09:00",
        durationSeconds: 7223,
        score: 5684,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_027",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-11T23:00:00+09:00",
        durationSeconds: 2014,
        score: 3768,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_008",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-08T22:00:00+09:00",
        durationSeconds: 7086,
        score: 6203,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_017",
        title: "【パズルゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-05T21:00:00+09:00",
        durationSeconds: 1866,
        score: 9483,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_028",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-04T19:00:00+09:00",
        durationSeconds: 3441,
        score: 7213,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_009",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-01T18:00:00+09:00",
        durationSeconds: 6958,
        score: 2966,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_018",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-29T23:00:00+09:00",
        durationSeconds: 5494,
        score: 8565,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_029",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-05-28T18:00:00+09:00",
        durationSeconds: 2955,
        score: 6369,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_019",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 4892,
        score: 4345,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_030",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-21T23:00:00+09:00",
        durationSeconds: 5681,
        score: 777,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_010",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T19:00:00+09:00",
        durationSeconds: 4860,
        score: 42,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      },
      {
        videoId: "mock_video_077_020",
        title: "【パズルゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-15T19:00:00+09:00",
        durationSeconds: 2757,
        score: 4827,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_077_011",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 5078,
        score: 1657,
        attributes: [
          "genre_game",
          "game_puzzle",
        ],
      }
    ],
  },
  {
    id: "78",
    channelId: "UC_mock_078",
    name: "雪代ウツギ",
    description: "雑談配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V078",
    bannerUrl: "https://placehold.co/640x180?text=V078",
    youtubeUrl: "https://www.youtube.com/@example-v078",
    subscriberCount: 252117,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_live2d", approved: false },
      { value: "hair_green", approved: true },
      { value: "eye_purple", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_mature", approved: true },
      { value: "genre_talk", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "talk_consultation", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_natural", approved: true },
      // "stream_time_early_morning",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_078_001",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T20:00:00+09:00",
        durationSeconds: 7263,
        score: 5653,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_078_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 3682,
        score: 6699,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_078_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 6369,
        score: 413,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_078_004",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T21:00:00+09:00",
        durationSeconds: 6192,
        score: 7913,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_078_005",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T21:00:00+09:00",
        durationSeconds: 4522,
        score: 4855,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_078_006",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T21:00:00+09:00",
        durationSeconds: 2643,
        score: 7038,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_078_007",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T20:00:00+09:00",
        durationSeconds: 4273,
        score: 9419,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_078_008",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T20:00:00+09:00",
        durationSeconds: 2855,
        score: 7872,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_078_009",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-25T19:00:00+09:00",
        durationSeconds: 3918,
        score: 5423,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      },
      {
        videoId: "mock_video_078_010",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-18T18:00:00+09:00",
        durationSeconds: 3515,
        score: 4918,
        attributes: [
          "genre_talk",
          "talk_consultation",
        ],
      }
    ],
  },
  {
    id: "79",
    channelId: "UC_mock_079",
    name: "星宮みかん",
    description: "ASMR配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V079",
    bannerUrl: "https://placehold.co/640x180?text=V079",
    youtubeUrl: "https://www.youtube.com/@example-v079",
    subscriberCount: 2111,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_png", approved: false },
      { value: "hair_blonde", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_middle", approved: false },
      { value: "voice_whisper", approved: true },
      { value: "voice_cool", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "personality_funny", approved: true },
      { value: "personality_gentle", approved: true },
      // stream_long
      // "stream_time_afternoon",
      { value: "stream_frequency_low", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_079_001",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 2501,
        score: 8049,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_002",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 4909,
        score: 4096,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_003",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-23T23:00:00+09:00",
        durationSeconds: 4902,
        score: 815,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_004",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-16T18:00:00+09:00",
        durationSeconds: 2106,
        score: 1779,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_005",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-09T23:00:00+09:00",
        durationSeconds: 3485,
        score: 3288,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_006",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-18T23:00:00+09:00",
        durationSeconds: 5307,
        score: 7481,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_007",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-04T18:00:00+09:00",
        durationSeconds: 4445,
        score: 8545,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_008",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-28T21:00:00+09:00",
        durationSeconds: 3276,
        score: 1450,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_009",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 4852,
        score: 9667,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_079_010",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-14T18:00:00+09:00",
        durationSeconds: 5331,
        score: 343,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "80",
    channelId: "UC_mock_080",
    name: "薄羽ウスバ",
    description: "料理配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V080",
    bannerUrl: "https://placehold.co/640x180?text=V080",
    youtubeUrl: "https://www.youtube.com/@example-v080",
    subscriberCount: 650,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_multicolor", approved: true },
      { value: "eye_blue", approved: false },
      { value: "hair_length_short", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_soft", approved: false },
      { value: "genre_cooking", approved: true },
      { value: "genre_game", approved: false },
      { value: "game_retro", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_cheerful", approved: false },
      { value: "personality_chaotic", approved: false },
      // stream_collab,
      // "stream_time_midnight",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_080_001",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T23:00:00+09:00",
        durationSeconds: 985,
        score: 8368,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_014",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 1560,
        score: 5896,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_013",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 2314,
        score: 6120,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_002",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T18:00:00+09:00",
        durationSeconds: 1476,
        score: 5501,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_015",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-25T21:00:00+09:00",
        durationSeconds: 1574,
        score: 2101,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_003",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T23:00:00+09:00",
        durationSeconds: 1870,
        score: 2283,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_024",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-20T19:00:00+09:00",
        durationSeconds: 1473,
        score: 5542,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_016",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 6414,
        score: 4923,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_004",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T22:00:00+09:00",
        durationSeconds: 1530,
        score: 1008,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_025",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-13T19:00:00+09:00",
        durationSeconds: 925,
        score: 4777,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_017",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-11T22:00:00+09:00",
        durationSeconds: 2196,
        score: 6703,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_005",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-07T23:00:00+09:00",
        durationSeconds: 2622,
        score: 4064,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_026",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-06T21:00:00+09:00",
        durationSeconds: 4974,
        score: 3985,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_018",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 7084,
        score: 5293,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_006",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-30T21:00:00+09:00",
        durationSeconds: 4498,
        score: 4978,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_027",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-06-29T22:00:00+09:00",
        durationSeconds: 6586,
        score: 4394,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_019",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-27T21:00:00+09:00",
        durationSeconds: 1812,
        score: 502,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_007",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-23T18:00:00+09:00",
        durationSeconds: 2040,
        score: 9573,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_020",
        title: "【レトロゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 3470,
        score: 8851,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_008",
        title: "【レトロゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-16T23:00:00+09:00",
        durationSeconds: 5373,
        score: 5027,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_009",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-09T18:00:00+09:00",
        durationSeconds: 2403,
        score: 1485,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_028",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 2044,
        score: 110,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-02T21:00:00+09:00",
        durationSeconds: 1422,
        score: 2489,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_029",
        title: "【レトロゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-01T21:00:00+09:00",
        durationSeconds: 4083,
        score: 4740,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_021",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-30T23:00:00+09:00",
        durationSeconds: 1173,
        score: 2298,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_011",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-26T22:00:00+09:00",
        durationSeconds: 1616,
        score: 4284,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_030",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-05-25T20:00:00+09:00",
        durationSeconds: 6923,
        score: 6799,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      },
      {
        videoId: "mock_video_080_022",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-23T18:00:00+09:00",
        durationSeconds: 1766,
        score: 3815,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_023",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-16T21:00:00+09:00",
        durationSeconds: 1026,
        score: 1921,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 1595,
        score: 3808,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_080_031",
        title: "【レトロゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-05-11T19:00:00+09:00",
        durationSeconds: 5896,
        score: 8874,
        attributes: [
          "genre_game",
          "game_retro",
        ],
      }
    ],
  },
  {
    id: "81",
    channelId: "UC_mock_081",
    name: "空木カザマ",
    description: "同時視聴配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V081",
    bannerUrl: "https://placehold.co/640x180?text=V081",
    youtubeUrl: "https://www.youtube.com/@example-v081",
    subscriberCount: 99686,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_png", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_yellow", approved: true },
      { value: "eye_red", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_watchalong", approved: false },
      { value: "personality_calm", approved: false },
      // stream_long
      // "stream_time_early_morning",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_tuesday", approved: false },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_081_001",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T21:00:00+09:00",
        durationSeconds: 7253,
        score: 1196,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_013",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 4468,
        score: 3955,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_012",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 7478,
        score: 23,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T23:00:00+09:00",
        durationSeconds: 7684,
        score: 6741,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T18:00:00+09:00",
        durationSeconds: 6411,
        score: 2333,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_014",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-16T22:00:00+09:00",
        durationSeconds: 8153,
        score: 2985,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_004",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T23:00:00+09:00",
        durationSeconds: 5233,
        score: 4069,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_005",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-07T19:00:00+09:00",
        durationSeconds: 5559,
        score: 324,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_015",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-02T22:00:00+09:00",
        durationSeconds: 6030,
        score: 6559,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_006",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-30T23:00:00+09:00",
        durationSeconds: 3608,
        score: 3229,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_016",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-25T21:00:00+09:00",
        durationSeconds: 6727,
        score: 5996,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_007",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-23T18:00:00+09:00",
        durationSeconds: 7701,
        score: 9754,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_017",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-18T20:00:00+09:00",
        durationSeconds: 3892,
        score: 460,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_008",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-09T20:00:00+09:00",
        durationSeconds: 3900,
        score: 7499,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_018",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-04T19:00:00+09:00",
        durationSeconds: 7818,
        score: 2981,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_009",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-02T20:00:00+09:00",
        durationSeconds: 5303,
        score: 3671,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_019",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-21T18:00:00+09:00",
        durationSeconds: 7001,
        score: 8722,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_010",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-19T20:00:00+09:00",
        durationSeconds: 6521,
        score: 6517,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_020",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-14T22:00:00+09:00",
        durationSeconds: 8700,
        score: 7984,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_081_011",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-12T21:00:00+09:00",
        durationSeconds: 6937,
        score: 3786,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "82",
    channelId: "UC_mock_082",
    name: "薄羽サクラ",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V082",
    bannerUrl: "https://placehold.co/640x180?text=V082",
    youtubeUrl: "https://www.youtube.com/@example-v082",
    subscriberCount: 717011,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_pink", approved: true },
      { value: "eye_pink", approved: true },
      { value: "hair_length_very_short", approved: false },
      { value: "accessory_tail", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_soft", approved: true },
      { value: "genre_drawing", approved: false },
      { value: "personality_cheerful", approved: true },
      // "stream_time_evening",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_sunday", approved: false },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_082_018",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-08-05T19:00:00+09:00",
        durationSeconds: 6951,
        score: 743,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_001",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T18:00:00+09:00",
        durationSeconds: 4353,
        score: 245,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-08-02T21:00:00+09:00",
        durationSeconds: 9708,
        score: 3588,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_019",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-07-29T23:00:00+09:00",
        durationSeconds: 3843,
        score: 5643,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_002",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T21:00:00+09:00",
        durationSeconds: 9521,
        score: 8749,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_012",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-26T23:00:00+09:00",
        durationSeconds: 3972,
        score: 6745,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_020",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-07-22T22:00:00+09:00",
        durationSeconds: 4918,
        score: 6605,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T20:00:00+09:00",
        durationSeconds: 9807,
        score: 9610,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_013",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-12T21:00:00+09:00",
        durationSeconds: 5858,
        score: 7740,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_021",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-07-08T22:00:00+09:00",
        durationSeconds: 9864,
        score: 2599,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_004",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-06T22:00:00+09:00",
        durationSeconds: 8045,
        score: 9067,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_022",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-01T22:00:00+09:00",
        durationSeconds: 8808,
        score: 6374,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_005",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 7367,
        score: 98,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_014",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-28T20:00:00+09:00",
        durationSeconds: 6365,
        score: 6866,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_023",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-06-24T18:00:00+09:00",
        durationSeconds: 8410,
        score: 9482,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_015",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-21T19:00:00+09:00",
        durationSeconds: 5065,
        score: 1313,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_006",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-15T18:00:00+09:00",
        durationSeconds: 8800,
        score: 5632,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_016",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-14T19:00:00+09:00",
        durationSeconds: 9699,
        score: 5316,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_024",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-06-10T19:00:00+09:00",
        durationSeconds: 6024,
        score: 8839,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_025",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-06-03T18:00:00+09:00",
        durationSeconds: 9709,
        score: 563,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_007",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-01T23:00:00+09:00",
        durationSeconds: 3715,
        score: 5548,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_026",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-05-27T20:00:00+09:00",
        durationSeconds: 5147,
        score: 8732,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_008",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-25T18:00:00+09:00",
        durationSeconds: 6027,
        score: 2357,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_027",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-05-20T20:00:00+09:00",
        durationSeconds: 4712,
        score: 8636,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_009",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-18T18:00:00+09:00",
        durationSeconds: 5009,
        score: 2868,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_017",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-17T20:00:00+09:00",
        durationSeconds: 4360,
        score: 8302,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_082_010",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-11T18:00:00+09:00",
        durationSeconds: 4805,
        score: 8942,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "83",
    channelId: "UC_mock_083",
    name: "天霧リン",
    description: "企業勢VTuberとして配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V083",
    bannerUrl: "https://placehold.co/640x180?text=V083",
    youtubeUrl: "https://www.youtube.com/@example-v083",
    subscriberCount: 97892,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_brown", approved: true },
      { value: "eye_purple", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "accessory_glasses", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_mature", approved: false },
      { value: "genre_other", approved: true },
      { value: "personality_serious", approved: true },
      { value: "personality_cool", approved: true },
      { value: "personality_calm", approved: true },
      // stream_long
      // stream_viewer_partcition,
      // "stream_time_morning",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_tuesday", approved: false },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_083_001",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T21:00:00+09:00",
        durationSeconds: 3394,
        score: 5248,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_009",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-07-30T20:00:00+09:00",
        durationSeconds: 2640,
        score: 4093,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_008",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-07-30T19:00:00+09:00",
        durationSeconds: 1852,
        score: 9262,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_002",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 2555,
        score: 3224,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_010",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-23T18:00:00+09:00",
        durationSeconds: 2289,
        score: 8369,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_003",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T22:00:00+09:00",
        durationSeconds: 2923,
        score: 5466,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_011",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-16T19:00:00+09:00",
        durationSeconds: 2374,
        score: 5372,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_012",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-09T20:00:00+09:00",
        durationSeconds: 1118,
        score: 9991,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_004",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-07T23:00:00+09:00",
        durationSeconds: 2973,
        score: 7111,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_013",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-02T22:00:00+09:00",
        durationSeconds: 2527,
        score: 8097,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_014",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-18T22:00:00+09:00",
        durationSeconds: 1637,
        score: 8939,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_005",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-16T18:00:00+09:00",
        durationSeconds: 1454,
        score: 8106,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_006",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-09T23:00:00+09:00",
        durationSeconds: 2606,
        score: 1296,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_015",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-04T18:00:00+09:00",
        durationSeconds: 1422,
        score: 1575,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_016",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-05-28T20:00:00+09:00",
        durationSeconds: 1042,
        score: 9873,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_017",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-21T18:00:00+09:00",
        durationSeconds: 1395,
        score: 328,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_083_007",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 3563,
        score: 61,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "84",
    channelId: "UC_mock_084",
    name: "紅葉ヨル",
    description: "個人勢VTuberとしてASMR配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V084",
    bannerUrl: "https://placehold.co/640x180?text=V084",
    youtubeUrl: "https://www.youtube.com/@example-v084",
    subscriberCount: 5693,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_black", approved: true },
      { value: "eye_yellow", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_glasses", approved: true },
      { value: "voice_pitch_very_high", approved: false },
      { value: "voice_cool", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "personality_funny", approved: true },
      { value: "personality_cheerful", approved: true },
      // stream_viewer_partcition,
      // "stream_time_night",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_tuesday", approved: false },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_084_010",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-08-03T19:00:00+09:00",
        durationSeconds: 1887,
        score: 5209,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_001",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 3969,
        score: 3323,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_011",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-27T21:00:00+09:00",
        durationSeconds: 3689,
        score: 9230,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_012",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-20T23:00:00+09:00",
        durationSeconds: 3619,
        score: 6034,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_002",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-14T21:00:00+09:00",
        durationSeconds: 5210,
        score: 2981,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_013",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-13T22:00:00+09:00",
        durationSeconds: 2985,
        score: 4177,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_003",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-07T23:00:00+09:00",
        durationSeconds: 2554,
        score: 9142,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_004",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-23T22:00:00+09:00",
        durationSeconds: 4222,
        score: 9812,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_014",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-22T18:00:00+09:00",
        durationSeconds: 2872,
        score: 8312,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_005",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-16T21:00:00+09:00",
        durationSeconds: 1997,
        score: 3875,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_015",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-15T19:00:00+09:00",
        durationSeconds: 2222,
        score: 9444,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_006",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-09T19:00:00+09:00",
        durationSeconds: 3244,
        score: 8104,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_016",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-08T19:00:00+09:00",
        durationSeconds: 5184,
        score: 6346,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_007",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-02T18:00:00+09:00",
        durationSeconds: 5305,
        score: 4492,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_017",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-01T20:00:00+09:00",
        durationSeconds: 4059,
        score: 4892,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_008",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-26T21:00:00+09:00",
        durationSeconds: 5169,
        score: 4555,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_018",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-25T23:00:00+09:00",
        durationSeconds: 4012,
        score: 9673,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_009",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-19T20:00:00+09:00",
        durationSeconds: 3422,
        score: 1257,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_084_019",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-11T20:00:00+09:00",
        durationSeconds: 2587,
        score: 4224,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "85",
    channelId: "UC_mock_085",
    name: "雫石つむぎ",
    description: "ゲーム配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V085",
    bannerUrl: "https://placehold.co/640x180?text=V085",
    youtubeUrl: "https://www.youtube.com/@example-v085",
    subscriberCount: 577,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: false },
      { value: "model_png", approved: false },
      { value: "hair_purple", approved: true },
      { value: "eye_orange", approved: true },
      { value: "hair_length_very_short", approved: false },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_cute", approved: true },
      { value: "voice_androgynous", approved: true },
      { value: "genre_game", approved: true },
      { value: "game_tps", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_chaotic", approved: true },
      // "stream_time_early_morning",
      { value: "stream_frequency_high", approved: true },
      { value: "day_wednesday", approved: false },
      { value: "day_thursday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_085_001",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-05T21:00:00+09:00",
        durationSeconds: 3051,
        score: 2685,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_021",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-07-31T22:00:00+09:00",
        durationSeconds: 4731,
        score: 7220,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_011",
        title: "【TPS】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-30T22:00:00+09:00",
        durationSeconds: 5604,
        score: 6461,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_002",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-29T18:00:00+09:00",
        durationSeconds: 2138,
        score: 4076,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_012",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-23T20:00:00+09:00",
        durationSeconds: 5608,
        score: 4274,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_013",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-16T21:00:00+09:00",
        durationSeconds: 6152,
        score: 3752,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_003",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-15T18:00:00+09:00",
        durationSeconds: 2705,
        score: 5779,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_022",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 2160,
        score: 5519,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_004",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-08T20:00:00+09:00",
        durationSeconds: 6782,
        score: 7154,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_023",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-03T22:00:00+09:00",
        durationSeconds: 4101,
        score: 8818,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_014",
        title: "【TPS】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-02T22:00:00+09:00",
        durationSeconds: 5658,
        score: 1024,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_005",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-01T18:00:00+09:00",
        durationSeconds: 3296,
        score: 4582,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_024",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-06-26T18:00:00+09:00",
        durationSeconds: 4453,
        score: 6227,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_015",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-25T23:00:00+09:00",
        durationSeconds: 3278,
        score: 6252,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_006",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 1808,
        score: 5021,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_016",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-18T22:00:00+09:00",
        durationSeconds: 6651,
        score: 4114,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_007",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-17T19:00:00+09:00",
        durationSeconds: 3971,
        score: 5934,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_025",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-06-12T20:00:00+09:00",
        durationSeconds: 6946,
        score: 8713,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_017",
        title: "【TPS】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-11T23:00:00+09:00",
        durationSeconds: 4462,
        score: 7992,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_008",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-03T21:00:00+09:00",
        durationSeconds: 4659,
        score: 8999,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_026",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-05-29T22:00:00+09:00",
        durationSeconds: 6088,
        score: 2395,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_018",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-28T21:00:00+09:00",
        durationSeconds: 5880,
        score: 4888,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_027",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-05-22T18:00:00+09:00",
        durationSeconds: 3446,
        score: 8595,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_019",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-21T22:00:00+09:00",
        durationSeconds: 2444,
        score: 1328,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_009",
        title: "【TPS】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-20T20:00:00+09:00",
        durationSeconds: 2697,
        score: 845,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_028",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-05-15T23:00:00+09:00",
        durationSeconds: 5089,
        score: 4608,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_020",
        title: "【TPS】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-14T21:00:00+09:00",
        durationSeconds: 2387,
        score: 9995,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      },
      {
        videoId: "mock_video_085_010",
        title: "【TPS】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-13T20:00:00+09:00",
        durationSeconds: 6625,
        score: 2068,
        attributes: [
          "genre_game",
          "game_tps",
        ],
      }
    ],
  },
  {
    id: "86",
    channelId: "UC_mock_086",
    name: "紅葉つむぎ",
    description: "企業勢VTuberとしてお絵描き配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V086",
    bannerUrl: "https://placehold.co/640x180?text=V086",
    youtubeUrl: "https://www.youtube.com/@example-v086",
    subscriberCount: 1757089,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_live2d", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_navy", approved: true },
      { value: "eye_black", approved: true },
      { value: "hair_length_short", approved: false },
      { value: "accessory_glasses", approved: true },
      { value: "accessory_halo", approved: true },
      { value: "voice_pitch_low", approved: false },
      { value: "voice_androgynous", approved: false },
      { value: "genre_drawing", approved: false },
      { value: "personality_cheerful", approved: true },
      // "stream_time_midnight",
      { value: "stream_frequency_rare", approved: false },
      { value: "day_tuesday", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_086_001",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T20:00:00+09:00",
        durationSeconds: 9342,
        score: 4268,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_012",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-03T22:00:00+09:00",
        durationSeconds: 7450,
        score: 4357,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_024",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-31T23:00:00+09:00",
        durationSeconds: 6210,
        score: 197,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_002",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T23:00:00+09:00",
        durationSeconds: 8897,
        score: 6114,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_013",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-27T18:00:00+09:00",
        durationSeconds: 7634,
        score: 8104,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_025",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-24T23:00:00+09:00",
        durationSeconds: 3765,
        score: 5826,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_003",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T20:00:00+09:00",
        durationSeconds: 6493,
        score: 4766,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_014",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-20T19:00:00+09:00",
        durationSeconds: 5681,
        score: 8863,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_026",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 6285,
        score: 7900,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_004",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T18:00:00+09:00",
        durationSeconds: 4454,
        score: 2940,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_015",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-13T20:00:00+09:00",
        durationSeconds: 8803,
        score: 3838,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_027",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-10T21:00:00+09:00",
        durationSeconds: 10044,
        score: 3132,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_016",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-06T22:00:00+09:00",
        durationSeconds: 5481,
        score: 9304,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_028",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-03T21:00:00+09:00",
        durationSeconds: 4154,
        score: 5759,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_005",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-30T20:00:00+09:00",
        durationSeconds: 5565,
        score: 4398,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_017",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-29T22:00:00+09:00",
        durationSeconds: 6710,
        score: 1591,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_006",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-23T18:00:00+09:00",
        durationSeconds: 6867,
        score: 4033,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_018",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-22T23:00:00+09:00",
        durationSeconds: 8926,
        score: 756,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_029",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-19T21:00:00+09:00",
        durationSeconds: 9296,
        score: 9347,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_007",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-16T20:00:00+09:00",
        durationSeconds: 6816,
        score: 5874,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_019",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-15T23:00:00+09:00",
        durationSeconds: 9700,
        score: 7542,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_030",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-12T19:00:00+09:00",
        durationSeconds: 6541,
        score: 9444,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_020",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-08T22:00:00+09:00",
        durationSeconds: 6876,
        score: 2103,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_031",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-05T20:00:00+09:00",
        durationSeconds: 8139,
        score: 7903,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-02T18:00:00+09:00",
        durationSeconds: 6452,
        score: 3962,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_021",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-01T19:00:00+09:00",
        durationSeconds: 10133,
        score: 3430,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_032",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-29T18:00:00+09:00",
        durationSeconds: 10234,
        score: 2362,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_009",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-26T22:00:00+09:00",
        durationSeconds: 8211,
        score: 4408,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_010",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-19T20:00:00+09:00",
        durationSeconds: 10486,
        score: 5671,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_022",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-18T21:00:00+09:00",
        durationSeconds: 10184,
        score: 3041,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_033",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 10801,
        score: 8636,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_011",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 4207,
        score: 2477,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_086_023",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-11T18:00:00+09:00",
        durationSeconds: 8239,
        score: 6749,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "87",
    channelId: "UC_mock_087",
    name: "朱雀シズク",
    description: "料理配信をメインに活動する個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V087",
    bannerUrl: "https://placehold.co/640x180?text=V087",
    youtubeUrl: "https://www.youtube.com/@example-v087",
    subscriberCount: 25016,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_en", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_blue", approved: true },
      { value: "eye_yellow", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_mature", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "genre_study", approved: true },
      { value: "personality_serious", approved: true },
      // "stream_time_afternoon",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_saturday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_087_001",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 2147,
        score: 9523,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_002",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-25T20:00:00+09:00",
        durationSeconds: 7547,
        score: 5464,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_087_003",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-18T22:00:00+09:00",
        durationSeconds: 2336,
        score: 7785,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_004",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-11T22:00:00+09:00",
        durationSeconds: 10103,
        score: 959,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_087_005",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-04T22:00:00+09:00",
        durationSeconds: 1653,
        score: 3629,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_006",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-27T20:00:00+09:00",
        durationSeconds: 1287,
        score: 5358,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_007",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 2341,
        score: 3233,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_008",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 1209,
        score: 3968,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_009",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-30T19:00:00+09:00",
        durationSeconds: 2410,
        score: 5874,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_010",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-23T22:00:00+09:00",
        durationSeconds: 1845,
        score: 9343,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_087_011",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 9914,
        score: 624,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "88",
    channelId: "UC_mock_088",
    name: "雫石ヨル",
    description: "お絵描き配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V088",
    bannerUrl: "https://placehold.co/640x180?text=V088",
    youtubeUrl: "https://www.youtube.com/@example-v088",
    subscriberCount: 4595,
    attributes: [
      { value: "affiliation_corporate", approved: false },
      { value: "language_zh", approved: true },
      { value: "model_png", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_white", approved: true },
      { value: "eye_black", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_cute", approved: true },
      { value: "genre_drawing", approved: false },
      { value: "genre_asmr", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_calm", approved: true },
      { value: "personality_relaxing", approved: false },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_morning",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_088_013",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-02T18:00:00+09:00",
        durationSeconds: 4949,
        score: 2592,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_002",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 5008,
        score: 2675,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_001",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T19:00:00+09:00",
        durationSeconds: 10666,
        score: 8724,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_014",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-26T23:00:00+09:00",
        durationSeconds: 2812,
        score: 7242,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_003",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T18:00:00+09:00",
        durationSeconds: 2482,
        score: 4809,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_015",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-19T21:00:00+09:00",
        durationSeconds: 2221,
        score: 3795,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_004",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T21:00:00+09:00",
        durationSeconds: 5287,
        score: 7164,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_016",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-12T22:00:00+09:00",
        durationSeconds: 10499,
        score: 9812,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_005",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-10T18:00:00+09:00",
        durationSeconds: 3423,
        score: 2473,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_017",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-05T20:00:00+09:00",
        durationSeconds: 10609,
        score: 2437,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_006",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-26T22:00:00+09:00",
        durationSeconds: 4019,
        score: 4106,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_018",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-21T22:00:00+09:00",
        durationSeconds: 10772,
        score: 1766,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_007",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-19T22:00:00+09:00",
        durationSeconds: 5135,
        score: 2263,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_019",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-14T22:00:00+09:00",
        durationSeconds: 4464,
        score: 1681,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_008",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-12T20:00:00+09:00",
        durationSeconds: 3984,
        score: 2506,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_009",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-05T21:00:00+09:00",
        durationSeconds: 4445,
        score: 9567,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_020",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-31T21:00:00+09:00",
        durationSeconds: 4369,
        score: 2946,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_010",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-29T23:00:00+09:00",
        durationSeconds: 10796,
        score: 9571,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_021",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-24T18:00:00+09:00",
        durationSeconds: 4576,
        score: 1782,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_011",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-22T18:00:00+09:00",
        durationSeconds: 3430,
        score: 8926,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_022",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-17T19:00:00+09:00",
        durationSeconds: 8738,
        score: 8944,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_088_012",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-15T23:00:00+09:00",
        durationSeconds: 2024,
        score: 3219,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_088_023",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-10T19:00:00+09:00",
        durationSeconds: 4159,
        score: 6328,
        attributes: [
          "genre_asmr",
        ],
      }
    ],
  },
  {
    id: "89",
    channelId: "UC_mock_089",
    name: "朱雀テツヤ",
    description: "個人勢VTuberとして配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V089",
    bannerUrl: "https://placehold.co/640x180?text=V089",
    youtubeUrl: "https://www.youtube.com/@example-v089",
    subscriberCount: 991,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_zh", approved: true },
      { value: "model_png", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_black", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_mature", approved: true },
      { value: "voice_cute", approved: false },
      { value: "genre_other", approved: false },
      { value: "genre_watchalong", approved: true },
      { value: "personality_funny", approved: true },
      { value: "personality_cheerful", approved: true },
      { value: "personality_energetic", approved: false },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_morning",
      { value: "stream_frequency_low", approved: true },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_089_001",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T19:00:00+09:00",
        durationSeconds: 2738,
        score: 7475,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_089_002",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T23:00:00+09:00",
        durationSeconds: 3137,
        score: 3208,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_089_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T21:00:00+09:00",
        durationSeconds: 8441,
        score: 3036,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_089_004",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T19:00:00+09:00",
        durationSeconds: 3420,
        score: 8338,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_089_005",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-30T18:00:00+09:00",
        durationSeconds: 1399,
        score: 9801,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_089_006",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-16T20:00:00+09:00",
        durationSeconds: 5462,
        score: 7592,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_089_007",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-09T19:00:00+09:00",
        durationSeconds: 973,
        score: 9107,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_089_008",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-02T18:00:00+09:00",
        durationSeconds: 4824,
        score: 2205,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_089_009",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-12T18:00:00+09:00",
        durationSeconds: 1291,
        score: 9732,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "90",
    channelId: "UC_mock_090",
    name: "花城ルナ",
    description: "お絵描き配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V090",
    bannerUrl: "https://placehold.co/640x180?text=V090",
    youtubeUrl: "https://www.youtube.com/@example-v090",
    subscriberCount: 463222,
    attributes: [
      { value: "affiliation_individual", approved: false },
      { value: "language_zh", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_multicolor", approved: false },
      { value: "eye_orange", approved: true },
      { value: "hair_length_medium", approved: false },
      { value: "accessory_glasses", approved: false },
      { value: "accessory_horns", approved: true },
      { value: "voice_pitch_low", approved: true },
      { value: "voice_powerful", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_drawing", approved: false },
      { value: "personality_chaotic", approved: true },
      { value: "personality_serious", approved: false },
      // stream_viewer_partcition,
      // stream_collab,
      // "stream_time_midnight",
      { value: "stream_frequency_low", approved: true },
      { value: "day_friday", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_090_001",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-31T23:00:00+09:00",
        durationSeconds: 4506,
        score: 6781,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_002",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-31T21:00:00+09:00",
        durationSeconds: 9465,
        score: 4480,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_014",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 9285,
        score: 3725,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_013",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-30T18:00:00+09:00",
        durationSeconds: 6592,
        score: 1301,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_003",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-24T21:00:00+09:00",
        durationSeconds: 10062,
        score: 491,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_004",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-17T19:00:00+09:00",
        durationSeconds: 7965,
        score: 9822,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_015",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-16T23:00:00+09:00",
        durationSeconds: 9157,
        score: 7143,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-10T22:00:00+09:00",
        durationSeconds: 5335,
        score: 4955,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_016",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-09T18:00:00+09:00",
        durationSeconds: 8961,
        score: 1879,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_006",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-03T20:00:00+09:00",
        durationSeconds: 9120,
        score: 5050,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_017",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-02T22:00:00+09:00",
        durationSeconds: 8811,
        score: 7157,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_007",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-26T23:00:00+09:00",
        durationSeconds: 9240,
        score: 1429,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_008",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-19T22:00:00+09:00",
        durationSeconds: 8010,
        score: 3523,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_018",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 4463,
        score: 2393,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_009",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-12T20:00:00+09:00",
        durationSeconds: 3676,
        score: 2071,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_010",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-05T21:00:00+09:00",
        durationSeconds: 4011,
        score: 2250,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_011",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-29T21:00:00+09:00",
        durationSeconds: 10653,
        score: 5957,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_019",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-28T19:00:00+09:00",
        durationSeconds: 6096,
        score: 5748,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_020",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 5485,
        score: 5558,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_012",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-15T21:00:00+09:00",
        durationSeconds: 6675,
        score: 2385,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_090_021",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-14T20:00:00+09:00",
        durationSeconds: 8090,
        score: 4869,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "91",
    channelId: "UC_mock_091",
    name: "水無月ルナ",
    description: "企業勢VTuberとして料理配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V091",
    bannerUrl: "https://placehold.co/640x180?text=V091",
    youtubeUrl: "https://www.youtube.com/@example-v091",
    subscriberCount: 51421,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_png", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_purple", approved: true },
      { value: "eye_pink", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "voice_pitch_middle", approved: false },
      { value: "voice_mature", approved: false },
      { value: "voice_cute", approved: true },
      { value: "genre_cooking", approved: false },
      { value: "genre_asmr", approved: true },
      { value: "personality_chaotic", approved: true },
      { value: "personality_energetic", approved: true },
      { value: "personality_serious", approved: true },
      // stream_viewer_partcition,
      // "stream_time_midnight",
      { value: "stream_frequency_high", approved: true },
      { value: "day_tuesday", approved: true },
      { value: "day_saturday", approved: false },
      { value: "day_wednesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_091_001",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T21:00:00+09:00",
        durationSeconds: 1929,
        score: 547,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_011",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 1967,
        score: 5188,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_012",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-08-01T18:00:00+09:00",
        durationSeconds: 2013,
        score: 6242,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_023",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-07-29T20:00:00+09:00",
        durationSeconds: 1715,
        score: 4196,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_002",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T23:00:00+09:00",
        durationSeconds: 1219,
        score: 1453,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_013",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-25T19:00:00+09:00",
        durationSeconds: 1148,
        score: 559,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_024",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-07-22T20:00:00+09:00",
        durationSeconds: 4780,
        score: 1873,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_014",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 1607,
        score: 1170,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_025",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-15T23:00:00+09:00",
        durationSeconds: 2401,
        score: 8546,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_003",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-14T22:00:00+09:00",
        durationSeconds: 3235,
        score: 8168,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_015",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-11T21:00:00+09:00",
        durationSeconds: 2182,
        score: 9640,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_026",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-08T18:00:00+09:00",
        durationSeconds: 2201,
        score: 9875,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_016",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-04T23:00:00+09:00",
        durationSeconds: 4815,
        score: 3089,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_027",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-01T23:00:00+09:00",
        durationSeconds: 2712,
        score: 7139,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_004",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-30T21:00:00+09:00",
        durationSeconds: 1133,
        score: 5205,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_017",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-27T20:00:00+09:00",
        durationSeconds: 3313,
        score: 2197,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_028",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-24T19:00:00+09:00",
        durationSeconds: 3311,
        score: 8779,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_005",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-23T19:00:00+09:00",
        durationSeconds: 2402,
        score: 7210,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_018",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-20T23:00:00+09:00",
        durationSeconds: 1793,
        score: 7356,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_029",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-17T21:00:00+09:00",
        durationSeconds: 2973,
        score: 1114,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_006",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-16T21:00:00+09:00",
        durationSeconds: 1052,
        score: 8404,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_019",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-13T19:00:00+09:00",
        durationSeconds: 3016,
        score: 8671,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_030",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-10T19:00:00+09:00",
        durationSeconds: 2403,
        score: 7759,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_007",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-09T22:00:00+09:00",
        durationSeconds: 4959,
        score: 671,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_020",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-06T22:00:00+09:00",
        durationSeconds: 4574,
        score: 3637,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_031",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-03T19:00:00+09:00",
        durationSeconds: 1824,
        score: 8023,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_008",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-02T19:00:00+09:00",
        durationSeconds: 3991,
        score: 3242,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_021",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-30T18:00:00+09:00",
        durationSeconds: 1582,
        score: 6618,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_091_032",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-27T23:00:00+09:00",
        durationSeconds: 2669,
        score: 5476,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_033",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-20T19:00:00+09:00",
        durationSeconds: 2762,
        score: 1450,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_009",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-19T23:00:00+09:00",
        durationSeconds: 3337,
        score: 6657,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_022",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-16T23:00:00+09:00",
        durationSeconds: 2643,
        score: 2679,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_034",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-05-13T22:00:00+09:00",
        durationSeconds: 4477,
        score: 5636,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_091_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-12T19:00:00+09:00",
        durationSeconds: 1154,
        score: 3162,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "92",
    channelId: "UC_mock_092",
    name: "水無月ギンガ",
    description: "個人勢VTuberとして料理配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V092",
    bannerUrl: "https://placehold.co/640x180?text=V092",
    youtubeUrl: "https://www.youtube.com/@example-v092",
    subscriberCount: 510,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_multicolor", approved: true },
      { value: "eye_heterochromia", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_mature", approved: false },
      { value: "genre_cooking", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "personality_serious", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_calm", approved: false },
      // "stream_time_morning",
      { value: "stream_frequency_rare", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_sunday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_092_002",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 3859,
        score: 6685,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_001",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 1104,
        score: 4396,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_003",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T22:00:00+09:00",
        durationSeconds: 5376,
        score: 4961,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_011",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-19T19:00:00+09:00",
        durationSeconds: 8691,
        score: 8220,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_012",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-12T19:00:00+09:00",
        durationSeconds: 1603,
        score: 543,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_013",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-05T20:00:00+09:00",
        durationSeconds: 7987,
        score: 6861,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_004",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-04T18:00:00+09:00",
        durationSeconds: 5820,
        score: 157,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_005",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-27T19:00:00+09:00",
        durationSeconds: 1337,
        score: 6980,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_014",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-21T18:00:00+09:00",
        durationSeconds: 2095,
        score: 8051,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_006",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 4902,
        score: 5758,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_015",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-14T22:00:00+09:00",
        durationSeconds: 1040,
        score: 7196,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_016",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-07T23:00:00+09:00",
        durationSeconds: 2055,
        score: 4334,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_007",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-06T18:00:00+09:00",
        durationSeconds: 1074,
        score: 1271,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_017",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-31T21:00:00+09:00",
        durationSeconds: 2008,
        score: 23,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_008",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-30T23:00:00+09:00",
        durationSeconds: 2279,
        score: 5905,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_018",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-24T18:00:00+09:00",
        durationSeconds: 7221,
        score: 3151,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_009",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-23T23:00:00+09:00",
        durationSeconds: 4989,
        score: 9501,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_092_019",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-17T22:00:00+09:00",
        durationSeconds: 1563,
        score: 7641,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_092_010",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-16T18:00:00+09:00",
        durationSeconds: 1122,
        score: 8246,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "93",
    channelId: "UC_mock_093",
    name: "銀河アマギリ",
    description: "作業配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V093",
    bannerUrl: "https://placehold.co/640x180?text=V093",
    youtubeUrl: "https://www.youtube.com/@example-v093",
    subscriberCount: 68534,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_blonde", approved: true },
      { value: "eye_black", approved: true },
      { value: "hair_length_long", approved: true },
      { value: "accessory_horns", approved: false },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_very_low", approved: false },
      { value: "voice_whisper", approved: true },
      { value: "genre_study", approved: true },
      { value: "personality_cool", approved: true },
      // "stream_time_afternoon",
      { value: "stream_frequency_middle", approved: false },
      { value: "day_tuesday", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_093_001",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-04T23:00:00+09:00",
        durationSeconds: 9922,
        score: 5890,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_026",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-08-03T21:00:00+09:00",
        durationSeconds: 5038,
        score: 9683,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_013",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 9911,
        score: 3838,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_014",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-08-01T18:00:00+09:00",
        durationSeconds: 9620,
        score: 6570,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_002",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-28T19:00:00+09:00",
        durationSeconds: 4052,
        score: 8168,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_027",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-27T19:00:00+09:00",
        durationSeconds: 5297,
        score: 3781,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_015",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-25T23:00:00+09:00",
        durationSeconds: 5155,
        score: 3114,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_003",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-21T22:00:00+09:00",
        durationSeconds: 9125,
        score: 1576,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_028",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-07-20T23:00:00+09:00",
        durationSeconds: 8752,
        score: 4596,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_016",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-18T18:00:00+09:00",
        durationSeconds: 4579,
        score: 243,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_004",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-14T21:00:00+09:00",
        durationSeconds: 4667,
        score: 8768,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_029",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-07-13T23:00:00+09:00",
        durationSeconds: 5748,
        score: 3210,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_017",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-11T23:00:00+09:00",
        durationSeconds: 4871,
        score: 391,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_005",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-07T18:00:00+09:00",
        durationSeconds: 9775,
        score: 6207,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_030",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-07-06T22:00:00+09:00",
        durationSeconds: 6599,
        score: 7160,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_018",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-07-04T18:00:00+09:00",
        durationSeconds: 4736,
        score: 2265,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_006",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-30T19:00:00+09:00",
        durationSeconds: 10032,
        score: 2073,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_031",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 5506,
        score: 9496,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_019",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-27T21:00:00+09:00",
        durationSeconds: 8698,
        score: 3608,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_032",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-06-22T22:00:00+09:00",
        durationSeconds: 4087,
        score: 4909,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_020",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 8592,
        score: 9927,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_007",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-16T18:00:00+09:00",
        durationSeconds: 6816,
        score: 1334,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_021",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-13T21:00:00+09:00",
        durationSeconds: 10264,
        score: 4204,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_008",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-09T20:00:00+09:00",
        durationSeconds: 4707,
        score: 3032,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_033",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-06-08T21:00:00+09:00",
        durationSeconds: 3681,
        score: 775,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_022",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-06-06T20:00:00+09:00",
        durationSeconds: 6010,
        score: 9192,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_009",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-02T20:00:00+09:00",
        durationSeconds: 6369,
        score: 1797,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_034",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream34",
        startedAt: "2026-06-01T23:00:00+09:00",
        durationSeconds: 5692,
        score: 6844,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_023",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-30T21:00:00+09:00",
        durationSeconds: 10102,
        score: 3671,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_010",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-26T21:00:00+09:00",
        durationSeconds: 4544,
        score: 9072,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_024",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-23T18:00:00+09:00",
        durationSeconds: 7893,
        score: 6020,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_011",
        title: "【作業】一緒に作業しませんか",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-19T21:00:00+09:00",
        durationSeconds: 7781,
        score: 7342,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_035",
        title: "【作業】資格勉強耐久",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream35",
        startedAt: "2026-05-18T18:00:00+09:00",
        durationSeconds: 8518,
        score: 9896,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_025",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-05-16T19:00:00+09:00",
        durationSeconds: 8833,
        score: 2785,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_012",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-12T22:00:00+09:00",
        durationSeconds: 9650,
        score: 7641,
        attributes: [
          "genre_study",
        ],
      },
      {
        videoId: "mock_video_093_036",
        title: "【作業】もくもく作業配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream36",
        startedAt: "2026-05-11T20:00:00+09:00",
        durationSeconds: 10333,
        score: 2933,
        attributes: [
          "genre_study",
        ],
      }
    ],
  },
  {
    id: "94",
    channelId: "UC_mock_094",
    name: "薄羽ミナヅキ",
    description: "配信をメインに活動する企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V094",
    bannerUrl: "https://placehold.co/640x180?text=V094",
    youtubeUrl: "https://www.youtube.com/@example-v094",
    subscriberCount: 479509,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_png", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_red", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_medium", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_other", approved: false },
      { value: "personality_cool", approved: true },
      { value: "personality_cheerful", approved: false },
      // "stream_time_night",
      { value: "stream_frequency_irregular", approved: false },
      { value: "day_tuesday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_094_001",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-28T20:00:00+09:00",
        durationSeconds: 2081,
        score: 4523,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_002",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-14T22:00:00+09:00",
        durationSeconds: 2282,
        score: 6095,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_003",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-07T21:00:00+09:00",
        durationSeconds: 998,
        score: 6394,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_004",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-30T22:00:00+09:00",
        durationSeconds: 3023,
        score: 1633,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_005",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-09T22:00:00+09:00",
        durationSeconds: 2710,
        score: 9384,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_006",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-02T20:00:00+09:00",
        durationSeconds: 3323,
        score: 290,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_007",
        title: "【配信】雑談枠",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-26T23:00:00+09:00",
        durationSeconds: 2914,
        score: 8031,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_008",
        title: "【配信】ゲスト回",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-19T18:00:00+09:00",
        durationSeconds: 3509,
        score: 8969,
        attributes: [
          "genre_other",
        ],
      },
      {
        videoId: "mock_video_094_009",
        title: "【配信】特別企画",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-12T23:00:00+09:00",
        durationSeconds: 2667,
        score: 8445,
        attributes: [
          "genre_other",
        ],
      }
    ],
  },
  {
    id: "95",
    channelId: "UC_mock_095",
    name: "星宮アマギリ",
    description: "個人勢VTuberとして同時視聴配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V095",
    bannerUrl: "https://placehold.co/640x180?text=V095",
    youtubeUrl: "https://www.youtube.com/@example-v095",
    subscriberCount: 66020,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: true },
      { value: "model_png", approved: false },
      { value: "model_3d", approved: true },
      { value: "hair_multicolor", approved: true },
      { value: "eye_pink", approved: true },
      { value: "hair_length_long", approved: false },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_clear", approved: true },
      { value: "genre_watchalong", approved: true },
      { value: "genre_asmr", approved: true },
      { value: "personality_cheerful", approved: true },
      // stream_collab,
      // "stream_time_midnight",
      { value: "stream_frequency_low", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_095_001",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 4079,
        score: 9382,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_010",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-07-30T22:00:00+09:00",
        durationSeconds: 2073,
        score: 4990,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_009",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 3886,
        score: 8494,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_011",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-07-16T22:00:00+09:00",
        durationSeconds: 6835,
        score: 6762,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_002",
        title: "【ASMR】リラックスタイム",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-11T18:00:00+09:00",
        durationSeconds: 3047,
        score: 3265,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_012",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-09T19:00:00+09:00",
        durationSeconds: 4273,
        score: 9259,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_003",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 4992,
        score: 139,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_013",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-02T19:00:00+09:00",
        durationSeconds: 5402,
        score: 3400,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_014",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-06-25T20:00:00+09:00",
        durationSeconds: 6727,
        score: 8017,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_004",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-20T21:00:00+09:00",
        durationSeconds: 5415,
        score: 9254,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_015",
        title: "【ASMR】寝る前のささやき",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 3892,
        score: 5039,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_005",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-13T18:00:00+09:00",
        durationSeconds: 6494,
        score: 2637,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_016",
        title: "【ASMR】囁き耳かき配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-11T23:00:00+09:00",
        durationSeconds: 4882,
        score: 3462,
        attributes: [
          "genre_asmr",
        ],
      },
      {
        videoId: "mock_video_095_006",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 7146,
        score: 4964,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_007",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-30T19:00:00+09:00",
        durationSeconds: 5027,
        score: 2246,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_017",
        title: "【同時視聴】アニメ一挙視聴",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-05-28T21:00:00+09:00",
        durationSeconds: 8358,
        score: 4426,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_018",
        title: "【同時視聴】話題の動画をみんなで",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-05-21T23:00:00+09:00",
        durationSeconds: 6932,
        score: 3332,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_008",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-16T23:00:00+09:00",
        durationSeconds: 7760,
        score: 7982,
        attributes: [
          "genre_watchalong",
        ],
      },
      {
        videoId: "mock_video_095_019",
        title: "【同時視聴】新作映画を見る",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-05-14T20:00:00+09:00",
        durationSeconds: 7494,
        score: 5247,
        attributes: [
          "genre_watchalong",
        ],
      }
    ],
  },
  {
    id: "96",
    channelId: "UC_mock_096",
    name: "夜久カエデ",
    description: "ゲーム配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V096",
    bannerUrl: "https://placehold.co/640x180?text=V096",
    youtubeUrl: "https://www.youtube.com/@example-v096",
    subscriberCount: 75863,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_yellow", approved: true },
      { value: "eye_brown", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "accessory_horns", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_high", approved: true },
      { value: "voice_husky", approved: false },
      { value: "genre_game", approved: false },
      { value: "genre_drawing", approved: true },
      { value: "game_rpg", approved: true },
      { value: "game_minecraft", approved: true },
      { value: "personality_relaxing", approved: true },
      { value: "personality_energetic", approved: true },
      // stream_long
      // stream_collab,
      // "stream_time_evening",
      { value: "stream_frequency_middle", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_096_001",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-07-27T20:00:00+09:00",
        durationSeconds: 7081,
        score: 4647,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_096_002",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 4123,
        score: 8345,
        attributes: [
          "genre_game",
          "game_rpg",
        ],
      },
      {
        videoId: "mock_video_096_003",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-06-22T22:00:00+09:00",
        durationSeconds: 10545,
        score: 4755,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_096_004",
        title: "【Minecraft】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-06-15T23:00:00+09:00",
        durationSeconds: 6532,
        score: 3940,
        attributes: [
          "genre_game",
          "game_minecraft",
        ],
      },
      {
        videoId: "mock_video_096_005",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-06-08T20:00:00+09:00",
        durationSeconds: 9339,
        score: 5858,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_096_006",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-01T18:00:00+09:00",
        durationSeconds: 9263,
        score: 8021,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_096_007",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-05-25T21:00:00+09:00",
        durationSeconds: 8197,
        score: 2163,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_096_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-05-18T20:00:00+09:00",
        durationSeconds: 5042,
        score: 3818,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_096_009",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-11T20:00:00+09:00",
        durationSeconds: 4783,
        score: 4539,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "97",
    channelId: "UC_mock_097",
    name: "薄羽テツヤ",
    description: "個人勢VTuberとして雑談配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V097",
    bannerUrl: "https://placehold.co/640x180?text=V097",
    youtubeUrl: "https://www.youtube.com/@example-v097",
    subscriberCount: 410,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ko", approved: false },
      { value: "model_live2d", approved: true },
      { value: "hair_silver", approved: true },
      { value: "eye_black", approved: true },
      { value: "hair_length_very_long", approved: true },
      { value: "voice_pitch_middle", approved: true },
      { value: "voice_whisper", approved: true },
      { value: "genre_talk", approved: true },
      { value: "talk_casual", approved: true },
      { value: "personality_cool", approved: true },
      { value: "personality_gentle", approved: false },
      // stream_long
      // "stream_time_midnight",
      { value: "stream_frequency_high", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_thursday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_097_001",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T22:00:00+09:00",
        durationSeconds: 3879,
        score: 5905,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_002",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T20:00:00+09:00",
        durationSeconds: 3036,
        score: 825,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_012",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-30T21:00:00+09:00",
        durationSeconds: 3999,
        score: 1889,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_003",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-18T22:00:00+09:00",
        durationSeconds: 4197,
        score: 2039,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_013",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-16T20:00:00+09:00",
        durationSeconds: 4543,
        score: 7715,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_004",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-11T23:00:00+09:00",
        durationSeconds: 2119,
        score: 2712,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_014",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-09T23:00:00+09:00",
        durationSeconds: 4957,
        score: 7338,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_005",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 4439,
        score: 6465,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_015",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-02T21:00:00+09:00",
        durationSeconds: 3264,
        score: 4103,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_006",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-27T23:00:00+09:00",
        durationSeconds: 4199,
        score: 691,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_016",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-06-25T22:00:00+09:00",
        durationSeconds: 5138,
        score: 6762,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_007",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-20T23:00:00+09:00",
        durationSeconds: 4072,
        score: 6227,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_017",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-18T18:00:00+09:00",
        durationSeconds: 3028,
        score: 5731,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_018",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-11T23:00:00+09:00",
        durationSeconds: 3624,
        score: 9063,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_008",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-06T23:00:00+09:00",
        durationSeconds: 4240,
        score: 7713,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_019",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-04T23:00:00+09:00",
        durationSeconds: 4621,
        score: 9867,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_009",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-05-30T18:00:00+09:00",
        durationSeconds: 2006,
        score: 6192,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_020",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-28T19:00:00+09:00",
        durationSeconds: 3987,
        score: 1754,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_010",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-23T20:00:00+09:00",
        durationSeconds: 2448,
        score: 243,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_021",
        title: "【雑談】深夜にちょっとだけ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-21T20:00:00+09:00",
        durationSeconds: 2475,
        score: 9225,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_011",
        title: "【雑談】最近あったことをだらだら話す",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-16T23:00:00+09:00",
        durationSeconds: 4022,
        score: 2,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      },
      {
        videoId: "mock_video_097_022",
        title: "【雑談】視聴者質問コーナー",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-14T22:00:00+09:00",
        durationSeconds: 4063,
        score: 7702,
        attributes: [
          "genre_talk",
          "talk_casual",
        ],
      }
    ],
  },
  {
    id: "98",
    channelId: "UC_mock_098",
    name: "雷電みかん",
    description: "料理配信が得意な個人勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V098",
    bannerUrl: "https://placehold.co/640x180?text=V098",
    youtubeUrl: "https://www.youtube.com/@example-v098",
    subscriberCount: 349512,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "model_png", approved: true },
      { value: "hair_white", approved: true },
      { value: "eye_light_blue", approved: true },
      { value: "hair_length_very_short", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "accessory_headphones", approved: true },
      { value: "voice_pitch_high", approved: false },
      { value: "voice_boyish", approved: true },
      { value: "genre_cooking", approved: true },
      { value: "genre_singing", approved: true },
      { value: "personality_chaotic", approved: true },
      { value: "personality_calm", approved: true },
      // stream_collab,
      // "stream_time_midnight",
      { value: "stream_frequency_daily", approved: true },
      { value: "day_saturday", approved: true },
      { value: "day_wednesday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_098_013",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-08-05T19:00:00+09:00",
        durationSeconds: 1680,
        score: 515,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_001",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-01T23:00:00+09:00",
        durationSeconds: 2985,
        score: 9791,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_002",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-08-01T21:00:00+09:00",
        durationSeconds: 1509,
        score: 7107,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_025",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream25",
        startedAt: "2026-07-31T18:00:00+09:00",
        durationSeconds: 2261,
        score: 8944,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_014",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-29T18:00:00+09:00",
        durationSeconds: 2481,
        score: 3745,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_003",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-25T22:00:00+09:00",
        durationSeconds: 2650,
        score: 406,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_015",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-22T20:00:00+09:00",
        durationSeconds: 998,
        score: 6765,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_004",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-18T20:00:00+09:00",
        durationSeconds: 2121,
        score: 4321,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_026",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream26",
        startedAt: "2026-07-17T20:00:00+09:00",
        durationSeconds: 1318,
        score: 6566,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_016",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-15T19:00:00+09:00",
        durationSeconds: 2152,
        score: 657,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_005",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-11T18:00:00+09:00",
        durationSeconds: 1037,
        score: 5005,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_027",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream27",
        startedAt: "2026-07-10T21:00:00+09:00",
        durationSeconds: 3629,
        score: 4231,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_017",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-07-08T23:00:00+09:00",
        durationSeconds: 2276,
        score: 803,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_006",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-07-04T19:00:00+09:00",
        durationSeconds: 3323,
        score: 7794,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_018",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-07-01T23:00:00+09:00",
        durationSeconds: 2637,
        score: 8909,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_007",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-27T22:00:00+09:00",
        durationSeconds: 1916,
        score: 1536,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_028",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream28",
        startedAt: "2026-06-26T21:00:00+09:00",
        durationSeconds: 1696,
        score: 393,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_019",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-24T23:00:00+09:00",
        durationSeconds: 2060,
        score: 5211,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_008",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-20T18:00:00+09:00",
        durationSeconds: 3617,
        score: 7250,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_029",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream29",
        startedAt: "2026-06-19T20:00:00+09:00",
        durationSeconds: 1087,
        score: 1315,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_009",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-13T23:00:00+09:00",
        durationSeconds: 2083,
        score: 8099,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_030",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream30",
        startedAt: "2026-06-12T21:00:00+09:00",
        durationSeconds: 1792,
        score: 3198,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_020",
        title: "【歌枠】リクエスト曲を歌う夜",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-06-10T21:00:00+09:00",
        durationSeconds: 2356,
        score: 8039,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_031",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream31",
        startedAt: "2026-06-05T18:00:00+09:00",
        durationSeconds: 1688,
        score: 179,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_021",
        title: "【歌枠】新曲カバー配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-06-03T18:00:00+09:00",
        durationSeconds: 3464,
        score: 1891,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_010",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-05-30T20:00:00+09:00",
        durationSeconds: 1743,
        score: 4990,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_032",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream32",
        startedAt: "2026-05-29T21:00:00+09:00",
        durationSeconds: 3409,
        score: 4619,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_022",
        title: "【料理】視聴者さんのおすすめ料理",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream22",
        startedAt: "2026-05-27T21:00:00+09:00",
        durationSeconds: 1478,
        score: 2560,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_011",
        title: "【料理】初めての料理配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-23T23:00:00+09:00",
        durationSeconds: 1519,
        score: 1420,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_023",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream23",
        startedAt: "2026-05-20T20:00:00+09:00",
        durationSeconds: 1138,
        score: 1386,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_012",
        title: "【歌枠】深夜の弾き語り",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-16T19:00:00+09:00",
        durationSeconds: 1207,
        score: 4086,
        attributes: [
          "genre_singing",
        ],
      },
      {
        videoId: "mock_video_098_033",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream33",
        startedAt: "2026-05-15T20:00:00+09:00",
        durationSeconds: 2409,
        score: 8132,
        attributes: [
          "genre_cooking",
        ],
      },
      {
        videoId: "mock_video_098_024",
        title: "【料理】簡単レシピに挑戦",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream24",
        startedAt: "2026-05-13T22:00:00+09:00",
        durationSeconds: 2196,
        score: 9964,
        attributes: [
          "genre_cooking",
        ],
      }
    ],
  },
  {
    id: "99",
    channelId: "UC_mock_099",
    name: "風間カザマ",
    description: "お絵描き配信が得意な企業勢VTuber。",
    iconUrl: "https://placehold.co/120x120?text=V099",
    bannerUrl: "https://placehold.co/640x180?text=V099",
    youtubeUrl: "https://www.youtube.com/@example-v099",
    subscriberCount: 5996,
    attributes: [
      { value: "affiliation_corporate", approved: true },
      { value: "language_ja", approved: true },
      { value: "model_3d", approved: true },
      { value: "hair_pink", approved: false },
      { value: "eye_purple", approved: true },
      { value: "hair_length_short", approved: true },
      { value: "accessory_hat", approved: true },
      { value: "voice_pitch_very_high", approved: true },
      { value: "voice_androgynous", approved: true },
      { value: "voice_boyish", approved: false },
      { value: "genre_drawing", approved: true },
      { value: "personality_gentle", approved: true },
      { value: "personality_relaxing", approved: true },
      // "stream_time_night",
      { value: "stream_frequency_high", approved: true },
      { value: "day_monday", approved: true },
      { value: "day_friday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_099_001",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T23:00:00+09:00",
        durationSeconds: 5895,
        score: 5990,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_012",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-07-31T20:00:00+09:00",
        durationSeconds: 7759,
        score: 4232,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_002",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T22:00:00+09:00",
        durationSeconds: 3734,
        score: 4429,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_013",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-07-24T23:00:00+09:00",
        durationSeconds: 9448,
        score: 9106,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_003",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T22:00:00+09:00",
        durationSeconds: 7614,
        score: 1228,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_014",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream14",
        startedAt: "2026-07-17T21:00:00+09:00",
        durationSeconds: 8917,
        score: 2674,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_004",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T20:00:00+09:00",
        durationSeconds: 10283,
        score: 7882,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_015",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream15",
        startedAt: "2026-07-10T23:00:00+09:00",
        durationSeconds: 5979,
        score: 4286,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_005",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T18:00:00+09:00",
        durationSeconds: 5691,
        score: 1909,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_016",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream16",
        startedAt: "2026-07-03T18:00:00+09:00",
        durationSeconds: 7753,
        score: 4330,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_006",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 6917,
        score: 8921,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_007",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T18:00:00+09:00",
        durationSeconds: 10255,
        score: 856,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_017",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream17",
        startedAt: "2026-06-19T18:00:00+09:00",
        durationSeconds: 8794,
        score: 3707,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_008",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T20:00:00+09:00",
        durationSeconds: 4893,
        score: 2144,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_018",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream18",
        startedAt: "2026-06-12T19:00:00+09:00",
        durationSeconds: 5974,
        score: 6322,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_009",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-08T21:00:00+09:00",
        durationSeconds: 6872,
        score: 2941,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_019",
        title: "【お絵描き】新しいアバター衣装ラフ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream19",
        startedAt: "2026-06-05T20:00:00+09:00",
        durationSeconds: 4350,
        score: 5337,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_010",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-01T21:00:00+09:00",
        durationSeconds: 4722,
        score: 5356,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_020",
        title: "【お絵描き】模写チャレンジ",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream20",
        startedAt: "2026-05-22T23:00:00+09:00",
        durationSeconds: 9257,
        score: 2211,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_021",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream21",
        startedAt: "2026-05-15T22:00:00+09:00",
        durationSeconds: 5553,
        score: 7402,
        attributes: [
          "genre_drawing",
        ],
      },
      {
        videoId: "mock_video_099_011",
        title: "【お絵描き】リクエストイラスト配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-11T21:00:00+09:00",
        durationSeconds: 9402,
        score: 43,
        attributes: [
          "genre_drawing",
        ],
      }
    ],
  },
  {
    id: "100",
    channelId: "UC_mock_100",
    name: "花城ウスバ",
    description: "個人勢VTuberとしてゲーム配信を中心に活動中。",
    iconUrl: "https://placehold.co/120x120?text=V100",
    bannerUrl: "https://placehold.co/640x180?text=V100",
    youtubeUrl: "https://www.youtube.com/@example-v100",
    subscriberCount: 6827,
    attributes: [
      { value: "affiliation_individual", approved: true },
      { value: "language_zh", approved: true },
      { value: "model_png", approved: true },
      { value: "model_live2d", approved: true },
      { value: "hair_gray", approved: true },
      { value: "eye_green", approved: true },
      { value: "hair_length_very_long", approved: false },
      { value: "accessory_tail", approved: true },
      { value: "voice_pitch_very_low", approved: true },
      { value: "voice_mature", approved: false },
      { value: "voice_cute", approved: true },
      { value: "genre_game", approved: false },
      { value: "game_racing", approved: true },
      { value: "personality_energetic", approved: true },
      // stream_viewer_partcition,
      // "stream_time_midnight",
      { value: "stream_frequency_irregular", approved: true },
      { value: "day_monday", approved: true },
    ],
    videos: [
      {
        videoId: "mock_video_100_001",
        title: "【レースゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream1",
        startedAt: "2026-08-03T18:00:00+09:00",
        durationSeconds: 6187,
        score: 6346,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_002",
        title: "【レースゲーム】ランクマ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream2",
        startedAt: "2026-07-27T22:00:00+09:00",
        durationSeconds: 7218,
        score: 9965,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_003",
        title: "【レースゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream3",
        startedAt: "2026-07-20T23:00:00+09:00",
        durationSeconds: 5048,
        score: 2960,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_004",
        title: "【レースゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream4",
        startedAt: "2026-07-13T22:00:00+09:00",
        durationSeconds: 5981,
        score: 2165,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_005",
        title: "【レースゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream5",
        startedAt: "2026-07-06T20:00:00+09:00",
        durationSeconds: 5020,
        score: 8941,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_006",
        title: "【レースゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream6",
        startedAt: "2026-06-29T23:00:00+09:00",
        durationSeconds: 6015,
        score: 7427,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_007",
        title: "【レースゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream7",
        startedAt: "2026-06-22T20:00:00+09:00",
        durationSeconds: 6339,
        score: 8656,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_008",
        title: "【レースゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream8",
        startedAt: "2026-06-15T20:00:00+09:00",
        durationSeconds: 1916,
        score: 1137,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_009",
        title: "【レースゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream9",
        startedAt: "2026-06-08T23:00:00+09:00",
        durationSeconds: 4509,
        score: 1663,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_010",
        title: "【レースゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream10",
        startedAt: "2026-06-01T18:00:00+09:00",
        durationSeconds: 7175,
        score: 8021,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_011",
        title: "【レースゲーム】新作を初見プレイ！",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream11",
        startedAt: "2026-05-25T20:00:00+09:00",
        durationSeconds: 6333,
        score: 7618,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_012",
        title: "【レースゲーム】実況しながらまったり",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream12",
        startedAt: "2026-05-18T23:00:00+09:00",
        durationSeconds: 2038,
        score: 8337,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      },
      {
        videoId: "mock_video_100_013",
        title: "【レースゲーム】耐久プレイ配信",
        thumbnailUrl: "https://placehold.co/320x180?text=Stream13",
        startedAt: "2026-05-11T18:00:00+09:00",
        durationSeconds: 6645,
        score: 7004,
        attributes: [
          "genre_game",
          "game_racing",
        ],
      }
    ],
  },
];

export const GENRE_OPTIONS = [
  { value: "genre_game", label: "ゲーム" },
  { value: "genre_singing", label: "歌" },
  { value: "genre_talk", label: "雑談" },
  { value: "genre_asmr", label: "ASMR" },
  { value: "genre_drawing", label: "お絵描き" },
  { value: "genre_study", label: "勉強・作業" },
  { value: "genre_cooking", label: "料理" },
  { value: "genre_watchalong", label: "同時視聴" },
  { value: "genre_other", label: "その他（ジャンル）" },
];

export const DAY_OPTIONS = [
  { value: "day_monday", label: "月曜" },
  { value: "day_tuesday", label: "火曜" },
  { value: "day_wednesday", label: "水曜" },
  { value: "day_thursday", label: "木曜" },
  { value: "day_friday", label: "金曜" },
  { value: "day_saturday", label: "土曜" },
  { value: "day_sunday", label: "日曜" },
];

export const AFFILIATION_OPTIONS = [
  { value: "affiliation_individual", label: "個人勢" },
  { value: "affiliation_corporate", label: "企業勢" },
];

export const HAIR_COLOR_OPTIONS = [
  { value: "hair_black", label: "黒（髪）" },
  { value: "hair_white", label: "白（髪）" },
  { value: "hair_gray", label: "グレー（髪）" },
  { value: "hair_silver", label: "銀（髪）" },
  { value: "hair_brown", label: "茶（髪）" },
  { value: "hair_blonde", label: "金（髪）" },
  { value: "hair_red", label: "赤（髪）" },
  { value: "hair_orange", label: "オレンジ（髪）" },
  { value: "hair_yellow", label: "黄（髪）" },
  { value: "hair_green", label: "緑（髪）" },
  { value: "hair_light_green", label: "黄緑（髪）" },
  { value: "hair_blue", label: "青（髪）" },
  { value: "hair_light_blue", label: "水色（髪）" },
  { value: "hair_navy", label: "紺（髪）" },
  { value: "hair_purple", label: "紫（髪）" },
  { value: "hair_pink", label: "ピンク（髪）" },
  { value: "hair_multicolor", label: "複数色（髪）" },
  { value: "hair_other", label: "その他（髪）" },
];

export const EYE_COLOR_OPTIONS = [
  { value: "eye_black", label: "黒（瞳）" },
  { value: "eye_brown", label: "茶（瞳）" },
  { value: "eye_red", label: "赤（瞳）" },
  { value: "eye_orange", label: "オレンジ（瞳）" },
  { value: "eye_yellow", label: "黄（瞳）" },
  { value: "eye_green", label: "緑（瞳）" },
  { value: "eye_blue", label: "青（瞳）" },
  { value: "eye_light_blue", label: "水色（瞳）" },
  { value: "eye_purple", label: "紫（瞳）" },
  { value: "eye_pink", label: "ピンク（瞳）" },
  { value: "eye_heterochromia", label: "オッドアイ（瞳）" },
  { value: "eye_other", label: "その他（瞳）" },
];

export const HAIR_LENGTH_OPTIONS = [
  { value: "hair_length_very_short", label: "ベリーショート" },
  { value: "hair_length_short", label: "ショート" },
  { value: "hair_length_medium", label: "ミディアム" },
  { value: "hair_length_long", label: "ロング" },
  { value: "hair_length_very_long", label: "スーパーロング" },
];

export const ACCESSORY_OPTIONS = [
  { value: "accessory_glasses", label: "メガネ" },
  { value: "accessory_animal_ears", label: "ケモ耳" },
  { value: "accessory_horns", label: "角" },
  { value: "accessory_halo", label: "天使の輪" },
  { value: "accessory_wings", label: "羽" },
  { value: "accessory_tail", label: "しっぽ" },
  { value: "accessory_hat", label: "帽子" },
  { value: "accessory_headphones", label: "ヘッドホン" },
];

export const VOICE_PITCH_OPTIONS = [
  { value: "voice_pitch_very_high", label: "かなり高め" },
  { value: "voice_pitch_high", label: "高め" },
  { value: "voice_pitch_middle", label: "中音" },
  { value: "voice_pitch_low", label: "低め" },
  { value: "voice_pitch_very_low", label: "かなり低め" },
];

export const VOICE_CHARACTER_OPTIONS = [
  { value: "voice_clear", label: "透明感" },
  { value: "voice_cute", label: "かわいい" },
  { value: "voice_cool", label: "クール（声）" },
  { value: "voice_soft", label: "やわらかい" },
  { value: "voice_powerful", label: "力強い" },
  { value: "voice_husky", label: "ハスキー" },
  { value: "voice_whisper", label: "ウィスパー" },
  { value: "voice_mature", label: "大人っぽい" },
  { value: "voice_boyish", label: "少年声" },
  { value: "voice_androgynous", label: "中性的" },
];

export const GAME_GENRE_OPTIONS = [
  { value: "game_fps", label: "FPS" },
  { value: "game_tps", label: "TPS" },
  { value: "game_horror", label: "ホラー" },
  { value: "game_rpg", label: "RPG" },
  { value: "game_action", label: "アクション" },
  { value: "game_fighting", label: "格闘ゲーム" },
  { value: "game_racing", label: "レース" },
  { value: "game_simulation", label: "シミュレーション" },
  { value: "game_puzzle", label: "パズル" },
  { value: "game_rhythm", label: "音ゲー" },
  { value: "game_retro", label: "レトロゲーム" },
  { value: "game_indie", label: "インディーゲーム" },
  { value: "game_minecraft", label: "Minecraft" },
];


export const TALK_STYLE_OPTIONS = [
  { value: "talk_casual", label: "まったり雑談" },
  { value: "talk_radio", label: "ラジオ系" },
  { value: "talk_drinking", label: "晩酌" },
  { value: "talk_consultation", label: "相談・お悩み" },
  { value: "talk_topic", label: "テーマトーク" },
];

export const PERSONALITY_OPTIONS = [
  { value: "personality_calm", label: "落ち着いている" },
  { value: "personality_relaxing", label: "癒し系" },
  { value: "personality_energetic", label: "元気" },
  { value: "personality_cheerful", label: "明るい" },
  { value: "personality_cool", label: "クール（性格）" },
  { value: "personality_funny", label: "面白い" },
  { value: "personality_chaotic", label: "カオス" },
  { value: "personality_natural", label: "天然" },
  { value: "personality_serious", label: "真面目" },
  { value: "personality_gentle", label: "穏やか" },
];

export const STREAM_STYLE_OPTIONS = [
  { value: "stream_viewer_partcition", label: "視聴者参加型" },
  { value: "stream_collab", label: "コラボ多め" },
  { value: "stream_long", label: "長時間配信" },

];

export const STREAM_TIME_OPTIONS = [
  { value: "stream_time_early_morning", label: "早朝（5〜8時）" },
  { value: "stream_time_morning", label: "朝（8〜12時）" },
  { value: "stream_time_afternoon", label: "昼（12〜17時）" },
  { value: "stream_time_evening", label: "夕方（17〜20時）" },
  { value: "stream_time_night", label: "夜（20〜24時）" },
  { value: "stream_time_midnight", label: "深夜（0〜5時）" },
];

export const STREAM_FREQUENCY_OPTIONS = [
  { value: "stream_frequency_daily", label: "ほぼ毎日" },
  { value: "stream_frequency_high", label: "週4〜6回" },
  { value: "stream_frequency_middle", label: "週2〜3回" },
  { value: "stream_frequency_low", label: "週1回程度" },
  { value: "stream_frequency_rare", label: "月数回" },
  { value: "stream_frequency_irregular", label: "不定期" },
];

export const LANGUAGE_OPTIONS = [
  { value: "language_ja", label: "日本語" },
  { value: "language_en", label: "英語" },
  { value: "language_ko", label: "韓国語" },
  { value: "language_zh", label: "中国語" },
  { value: "language_other", label: "その他（言語）" },
];

export const MODEL_OPTIONS = [
  { value: "model_live2d", label: "Live2D" },
  { value: "model_3d", label: "3D" },
  { value: "model_png", label: "PNG・静止画" },
  { value: "model_other", label: "その他（モデル）" },
];

export const SUBSCRIBER_OPTIONS = [
  { value: "subscriber_under_1k", label: "1,000人未満" },
  { value: "subscriber_1k_5k", label: "1,000〜5,000人" },
  { value: "subscriber_5k_10k", label: "5,000〜1万人" },
  { value: "subscriber_10k_50k", label: "1万〜5万人" },
  { value: "subscriber_50k_100k", label: "5万〜10万人" },
  { value: "subscriber_100k_500k", label: "10万〜50万人" },
  { value: "subscriber_500k_1m", label: "50万〜100万人" },
  { value: "subscriber_1m_plus", label: "100万人以上" },
];

const ATTRIBUTE_OPTION_LISTS = [
  GENRE_OPTIONS,
  DAY_OPTIONS,
  AFFILIATION_OPTIONS,
  HAIR_COLOR_OPTIONS,
  EYE_COLOR_OPTIONS,
  HAIR_LENGTH_OPTIONS,
  ACCESSORY_OPTIONS,
  VOICE_PITCH_OPTIONS,
  VOICE_CHARACTER_OPTIONS,
  GAME_GENRE_OPTIONS,
  TALK_STYLE_OPTIONS,
  PERSONALITY_OPTIONS,
  STREAM_STYLE_OPTIONS,
  STREAM_TIME_OPTIONS,
  STREAM_FREQUENCY_OPTIONS,
  LANGUAGE_OPTIONS,
  MODEL_OPTIONS,
];

export const ATTRIBUTE_LABELS = ATTRIBUTE_OPTION_LISTS.reduce(
  (labels, options) => {
    options.forEach(({ value, label }) => {
      labels[value] = label;
    });
    return labels;
  },
  {},
);
